(() => {
  const STORAGE_KEY = 'lp-theme';
  const root = document.documentElement;

  const systemTheme = window.matchMedia(
    '(prefers-color-scheme: dark)'
  );

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  let transitionRunning = false;


  const getTheme = () => {
    return root.dataset.theme || 'light';
  };


  const updateButtons = (theme) => {
    document
      .querySelectorAll('[data-theme-toggle]')
      .forEach((button) => {
        const isDark = theme === 'dark';

        button.setAttribute(
          'aria-pressed',
          isDark ? 'true' : 'false'
        );

        button.dataset.themeCurrent = theme;
      });
  };


  const setTheme = (
    theme,
    save = true
  ) => {
    if (
      theme !== 'light' &&
      theme !== 'dark'
    ) {
      return;
    }

    root.dataset.theme = theme;
    root.style.colorScheme = theme;

    updateButtons(theme);

    if (save) {
      try {
        localStorage.setItem(
          STORAGE_KEY,
          theme
        );
      } catch (error) { }
    }
  };


  const canUseCircularTransition = () => {
    if (
      typeof document.startViewTransition !==
      'function'
    ) {
      return false;
    }

    if (reducedMotion.matches) {
      return false;
    }

    /*
      Keep the expensive circular transition
      only for larger standard-density desktops.

      Retina MacBooks / high-DPR screens and
      laptop-sized screens get the lightweight path.
    */
    const isLargeDesktop =
      window.innerWidth >= 1440 &&
      window.innerHeight >= 700;

    const isStandardDensity =
      window.devicePixelRatio <= 1.5;

    return (
      isLargeDesktop &&
      isStandardDensity
    );
  };


  const lightweightSwitch = (
    nextTheme
  ) => {
    root.classList.add(
      'lp-theme-switching'
    );

    setTheme(nextTheme);

    window.setTimeout(() => {
      root.classList.remove(
        'lp-theme-switching'
      );
    }, 180);
  };


  const circularSwitch = (
    nextTheme,
    toggle
  ) => {
    if (transitionRunning) {
      return;
    }

    transitionRunning = true;

    const rect =
      toggle?.getBoundingClientRect();

    /*
      Start from actual toggle instead of
      forcing top-right corner.
    */
    const x = rect
      ? rect.left + rect.width / 2
      : window.innerWidth;

    const y = rect
      ? rect.top + rect.height / 2
      : 0;

    const radius = Math.hypot(
      Math.max(
        x,
        window.innerWidth - x
      ),
      Math.max(
        y,
        window.innerHeight - y
      )
    );

    const transition =
      document.startViewTransition(
        () => {
          setTheme(nextTheme);
        }
      );


    transition.ready
      .then(() => {
        const animation =
          root.animate(
            {
              clipPath: [
                `circle(0px at ${x}px ${y}px)`,
                `circle(${radius}px at ${x}px ${y}px)`
              ]
            },
            {
              duration: 420,

              easing:
                'cubic-bezier(.16, 1, .3, 1)',

              pseudoElement:
                '::view-transition-new(root)'
            }
          );

        animation.finished
          .catch(() => { })
          .finally(() => {
            transitionRunning = false;
          });
      })
      .catch(() => {
        transitionRunning = false;
      });


    transition.finished
      .catch(() => { })
      .finally(() => {
        transitionRunning = false;
      });
  };


  const toggleTheme = (
    toggle
  ) => {
    if (transitionRunning) {
      return;
    }

    const nextTheme =
      getTheme() === 'dark'
        ? 'light'
        : 'dark';


    if (
      !canUseCircularTransition()
    ) {
      lightweightSwitch(nextTheme);
      return;
    }


    circularSwitch(
      nextTheme,
      toggle
    );
  };


  document.addEventListener(
    'click',
    (event) => {
      const toggle =
        event.target.closest(
          '[data-theme-toggle]'
        );

      if (!toggle) return;

      toggleTheme(toggle);
    }
  );


  const handleSystemThemeChange = (
    event
  ) => {
    try {
      if (
        localStorage.getItem(
          STORAGE_KEY
        )
      ) {
        return;
      }
    } catch (error) {
      return;
    }

    setTheme(
      event.matches
        ? 'dark'
        : 'light',
      false
    );
  };


  systemTheme.addEventListener(
    'change',
    handleSystemThemeChange
  );


  updateButtons(
    getTheme()
  );
})();

















(() => {
  const menuToggle = document.querySelector('[data-lp-menu-toggle]');
  const mobileDrawer = document.querySelector('[data-lp-mobile-drawer]');
  const menuBackdrop = document.querySelector('[data-lp-menu-backdrop]');

  if (!menuToggle || !mobileDrawer) return;

  const isOpen = () => mobileDrawer.classList.contains('is-open');

  const openDrawer = () => {
    mobileDrawer.classList.add('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'false');

    menuToggle.setAttribute('aria-expanded', 'true');
    menuToggle.setAttribute('aria-label', 'Close menu');

    document.documentElement.classList.add('lp-drawer-open');
  };

  const closeDrawer = () => {
    mobileDrawer.classList.remove('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'true');

    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-label', 'Open menu');

    document.documentElement.classList.remove('lp-drawer-open');
  };

  menuToggle.addEventListener('click', () => {
    isOpen() ? closeDrawer() : openDrawer();
  });

  menuBackdrop?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) {
      closeDrawer();
      menuToggle.focus();
    }
  });
})();





(() => {
  const header = document.querySelector('[data-lp-header]');

  if (!header || !header.classList.contains('lp-header--scroll_up')) return;

  const section = header.closest('.shopify-section');

  if (!section) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  section.classList.toggle('is-stuck', window.scrollY > 8);


  const updateHeader = () => {
    const currentScrollY = window.scrollY;

    section.classList.toggle('is-stuck', currentScrollY > 8);

    if (currentScrollY <= 20) {
      section.classList.remove('is-hidden');
    } else if (currentScrollY > lastScrollY) {
      section.classList.add('is-hidden');
    } else {
      section.classList.remove('is-hidden');
    }

    lastScrollY = Math.max(currentScrollY, 0);
    ticking = false;
  };


  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;

      requestAnimationFrame(updateHeader);
      ticking = true;
    },
    { passive: true }
  );
})();










(() => {
  const initTextRoll = (root = document) => {
    const elements = root.querySelectorAll(
      '[data-text-roll]:not([data-text-roll-ready="true"])'
    );

    elements.forEach((element) => {
      if (
        window.matchMedia('(hover: none)').matches &&
        element.closest('.lp-mobile-drawer')
      ) {
        return;
      }

      const text = element.textContent.trim();

      if (!text) return;

      element.dataset.textRollReady = 'true';
      element.setAttribute('aria-label', text);

      const wrapper = document.createElement('span');

      wrapper.className = 'lp-text-roll';
      wrapper.setAttribute('aria-hidden', 'true');

      [...text].forEach((character, index) => {
        const char = document.createElement('span');

        char.className = 'lp-text-roll__char';
        char.style.setProperty('--char-index', index);

        const current = document.createElement('span');
        const next = document.createElement('span');

        current.className = 'lp-text-roll__current';
        next.className = 'lp-text-roll__next';

        const value = character === ' ' ? '\u00A0' : character;

        current.textContent = value;
        next.textContent = value;

        char.append(current, next);
        wrapper.appendChild(char);
      });

      element.textContent = '';
      element.appendChild(wrapper);
    });
  };

  initTextRoll();

  document.addEventListener('shopify:section:load', (event) => {
    initTextRoll(event.target);
  });
})();













(() => {
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-lp-submenu-toggle]');

    if (!toggle) return;

    const item = toggle.closest('[data-lp-submenu-item]');

    if (!item) return;

    const isOpen = item.classList.contains('is-open');

    item.classList.toggle('is-open', !isOpen);

    toggle.setAttribute(
      'aria-expanded',
      isOpen ? 'false' : 'true'
    );
  });
})();





(() => {
  const loadVideo = (wrapper) => {
    if (wrapper.dataset.videoLoaded === 'true') return;

    const video = wrapper.querySelector('[data-lp-video-element]');
    const src = wrapper.dataset.videoSrc;

    if (!video || !src) return;

    wrapper.dataset.videoLoaded = 'true';

    video.src = src;
    video.load();

    const ready = async () => {
      wrapper.classList.add('is-loaded');

      try {
        await video.play();
      } catch (error) { }
    };

    if (video.readyState >= 3) {
      ready();
    } else {
      video.addEventListener('canplay', ready, { once: true });
    }
  };

  const scheduleVideo = (wrapper) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(
        () => loadVideo(wrapper),
        { timeout: 1400 }
      );
    } else {
      setTimeout(() => loadVideo(wrapper), 800);
    }
  };

  document
    .querySelectorAll('[data-lp-lazy-video]')
    .forEach((wrapper) => {
      const poster = wrapper.querySelector('.lp-hero__video-poster');

      if (poster) {
        const posterReady = () => {
          wrapper.classList.add('is-poster-loaded');
        };

        if (poster.complete) {
          posterReady();
        } else {
          poster.addEventListener('load', posterReady, { once: true });
        }
      }

      scheduleVideo(wrapper);
    });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lp-video-mute]');

    if (!button) return;

    const wrapper = button.closest('[data-lp-lazy-video]');
    const video = wrapper?.querySelector('[data-lp-video-element]');

    if (!video) return;

    video.muted = !video.muted;

    const unmuted = !video.muted;

    button.classList.toggle('is-unmuted', unmuted);
    button.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      unmuted ? 'Mute video' : 'Unmute video'
    );
  });
})();










































(() => {
  const updateDrawerTop = () => {
    const header = document.querySelector('[data-lp-header]');
    const drawer = document.querySelector('[data-lp-mobile-drawer]');

    if (!header || !drawer) return;

    const section = header.closest('.shopify-section');
    const headerBottom = Math.max(
      header.getBoundingClientRect().bottom,
      0
    );

    const sectionTop =
      header.classList.contains('lp-header--scroll_up') && section
        ? section.getBoundingClientRect().top
        : 0;

    const drawerTop = Math.max(
      headerBottom - sectionTop,
      0
    );

    document.documentElement.style.setProperty(
      '--lp-drawer-top',
      `${drawerTop}px`
    );

    document.documentElement.style.setProperty(
      '--lp-drawer-viewport-bottom',
      `${headerBottom}px`
    );
  };

  updateDrawerTop();

  window.addEventListener('resize', updateDrawerTop, { passive: true });
  window.addEventListener('scroll', updateDrawerTop, { passive: true });

  document.addEventListener('shopify:section:load', updateDrawerTop);
})();







(() => {
  const initAnnouncementBars = (root = document) => {
    const bars = root.querySelectorAll(
      '[data-lp-announcement]:not([data-announcement-ready="true"])'
    );

    bars.forEach((bar) => {
      const slides = [
        ...bar.querySelectorAll('[data-lp-announcement-slide]')
      ];

      if (!slides.length) return;

      bar.dataset.announcementReady = 'true';

      if (slides.length === 1) return;

      const autoplay = bar.dataset.autoplay === 'true';
      const speed = Number(bar.dataset.speed) || 5000;

      let currentIndex = 0;
      let timer = null;

      const showSlide = (nextIndex) => {
        slides.forEach((slide, index) => {
          const active = index === nextIndex;

          slide.classList.toggle('is-active', active);

          slide.setAttribute(
            'aria-hidden',
            active ? 'false' : 'true'
          );
        });

        currentIndex = nextIndex;
      };

      const nextSlide = () => {
        const nextIndex =
          (currentIndex + 1) % slides.length;

        showSlide(nextIndex);
      };

      const stop = () => {
        if (!timer) return;

        clearInterval(timer);
        timer = null;
      };

      const start = () => {
        if (!autoplay) return;

        stop();

        timer = setInterval(nextSlide, speed);
      };

      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);

      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);

      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            stop();
          } else {
            start();
          }
        }
      );

      start();
    });
  };

  initAnnouncementBars();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAnnouncementBars(event.target);
    }
  );
})();





















(() => {
  const initServices = (root = document) => {
    const sections = root.querySelectorAll(
      '[data-lp-services]:not([data-lp-services-ready="true"])'
    );

    sections.forEach((section) => {
      const track = section.querySelector(
        '[data-lp-services-track]'
      );

      const previous = section.querySelector(
        '[data-lp-services-prev]'
      );

      const next = section.querySelector(
        '[data-lp-services-next]'
      );

      if (!track) return;

      section.dataset.lpServicesReady = 'true';

      const reducedMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;


      /* -----------------------------------------
         Slider controls
         ----------------------------------------- */

      const updateControls = () => {
        if (!previous || !next) return;

        const maxScroll =
          track.scrollWidth - track.clientWidth;

        const currentScroll =
          Math.abs(track.scrollLeft);

        const canScroll = maxScroll > 4;

        previous.hidden = !canScroll;
        next.hidden = !canScroll;

        previous.disabled =
          !canScroll ||
          currentScroll <= 2;

        next.disabled =
          !canScroll ||
          currentScroll >= maxScroll - 2;
      };


      const getScrollAmount = () => {
        const card = track.querySelector(
          '[data-lp-service-card]'
        );

        if (!card) {
          return track.clientWidth;
        }

        const styles =
          getComputedStyle(track);

        const gap =
          parseFloat(
            styles.columnGap ||
            styles.gap
          ) || 0;

        return (
          card.getBoundingClientRect().width +
          gap
        );
      };


      const scrollTrack = (direction) => {
        track.scrollBy({
          left:
            direction *
            getScrollAmount(),

          behavior:
            reducedMotion
              ? 'auto'
              : 'smooth'
        });
      };


      previous?.addEventListener(
        'click',
        () => scrollTrack(-1)
      );

      next?.addEventListener(
        'click',
        () => scrollTrack(1)
      );


      /* -----------------------------------------
         Efficient scroll handling
         ----------------------------------------- */

      let scrollFrame = null;

      track.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) return;

          scrollFrame =
            requestAnimationFrame(() => {
              updateControls();
              scrollFrame = null;
            });
        },
        { passive: true }
      );


      /* -----------------------------------------
         Responsive controls
         ----------------------------------------- */

      if ('ResizeObserver' in window) {
        const resizeObserver =
          new ResizeObserver(updateControls);

        resizeObserver.observe(track);
      } else {
        window.addEventListener(
          'resize',
          updateControls,
          { passive: true }
        );
      }


      /* -----------------------------------------
         Section reveal
         ----------------------------------------- */

      if (
        'IntersectionObserver' in window &&
        !reducedMotion
      ) {
        const sectionObserver =
          new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                section.classList.add(
                  'is-visible'
                );

                observer.unobserve(
                  entry.target
                );
              });
            },
            {
              threshold: 0.08
            }
          );

        sectionObserver.observe(section);
      } else {
        section.classList.add(
          'is-visible'
        );
      }





      updateControls();
    });
  };


  initServices();


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initServices(event.target);
    }
  );
})();





















(() => {
  const INDIA_TIMEZONE = 'Asia/Kolkata';

  const copyText = async (value) => {
    if (!value) return false;

    if (
      navigator.clipboard &&
      window.isSecureContext
    ) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch (error) { }
    }

    const textarea =
      document.createElement('textarea');

    textarea.value = value;
    textarea.readOnly = true;

    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);

    textarea.select();

    let success = false;

    try {
      success = document.execCommand('copy');
    } catch (error) { }

    textarea.remove();

    return success;
  };


  document.addEventListener(
    'click',
    async (event) => {
      const button =
        event.target.closest('[data-lp-copy]');

      if (!button) return;

      const value =
        button.dataset.copyValue;

      const success =
        await copyText(value);

      if (!success) return;

      const label =
        button.querySelector(
          '.lp-footer__copy-text'
        );

      if (button._lpCopyTimer) {
        clearTimeout(button._lpCopyTimer);
      }

      button.classList.add('is-copied');

      button.setAttribute(
        'aria-label',
        'Copied'
      );

      if (label) {
        label.textContent = 'Copied';
      }

      button._lpCopyTimer =
        setTimeout(() => {
          button.classList.remove('is-copied');

          button.setAttribute(
            'aria-label',
            'Copy'
          );

          if (label) {
            label.textContent = 'Copy';
          }
        }, 1400);
    }
  );


  const formatter =
    new Intl.DateTimeFormat(
      'en-IN',
      {
        timeZone: INDIA_TIMEZONE,
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }
    );


  const updateIndiaTime = () => {
    const elements =
      document.querySelectorAll(
        '[data-lp-india-time]'
      );

    if (!elements.length) return;

    const now = new Date();

    const value =
      `${formatter.format(now)} IST`;

    elements.forEach((element) => {
      element.textContent = value;

      element.dateTime =
        now.toISOString();
    });
  };


  const hasIndiaClock = () =>
    document.querySelector(
      '[data-lp-india-time]'
    );


  let indiaTimer = null;


  const startIndiaClock = () => {
    if (!hasIndiaClock()) return;

    updateIndiaTime();

    if (indiaTimer) {
      clearInterval(indiaTimer);
    }

    indiaTimer =
      setInterval(
        updateIndiaTime,
        60000
      );
  };


  const stopIndiaClock = () => {
    if (!indiaTimer) return;

    clearInterval(indiaTimer);

    indiaTimer = null;
  };


  startIndiaClock();


  document.addEventListener(
    'visibilitychange',
    () => {
      if (document.hidden) {
        stopIndiaClock();
      } else {
        startIndiaClock();
      }
    }
  );


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (
        event.target.querySelector(
          '[data-lp-footer]'
        ) ||
        event.target.matches?.(
          '[data-lp-footer]'
        )
      ) {
        startIndiaClock();
      }
    }
  );
})();


























(() => {
  const money = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  });

  const number = new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0
  });

  const clamp = (value, min, max) =>
    Math.min(Math.max(value, min), max);

  const initCalculator = (calculator) => {
    if (
      calculator.dataset.lpRoiReady ===
      'true'
    ) {
      return;
    }

    const input = (name) =>
      calculator.querySelector(
        `[data-roi-input="${name}"]`
      );

    const visitorsInput =
      input('visitors');

    const aovInput =
      input('aov');

    const conversionInput =
      input('conversion');

    const improvementInput =
      input('improvement');

    if (
      !visitorsInput ||
      !aovInput ||
      !conversionInput ||
      !improvementInput
    ) {
      return;
    }

    calculator.dataset.lpRoiReady =
      'true';

    const codShareInput =
      input('cod-share');

    const codRtoInput =
      input('cod-rto');

    const prepaidFailureInput =
      input('prepaid-failure');

    const advanced =
      calculator.querySelector(
        '.lp-roi__advanced'
      );

    let frame = null;


    const setText = (
      selector,
      value
    ) => {
      const element =
        calculator.querySelector(selector);

      if (element) {
        element.textContent = value;
      }
    };


    const updateProgress = (
      range
    ) => {
      const min =
        Number(range.min);

      const max =
        Number(range.max);

      const value =
        Number(range.value);

      const progress =
        max === min
          ? 0
          : ((value - min) /
            (max - min)) *
          100;

      range.style.setProperty(
        '--lp-range-progress',
        `${clamp(progress, 0, 100)}%`
      );
    };


    const isAdvancedActive = () =>
      advanced?.open === true;


    const calculate = () => {
      const visitors =
        Number(visitorsInput.value) || 0;

      const aov =
        Number(aovInput.value) || 0;

      const conversion =
        Number(conversionInput.value) || 0;

      const improvement =
        Number(improvementInput.value) || 0;


      const currentConversionDecimal =
        conversion / 100;


      const newConversion =
        conversion *
        (1 + improvement / 100);


      const newConversionDecimal =
        newConversion / 100;


      const currentRevenue =
        visitors *
        currentConversionDecimal *
        aov;


      const projectedRevenue =
        visitors *
        newConversionDecimal *
        aov;


      let monthlyExtra =
        projectedRevenue -
        currentRevenue;


      if (
        isAdvancedActive() &&
        codShareInput &&
        codRtoInput &&
        prepaidFailureInput
      ) {
        const codShare =
          clamp(
            Number(
              codShareInput.value
            ) || 0,
            0,
            100
          ) / 100;


        const codRto =
          clamp(
            Number(
              codRtoInput.value
            ) || 0,
            0,
            100
          ) / 100;


        const prepaidFailure =
          clamp(
            Number(
              prepaidFailureInput.value
            ) || 0,
            0,
            100
          ) / 100;


        const prepaidShare =
          1 - codShare;


        const leakageRate =
          (codShare * codRto) +
          (
            prepaidShare *
            prepaidFailure
          );


        monthlyExtra *=
          1 - leakageRate;
      }


      const yearlyExtra =
        monthlyExtra * 12;


      setText(
        '[data-roi-output="visitors"]',
        number.format(visitors)
      );


      setText(
        '[data-roi-output="aov"]',
        money.format(aov)
      );


      setText(
        '[data-roi-output="conversion"]',
        `${conversion.toFixed(1)}%`
      );


      setText(
        '[data-roi-output="improvement"]',
        `+${Math.round(
          improvement
        )}%`
      );


      setText(
        '[data-roi-result="current-revenue"]',
        money.format(
          Math.round(currentRevenue)
        )
      );


      setText(
        '[data-roi-result="new-conversion"]',
        `${newConversion.toFixed(2)}%`
      );


      setText(
        '[data-roi-result="monthly-extra"]',
        money.format(
          Math.max(
            0,
            Math.round(monthlyExtra)
          )
        )
      );


      setText(
        '[data-roi-result="yearly-extra"]',
        money.format(
          Math.max(
            0,
            Math.round(yearlyExtra)
          )
        )
      );


      updateProgress(
        visitorsInput
      );

      updateProgress(
        aovInput
      );

      updateProgress(
        conversionInput
      );

      updateProgress(
        improvementInput
      );
    };


    const schedule = () => {
      if (frame) {
        cancelAnimationFrame(frame);
      }

      frame =
        requestAnimationFrame(() => {
          calculate();
          frame = null;
        });
    };


    calculator
      .querySelectorAll(
        '[data-roi-input]'
      )
      .forEach((field) => {
        field.addEventListener(
          'input',
          schedule,
          { passive: true }
        );
      });


    advanced?.addEventListener(
      'toggle',
      schedule
    );


    setText(
      '[data-roi-min="visitors"]',
      number.format(
        Number(visitorsInput.min)
      )
    );

    setText(
      '[data-roi-max="visitors"]',
      number.format(
        Number(visitorsInput.max)
      )
    );

    setText(
      '[data-roi-min="aov"]',
      money.format(
        Number(aovInput.min)
      )
    );

    setText(
      '[data-roi-max="aov"]',
      money.format(
        Number(aovInput.max)
      )
    );


    calculate();
  };


  const initCalculators = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-roi]'
      )
      .forEach(initCalculator);
  };


  initCalculators();


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initCalculators(
        event.target
      );
    }
  );
})();










(() => {
  const initTestimonials = (root = document) => {
    const sections = root.querySelectorAll(
      '[data-lp-testimonials]:not([data-lp-testimonials-ready="true"])'
    );

    sections.forEach((section) => {
      section.dataset.lpTestimonialsReady = 'true';

      const dialog = section.querySelector(
        '[data-lp-testimonial-dialog]'
      );

      const player = section.querySelector(
        '[data-lp-testimonial-player]'
      );

      const video = section.querySelector(
        '[data-lp-testimonial-video]'
      );

      const closeButton = section.querySelector(
        '[data-lp-testimonial-close]'
      );

      const toggleButton = section.querySelector(
        '[data-lp-testimonial-toggle-play]'
      );

      const pauseIcon = section.querySelector(
        '[data-lp-testimonial-pause-icon]'
      );

      const playIcon = section.querySelector(
        '[data-lp-testimonial-play-icon]'
      );

      const playButtons = section.querySelectorAll(
        '[data-lp-testimonial-play]'
      );

      const track = section.querySelector(
        '[data-lp-testimonials-track]'
      );

      if (
        !dialog ||
        !player ||
        !video ||
        !playButtons.length
      ) {
        return;
      }

      let trigger = null;

      const setPlayState = () => {
        const isPlaying =
          !video.paused &&
          !video.ended;

        if (pauseIcon) {
          pauseIcon.hidden = !isPlaying;
        }

        if (playIcon) {
          playIcon.hidden = isPlaying;
        }

        if (toggleButton) {
          toggleButton.setAttribute(
            'aria-label',
            isPlaying
              ? 'Pause video'
              : 'Play video'
          );

          toggleButton.setAttribute(
            'aria-pressed',
            isPlaying
              ? 'true'
              : 'false'
          );
        }
      };

      const cleanVideo = () => {
        video.pause();

        video.removeAttribute('src');
        video.removeAttribute('poster');

        video.load();

        player.classList.remove(
          'is-portrait',
          'is-landscape'
        );

        document.documentElement.classList.remove(
          'lp-testimonial-modal-open'
        );

        document.body.classList.remove(
          'lp-testimonial-modal-open'
        );

        setPlayState();

        if (trigger) {
          trigger.focus({
            preventScroll: true
          });

          trigger = null;
        }
      };

      const closeVideo = () => {
        if (dialog.open) {
          dialog.close();
        } else {
          cleanVideo();
        }
      };

      const openVideo = async (button) => {
        const src =
          button.dataset.videoSrc;

        if (!src) return;

        trigger = button;

        const poster =
          button.dataset.videoPoster || '';

        const orientation =
          button.dataset.videoOrientation ===
            'landscape'
            ? 'landscape'
            : 'portrait';

        player.classList.remove(
          'is-portrait',
          'is-landscape'
        );

        player.classList.add(
          `is-${orientation}`
        );

        if (poster) {
          video.poster = poster;
        }

        video.src = src;

        if (
          typeof dialog.showModal ===
          'function'
        ) {
          dialog.showModal();

          document.documentElement.classList.add(
            'lp-testimonial-modal-open'
          );

          document.body.classList.add(
            'lp-testimonial-modal-open'
          );

          video.load();

          try {
            await video.play();
          } catch (error) { }

          setPlayState();

          return;
        }

        window.open(
          src,
          '_blank',
          'noopener,noreferrer'
        );
      };

      const togglePlayback = async () => {
        if (video.paused || video.ended) {
          try {
            await video.play();
          } catch (error) { }
        } else {
          video.pause();
        }

        setPlayState();
      };






      let pointerDown = false;
      let isDragging = false;
      let dragMoved = false;

      let startX = 0;
      let startScrollLeft = 0;
      let activePointerId = null;

      const DRAG_THRESHOLD = 6;

      const canDragTrack = () => {
        if (!track) return false;

        if (
          !section.classList.contains(
            'lp-testimonials--desktop-slider'
          )
        ) {
          return false;
        }

        return (
          track.scrollWidth >
          track.clientWidth + 2
        );
      };

      const startDrag = (event) => {
        if (!canDragTrack()) {
          return;
        }

        if (
          event.pointerType !== 'mouse' &&
          event.pointerType !== 'pen'
        ) {
          return;
        }

        if (event.button !== 0) {
          return;
        }

        pointerDown = true;
        isDragging = false;
        dragMoved = false;

        activePointerId = event.pointerId;

        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
      };

      const dragTrack = (event) => {
        if (
          !pointerDown ||
          !track ||
          event.pointerId !== activePointerId
        ) {
          return;
        }

        const delta =
          event.clientX - startX;

        if (
          !isDragging &&
          Math.abs(delta) >= DRAG_THRESHOLD
        ) {
          isDragging = true;
          dragMoved = true;

          track.classList.add(
            'is-dragging'
          );

          track.setPointerCapture?.(
            event.pointerId
          );
        }

        if (!isDragging) {
          return;
        }

        event.preventDefault();

        track.scrollLeft =
          startScrollLeft - delta;
      };

      const stopDrag = (event) => {
        if (
          !pointerDown ||
          event.pointerId !== activePointerId
        ) {
          return;
        }

        pointerDown = false;

        if (isDragging) {
          track.classList.remove(
            'is-dragging'
          );

          if (
            track.hasPointerCapture?.(
              event.pointerId
            )
          ) {
            track.releasePointerCapture(
              event.pointerId
            );
          }
        }

        isDragging = false;
        activePointerId = null;

        if (dragMoved) {
          window.setTimeout(() => {
            dragMoved = false;
          }, 0);
        }
      };

      if (track) {
        track.addEventListener(
          'pointerdown',
          startDrag
        );

        track.addEventListener(
          'pointermove',
          dragTrack
        );

        track.addEventListener(
          'pointerup',
          stopDrag
        );

        track.addEventListener(
          'pointercancel',
          stopDrag
        );

        track.addEventListener(
          'lostpointercapture',
          () => {
            pointerDown = false;
            isDragging = false;
            activePointerId = null;

            track.classList.remove(
              'is-dragging'
            );
          }
        );

        track.addEventListener(
          'dragstart',
          (event) => {
            event.preventDefault();
          }
        );
      }









      playButtons.forEach((button) => {
        button.addEventListener(
          'click',
          (event) => {
            if (dragMoved) {
              event.preventDefault();
              return;
            }

            openVideo(button);
          }
        );
      });

      closeButton?.addEventListener(
        'click',
        closeVideo
      );

      toggleButton?.addEventListener(
        'click',
        togglePlayback
      );

      video.addEventListener(
        'click',
        togglePlayback
      );

      video.addEventListener(
        'play',
        setPlayState
      );

      video.addEventListener(
        'pause',
        setPlayState
      );

      video.addEventListener(
        'ended',
        setPlayState
      );

      dialog.addEventListener(
        'close',
        cleanVideo
      );

      dialog.addEventListener(
        'cancel',
        (event) => {
          event.preventDefault();
          closeVideo();
        }
      );

      dialog.addEventListener(
        'click',
        (event) => {
          if (event.target === dialog) {
            closeVideo();
          }
        }
      );

      video.addEventListener(
        'contextmenu',
        (event) => {
          event.preventDefault();
        }
      );

      document.addEventListener(
        'visibilitychange',
        () => {
          if (
            document.hidden &&
            dialog.open
          ) {
            video.pause();
          }
        }
      );

      setPlayState();
    });
  };

  initTestimonials();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initTestimonials(event.target);
    }
  );
})();







































(() => {
  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const copyText = async (value) => {
    if (!value) return false;

    if (
      navigator.clipboard &&
      window.isSecureContext
    ) {
      try {
        await navigator.clipboard.writeText(
          value
        );

        return true;
      } catch (error) { }
    }

    const textarea =
      document.createElement(
        'textarea'
      );

    textarea.value = value;
    textarea.readOnly = true;

    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(
      textarea
    );

    textarea.select();

    let success = false;

    try {
      success =
        document.execCommand(
          'copy'
        );
    } catch (error) { }

    textarea.remove();

    return success;
  };

  const initArticle = (
    root = document
  ) => {
    const articles =
      root.querySelectorAll(
        '[data-lp-article]:not([data-lp-article-ready="true"])'
      );

    articles.forEach(
      (article) => {
        article.dataset.lpArticleReady =
          'true';

        const content =
          article.querySelector(
            '[data-lp-article-content]'
          );

        const tocLists =
          Array.from(
            article.querySelectorAll(
              '[data-lp-article-toc-list]'
            )
          );

        const progress =
          article.querySelector(
            '[data-lp-article-progress]'
          );

        const mobileToc =
          article.querySelector(
            '[data-lp-mobile-toc]'
          );

        if (!content) return;

        content
          .querySelectorAll('table')
          .forEach((table) => {
            if (
              table.closest(
                '.lp-article-table-wrap'
              )
            ) {
              return;
            }

            const wrapper =
              document.createElement(
                'div'
              );

            wrapper.className =
              'lp-article-table-wrap';

            table.parentNode.insertBefore(
              wrapper,
              table
            );

            wrapper.appendChild(table);
          });

        content
          .querySelectorAll('pre')
          .forEach((pre) => {
            if (
              pre.closest(
                '.lp-article-code-wrap'
              )
            ) {
              return;
            }

            const wrapper =
              document.createElement(
                'div'
              );

            wrapper.className =
              'lp-article-code-wrap';

            const button =
              document.createElement(
                'button'
              );

            button.type = 'button';

            button.className =
              'lp-article-code-copy';

            button.textContent =
              'Copy';

            button.setAttribute(
              'aria-label',
              'Copy code'
            );

            pre.parentNode.insertBefore(
              wrapper,
              pre
            );

            wrapper.appendChild(pre);
            wrapper.appendChild(button);

            button.addEventListener(
              'click',
              async () => {
                const success =
                  await copyText(
                    pre.textContent
                  );

                if (!success) return;

                button.textContent =
                  'Copied';

                button.setAttribute(
                  'aria-label',
                  'Code copied'
                );

                window.setTimeout(
                  () => {
                    button.textContent =
                      'Copy';

                    button.setAttribute(
                      'aria-label',
                      'Copy code'
                    );
                  },
                  1400
                );
              }
            );
          });

        const headings =
          Array.from(
            content.querySelectorAll(
              'h2, h3'
            )
          ).filter(
            (heading) =>
              heading.textContent
                .trim()
          );

        const slugify = (value) =>
          value
            .toLowerCase()
            .trim()
            .normalize('NFKD')
            .replace(
              /[\u0300-\u036f]/g,
              ''
            )
            .replace(
              /[^a-z0-9\s-]/g,
              ''
            )
            .replace(
              /\s+/g,
              '-'
            )
            .replace(
              /-+/g,
              '-'
            );

        const usedIds =
          new Set();

        headings.forEach(
          (heading, index) => {
            const baseId =
              heading.id ||
              slugify(
                heading.textContent
              ) ||
              `article-section-${index + 1}`;

            let id = baseId;
            let suffix = 2;

            while (
              usedIds.has(id) ||
              (
                document.getElementById(
                  id
                ) &&
                document.getElementById(
                  id
                ) !== heading
              )
            ) {
              id =
                `${baseId}-${suffix}`;

              suffix += 1;
            }

            heading.id = id;

            usedIds.add(id);
          }
        );

        if (
          tocLists.length &&
          headings.length
        ) {
          let h2Number = 0;

          const headingNumbers =
            new Map();

          headings.forEach(
            (heading) => {
              if (
                heading.tagName ===
                'H2'
              ) {
                h2Number += 1;

                headingNumbers.set(
                  heading.id,
                  h2Number
                );
              }
            }
          );

          tocLists.forEach(
            (tocList) => {
              tocList.innerHTML = '';

              const fragment =
                document
                  .createDocumentFragment();

              headings.forEach(
                (heading) => {
                  const item =
                    document.createElement(
                      'li'
                    );

                  const link =
                    document.createElement(
                      'a'
                    );

                  item.className =
                    heading.tagName ===
                      'H3'
                      ? 'lp-article-toc__item lp-article-toc__item--h3'
                      : 'lp-article-toc__item';

                  link.className =
                    'lp-article-toc__link';

                  link.href =
                    `#${heading.id}`;

                  link.textContent =
                    heading.textContent
                      .trim();

                  if (
                    heading.tagName ===
                    'H2'
                  ) {
                    const number =
                      document
                        .createElement(
                          'span'
                        );

                    number.className =
                      'lp-article-toc__number';

                    number.textContent =
                      String(
                        headingNumbers.get(
                          heading.id
                        )
                      ).padStart(
                        2,
                        '0'
                      );

                    item.appendChild(
                      number
                    );
                  }

                  item.appendChild(
                    link
                  );

                  fragment.appendChild(
                    item
                  );
                }
              );

              tocList.appendChild(
                fragment
              );

              tocList.addEventListener(
                'click',
                (event) => {
                  const link =
                    event.target.closest(
                      '.lp-article-toc__link'
                    );

                  if (!link) return;

                  const id =
                    decodeURIComponent(
                      link.hash.slice(1)
                    );

                  const target =
                    document
                      .getElementById(
                        id
                      );

                  if (!target) return;

                  event.preventDefault();

                  target.scrollIntoView({
                    behavior:
                      reducedMotion.matches
                        ? 'auto'
                        : 'smooth',

                    block: 'start'
                  });

                  if (
                    mobileToc?.open
                  ) {
                    mobileToc.open =
                      false;
                  }

                  history.replaceState(
                    null,
                    '',
                    `#${id}`
                  );
                }
              );
            }
          );

          const linksById =
            new Map();

          tocLists.forEach(
            (tocList) => {
              tocList
                .querySelectorAll(
                  '.lp-article-toc__link'
                )
                .forEach(
                  (link) => {
                    const id =
                      decodeURIComponent(
                        link.hash.slice(
                          1
                        )
                      );

                    if (
                      !linksById.has(
                        id
                      )
                    ) {
                      linksById.set(
                        id,
                        []
                      );
                    }

                    linksById
                      .get(id)
                      .push(link);
                  }
                );
            }
          );

          const activateHeading =
            (id) => {
              linksById.forEach(
                (links, key) => {
                  links.forEach(
                    (link) => {
                      link.classList.toggle(
                        'is-active',
                        key === id
                      );
                    }
                  );
                }
              );

              linksById
                .get(id)
                ?.forEach(
                  (link) => {
                    const scrollParent =
                      link.closest(
                        '.lp-article-toc__scroll'
                      );

                    if (
                      !scrollParent
                    ) {
                      return;
                    }

                    const linkRect =
                      link
                        .getBoundingClientRect();

                    const parentRect =
                      scrollParent
                        .getBoundingClientRect();

                    if (
                      linkRect.top <
                      parentRect.top +
                      12 ||
                      linkRect.bottom >
                      parentRect.bottom -
                      12
                    ) {
                      link.scrollIntoView({
                        block:
                          'nearest',

                        behavior:
                          reducedMotion
                            .matches
                            ? 'auto'
                            : 'smooth'
                      });
                    }
                  }
                );
            };

          if (
            'IntersectionObserver' in
            window
          ) {
            const observer =
              new IntersectionObserver(
                (entries) => {
                  const visible =
                    entries
                      .filter(
                        (entry) =>
                          entry
                            .isIntersecting
                      )
                      .sort(
                        (a, b) =>
                          a
                            .boundingClientRect
                            .top -
                          b
                            .boundingClientRect
                            .top
                      );

                  if (
                    !visible.length
                  ) {
                    return;
                  }

                  activateHeading(
                    visible[0]
                      .target.id
                  );
                },
                {
                  rootMargin:
                    '-16% 0px -72% 0px',

                  threshold: 0
                }
              );

            headings.forEach(
              (heading) =>
                observer.observe(
                  heading
                )
            );
          }
        }

        if (!progress) return;

        const bar =
          progress.querySelector(
            'span'
          );

        if (!bar) return;

        let articleStart = 0;
        let articleEnd = 0;
        let frame = null;

        const update = () => {
          const scrollY =
            window.scrollY;

          const range =
            Math.max(
              articleEnd -
              articleStart,
              1
            );

          const progressValue =
            Math.min(
              Math.max(
                (
                  scrollY -
                  articleStart
                ) /
                range,
                0
              ),
              1
            );

          bar.style.transform =
            `scaleX(${progressValue})`;

          progress.classList.toggle(
            'is-visible',
            scrollY >=
            articleStart &&
            scrollY <=
            articleEnd
          );

          frame = null;
        };

        const measure = () => {
          const rect =
            content
              .getBoundingClientRect();

          articleStart =
            rect.top +
            window.scrollY -
            window.innerHeight *
            .2;

          articleEnd =
            rect.bottom +
            window.scrollY -
            window.innerHeight *
            .72;

          update();
        };

        const onScroll = () => {
          if (frame) return;

          frame =
            requestAnimationFrame(
              update
            );
        };

        window.addEventListener(
          'scroll',
          onScroll,
          {
            passive: true
          }
        );

        if (
          'ResizeObserver' in
          window
        ) {
          const resizeObserver =
            new ResizeObserver(
              measure
            );

          resizeObserver.observe(
            content
          );
        } else {
          window.addEventListener(
            'resize',
            measure,
            {
              passive: true
            }
          );
        }

        measure();
      }
    );
  };

  initArticle();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initArticle(
        event.target
      );
    }
  );
})();
























































(() => {
  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const finePointer =
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

  const coarsePointer =
    window.matchMedia(
      '(hover: none), (pointer: coarse)'
    );

  let activeTouchCard = null;
  let activeTouchClose = null;

  const setResponsiveImageSource = (
    image
  ) => {
    if (
      !image ||
      image.dataset.lpSourceReady ===
      'true'
    ) {
      return;
    }

    const src =
      image.dataset.src;

    if (!src) return;

    image.dataset.lpSourceReady =
      'true';

    const srcset =
      image.dataset.srcset;

    const sizes =
      image.dataset.sizes;

    if (srcset) {
      image.srcset = srcset;
    }

    if (sizes) {
      image.sizes = sizes;
    }

    image.src = src;
  };

  const closeActiveTouchCard =
    () => {
      if (!activeTouchClose) {
        return;
      }

      const close =
        activeTouchClose;

      activeTouchCard = null;
      activeTouchClose = null;

      close();
    };

  const initCaseStudies = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-case-card]:not([data-lp-case-card-ready="true"])'
      )
      .forEach((card) => {
        card.dataset.lpCaseCardReady =
          'true';

        const primaryType =
          card.dataset
            .lpCasePrimaryType;

        const previewType =
          card.dataset
            .lpCaseHoverType;

        const mobilePreviewMode =
          card.dataset
            .lpCaseMobilePreview ||
          'tap';

        const primaryImage =
          card.querySelector(
            '[data-lp-case-primary-image]'
          );

        const primaryPoster =
          card.querySelector(
            '[data-lp-case-primary-poster]'
          );

        const primaryVideo =
          card.querySelector(
            '[data-lp-case-primary-video]'
          );

        const hoverImage =
          card.querySelector(
            '[data-lp-case-hover-image]'
          );

        const hoverPoster =
          card.querySelector(
            '[data-lp-case-hover-poster]'
          );

        const hoverVideo =
          card.querySelector(
            '[data-lp-case-hover-video]'
          );

        const mediaLink =
          card.querySelector(
            '[data-lp-case-media-link]'
          );

        let primaryLoaded = false;
        let primaryVisible = false;

        let previewPrepared = false;

        let hoverVideoLoaded = false;

        let hoverTimer = null;

        let pointerStartX = 0;
        let pointerStartY = 0;
        let pointerMoved = false;

        let mobileAlwaysVisible = false;

        const loadPrimaryImage =
          async () => {
            if (
              !primaryImage ||
              primaryLoaded
            ) {
              return;
            }

            primaryLoaded = true;

            setResponsiveImageSource(
              primaryImage
            );

            try {
              await primaryImage.decode();
            } catch (error) { }

            primaryImage.classList.add(
              'is-loaded'
            );
          };

        const loadPrimaryVideo =
          () => {
            if (
              !primaryVideo ||
              primaryLoaded
            ) {
              return;
            }

            primaryLoaded = true;

            if (primaryPoster) {
              setResponsiveImageSource(
                primaryPoster
              );

              const showPoster =
                async () => {
                  try {
                    await primaryPoster.decode();
                  } catch (error) { }

                  primaryPoster.classList.add(
                    'is-loaded'
                  );
                };

              showPoster();
            }

            const src =
              primaryVideo.dataset
                .videoSrc;

            if (!src) return;

            primaryVideo.src = src;

            primaryVideo.load();

            const ready =
              async () => {
                primaryVideo.classList.add(
                  'is-loaded'
                );

                primaryPoster?.classList.add(
                  'is-video-ready'
                );

                if (
                  primaryVisible &&
                  !reducedMotion.matches
                ) {
                  try {
                    await primaryVideo.play();
                  } catch (error) { }
                }
              };

            if (
              primaryVideo.readyState >=
              2
            ) {
              ready();
            } else {
              primaryVideo.addEventListener(
                'loadeddata',
                ready,
                {
                  once: true
                }
              );
            }
          };

        const loadPrimary = () => {
          if (primaryLoaded) return;

          if (
            primaryType === 'video'
          ) {
            loadPrimaryVideo();

            return;
          }

          if (
            primaryType === 'image'
          ) {
            loadPrimaryImage();
          }
        };

        if (
          'IntersectionObserver' in
          window
        ) {
          const primaryObserver =
            new IntersectionObserver(
              (
                entries,
                observer
              ) => {
                entries.forEach(
                  (entry) => {
                    if (
                      !entry.isIntersecting
                    ) {
                      return;
                    }

                    loadPrimary();

                    observer.unobserve(
                      card
                    );
                  }
                );
              },
              {
                root: null,

                rootMargin:
                  '350px 350px 350px 350px',

                threshold: 0
              }
            );

          primaryObserver.observe(
            card
          );
        } else {
          loadPrimary();
        }

        const loadHoverVideo =
          () => {
            if (
              !hoverVideo ||
              hoverVideoLoaded
            ) {
              return;
            }

            const src =
              hoverVideo.dataset
                .videoSrc;

            if (!src) return;

            hoverVideoLoaded = true;

            hoverVideo.src = src;

            hoverVideo.load();
          };

        const preparePreview =
          () => {
            if (
              previewPrepared ||
              !previewType
            ) {
              return;
            }

            previewPrepared = true;

            if (
              previewType ===
              'image' &&
              hoverImage
            ) {
              setResponsiveImageSource(
                hoverImage
              );

              return;
            }

            if (
              previewType ===
              'video' &&
              hoverPoster
            ) {
              setResponsiveImageSource(
                hoverPoster
              );
            }
          };

        const showImagePreview =
          async () => {
            if (!hoverImage) return;

            setResponsiveImageSource(
              hoverImage
            );

            card.classList.add(
              'is-preview-active'
            );

            requestAnimationFrame(
              () => {
                hoverImage.classList.add(
                  'is-active'
                );
              }
            );

            if (
              !hoverImage.complete
            ) {
              try {
                await hoverImage.decode();
              } catch (error) { }
            }
          };

        const showVideoPreview =
          async () => {
            if (!hoverVideo) return;

            card.classList.add(
              'is-preview-active'
            );

            primaryVideo?.pause();

            if (hoverPoster) {
              setResponsiveImageSource(
                hoverPoster
              );

              requestAnimationFrame(
                () => {
                  hoverPoster.classList.add(
                    'is-active'
                  );
                }
              );
            }

            loadHoverVideo();

            const revealVideo =
              () => {
                if (
                  !card.classList.contains(
                    'is-preview-active'
                  ) &&
                  !mobileAlwaysVisible
                ) {
                  return;
                }

                hoverVideo.classList.add(
                  'is-active'
                );

                hoverPoster?.classList.add(
                  'is-video-ready'
                );
              };

            if (
              hoverVideo.readyState >=
              2
            ) {
              revealVideo();
            } else {
              hoverVideo.addEventListener(
                'canplay',
                revealVideo,
                {
                  once: true
                }
              );
            }

            if (
              reducedMotion.matches
            ) {
              return;
            }

            try {
              await hoverVideo.play();
            } catch (error) { }
          };

        const showPreview =
          async () => {
            if (
              previewType === 'video'
            ) {
              await showVideoPreview();

              return;
            }

            if (
              previewType === 'image'
            ) {
              await showImagePreview();
            }
          };

        const hidePreview =
          () => {
            clearTimeout(
              hoverTimer
            );

            if (
              mobileAlwaysVisible
            ) {
              return;
            }

            card.classList.remove(
              'is-preview-active'
            );

            hoverImage?.classList.remove(
              'is-active'
            );

            hoverPoster?.classList.remove(
              'is-active',
              'is-video-ready'
            );

            if (hoverVideo) {
              hoverVideo.classList.remove(
                'is-active'
              );

              hoverVideo.pause();

              try {
                hoverVideo.currentTime =
                  0;
              } catch (error) { }
            }

            if (
              primaryVideo &&
              primaryVisible &&
              !reducedMotion.matches
            ) {
              primaryVideo
                .play()
                .catch(() => { });
            }

            if (
              activeTouchCard === card
            ) {
              activeTouchCard = null;
              activeTouchClose = null;
            }
          };

        if (
          primaryVideo &&
          'IntersectionObserver' in
          window
        ) {
          const playbackObserver =
            new IntersectionObserver(
              (entries) => {
                entries.forEach(
                  async (entry) => {
                    primaryVisible =
                      entry.isIntersecting &&
                      entry.intersectionRatio >=
                      0.4;

                    if (
                      !primaryVisible
                    ) {
                      primaryVideo.pause();

                      return;
                    }

                    loadPrimary();

                    if (
                      reducedMotion.matches ||
                      card.classList.contains(
                        'is-preview-active'
                      ) ||
                      mobileAlwaysVisible
                    ) {
                      return;
                    }

                    try {
                      await primaryVideo.play();
                    } catch (error) { }
                  }
                );
              },
              {
                threshold:
                  [0, 0.4, 0.65]
              }
            );

          playbackObserver.observe(
            card
          );
        }

        if (
          coarsePointer.matches &&
          previewType &&
          mobilePreviewMode !==
          'disabled' &&
          'IntersectionObserver' in
          window
        ) {
          const previewObserver =
            new IntersectionObserver(
              (entries) => {
                entries.forEach(
                  (entry) => {
                    if (
                      !entry.isIntersecting
                    ) {
                      return;
                    }

                    const prepare =
                      async () => {
                        preparePreview();

                        if (
                          mobilePreviewMode ===
                          'always'
                        ) {
                          mobileAlwaysVisible =
                            true;

                          card.classList.add(
                            'is-preview-active'
                          );

                          if (
                            previewType ===
                            'image'
                          ) {
                            await showImagePreview();

                            return;
                          }

                          if (
                            previewType ===
                            'video'
                          ) {
                            if (
                              hoverPoster
                            ) {
                              setResponsiveImageSource(
                                hoverPoster
                              );

                              hoverPoster.classList.add(
                                'is-active'
                              );
                            }
                          }
                        }
                      };

                    if (
                      'requestIdleCallback' in
                      window
                    ) {
                      requestIdleCallback(
                        prepare,
                        {
                          timeout: 400
                        }
                      );
                    } else {
                      window.setTimeout(
                        prepare,
                        60
                      );
                    }
                  }
                );
              },
              {
                root: null,

                rootMargin:
                  '140px 180px 140px 180px',

                threshold: 0
              }
            );

          previewObserver.observe(
            card
          );
        }

        if (
          coarsePointer.matches &&
          mobilePreviewMode ===
          'always' &&
          previewType ===
          'video' &&
          hoverVideo &&
          'IntersectionObserver' in
          window
        ) {
          const mobileVideoObserver =
            new IntersectionObserver(
              (entries) => {
                entries.forEach(
                  async (entry) => {
                    const visible =
                      entry.isIntersecting &&
                      entry.intersectionRatio >=
                      0.5;

                    if (!visible) {
                      hoverVideo.pause();

                      return;
                    }

                    mobileAlwaysVisible =
                      true;

                    card.classList.add(
                      'is-preview-active'
                    );

                    if (
                      hoverPoster
                    ) {
                      setResponsiveImageSource(
                        hoverPoster
                      );

                      hoverPoster.classList.add(
                        'is-active'
                      );
                    }

                    loadHoverVideo();

                    const reveal =
                      () => {
                        hoverVideo.classList.add(
                          'is-active'
                        );

                        hoverPoster?.classList.add(
                          'is-video-ready'
                        );
                      };

                    if (
                      hoverVideo.readyState >=
                      2
                    ) {
                      reveal();
                    } else {
                      hoverVideo.addEventListener(
                        'canplay',
                        reveal,
                        {
                          once: true
                        }
                      );
                    }

                    if (
                      reducedMotion.matches
                    ) {
                      return;
                    }

                    try {
                      await hoverVideo.play();
                    } catch (error) { }
                  }
                );
              },
              {
                threshold:
                  [0, 0.5, 0.75]
              }
            );

          mobileVideoObserver.observe(
            card
          );
        }



        if (
          finePointer.matches &&
          previewType &&
          'IntersectionObserver' in window
        ) {
          const desktopPreviewObserver =
            new IntersectionObserver(
              (
                entries,
                observer
              ) => {
                entries.forEach(
                  (entry) => {
                    if (
                      !entry.isIntersecting
                    ) {
                      return;
                    }

                    preparePreview();

                    if (
                      previewType ===
                      'video'
                    ) {
                      loadHoverVideo();
                    }

                    observer.unobserve(
                      entry.target
                    );
                  }
                );
              },
              {
                root: null,

                rootMargin:
                  '280px 320px 280px 320px',

                threshold: 0
              }
            );

          desktopPreviewObserver.observe(
            card
          );
        }


        const desktopEnter =
          () => {
            if (!previewType) return;

            clearTimeout(
              hoverTimer
            );

            hoverTimer =
              window.setTimeout(
                () => {
                  showPreview();
                },
                40
              );
          };

        if (
          finePointer.matches
        ) {
          card.addEventListener(
            'pointerenter',
            desktopEnter,
            {
              passive: true
            }
          );

          card.addEventListener(
            'pointerleave',
            hidePreview,
            {
              passive: true
            }
          );
        }

        card.addEventListener(
          'pointerdown',
          (event) => {
            if (
              event.pointerType ===
              'mouse'
            ) {
              return;
            }

            pointerStartX =
              event.clientX;

            pointerStartY =
              event.clientY;

            pointerMoved = false;
          },
          {
            passive: true
          }
        );

        card.addEventListener(
          'pointermove',
          (event) => {
            if (
              event.pointerType ===
              'mouse'
            ) {
              return;
            }

            const deltaX =
              Math.abs(
                event.clientX -
                pointerStartX
              );

            const deltaY =
              Math.abs(
                event.clientY -
                pointerStartY
              );

            if (
              deltaX > 9 ||
              deltaY > 9
            ) {
              pointerMoved = true;
            }
          },
          {
            passive: true
          }
        );

        card.addEventListener(
          'pointercancel',
          () => {
            pointerMoved = true;
          },
          {
            passive: true
          }
        );

        mediaLink?.addEventListener(
          'click',
          async (event) => {
            if (
              finePointer.matches ||
              !previewType ||
              mobilePreviewMode ===
              'always' ||
              mobilePreviewMode ===
              'disabled'
            ) {
              return;
            }

            if (pointerMoved) {
              event.preventDefault();

              return;
            }

            if (
              activeTouchCard === card &&
              card.classList.contains(
                'is-preview-active'
              )
            ) {
              return;
            }

            event.preventDefault();

            if (
              activeTouchCard &&
              activeTouchCard !== card
            ) {
              closeActiveTouchCard();
            }

            activeTouchCard =
              card;

            activeTouchClose =
              hidePreview;

            await showPreview();
          }
        );

        card
          .querySelectorAll(
            'img, video'
          )
          .forEach((media) => {
            media.addEventListener(
              'dragstart',
              (event) => {
                event.preventDefault();
              }
            );

            media.addEventListener(
              'contextmenu',
              (event) => {
                event.preventDefault();
              }
            );
          });
      });





    root
      .querySelectorAll(
        '[data-lp-case-track]:not([data-lp-case-track-ready="true"])'
      )
      .forEach((track) => {
        track.dataset
          .lpCaseTrackReady =
          'true';

        const shell =
          track.closest(
            '[data-lp-case-track-shell]'
          );

        const previous =
          shell?.querySelector(
            '[data-lp-case-track-previous]'
          );

        const next =
          shell?.querySelector(
            '[data-lp-case-track-next]'
          );

        const reduceMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

        let scrollFrame = null;

        const getMaxScroll = () =>
          Math.max(
            track.scrollWidth -
            track.clientWidth,
            0
          );

        const getScrollPosition = () =>
          Math.max(
            Math.abs(track.scrollLeft),
            0
          );

        const updateNavigation = () => {
          if (
            !previous ||
            !next
          ) {
            return;
          }

          const maxScroll =
            getMaxScroll();

          const current =
            getScrollPosition();

          const canScroll =
            maxScroll > 4;

          previous.hidden =
            !canScroll;

          next.hidden =
            !canScroll;

          previous.disabled =
            !canScroll ||
            current <= 3;

          next.disabled =
            !canScroll ||
            current >=
            maxScroll - 3;
        };

        const getScrollAmount = () => {
          const card =
            track.querySelector(
              '.lp-case-card'
            );

          if (!card) {
            return track.clientWidth;
          }

          const styles =
            getComputedStyle(track);

          const gap =
            parseFloat(
              styles.columnGap ||
              styles.gap
            ) || 0;

          return (
            card.getBoundingClientRect()
              .width +
            gap
          );
        };

        const scrollTrack = (
          direction
        ) => {
          if (
            getMaxScroll() <= 4
          ) {
            return;
          }

          track.scrollBy({
            left:
              direction *
              getScrollAmount(),

            behavior:
              reduceMotion.matches
                ? 'auto'
                : 'smooth'
          });
        };

        previous?.addEventListener(
          'click',
          () => {
            scrollTrack(-1);
          }
        );

        next?.addEventListener(
          'click',
          () => {
            scrollTrack(1);
          }
        );

        track.addEventListener(
          'scroll',
          () => {
            if (scrollFrame) {
              return;
            }

            scrollFrame =
              requestAnimationFrame(
                () => {
                  if (
                    activeTouchCard
                  ) {
                    closeActiveTouchCard();
                  }

                  updateNavigation();

                  scrollFrame = null;
                }
              );
          },
          {
            passive: true
          }
        );

        if (
          'ResizeObserver' in
          window
        ) {
          const resizeObserver =
            new ResizeObserver(
              () => {
                requestAnimationFrame(
                  updateNavigation
                );
              }
            );

          resizeObserver.observe(
            track
          );
        } else {
          window.addEventListener(
            'resize',
            updateNavigation,
            {
              passive: true
            }
          );
        }

        requestAnimationFrame(
          updateNavigation
        );
      });

    root
      .querySelectorAll(
        '[data-lp-case-media-play]:not([data-lp-case-media-play-ready="true"])'
      )
      .forEach((button) => {
        button.dataset
          .lpCaseMediaPlayReady =
          'true';

        button.addEventListener(
          'click',
          async () => {
            const surface =
              button.closest(
                '.lp-case-media__surface'
              );

            const video =
              surface?.querySelector(
                '[data-lp-case-media-video]'
              );

            if (
              !video ||
              !video.dataset.videoSrc
            ) {
              return;
            }

            if (!video.src) {
              video.src =
                video.dataset.videoSrc;

              video.load();
            }

            video.classList.add(
              'is-active'
            );

            button.hidden = true;

            try {
              await video.play();
            } catch (error) { }
          }
        );
      });
  };

  initCaseStudies();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initCaseStudies(
        event.target
      );
    }
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (
        !activeTouchCard ||
        activeTouchCard.contains(
          event.target
        )
      ) {
        return;
      }

      closeActiveTouchCard();
    },
    {
      passive: true
    }
  );

  document.addEventListener(
    'visibilitychange',
    () => {
      if (!document.hidden) {
        return;
      }

      closeActiveTouchCard();

      document
        .querySelectorAll(
          '[data-lp-case-primary-video], [data-lp-case-hover-video]'
        )
        .forEach((video) => {
          video.pause();
        });
    }
  );
})();


































(() => {
  const initShowreels = (root = document) => {
    const showreels = root.querySelectorAll(
      '[data-lp-showreel]:not([data-lp-showreel-ready="true"])'
    );

    showreels.forEach((section) => {
      const media =
        section.querySelector('[data-lp-showreel-media]');

      const video =
        section.querySelector('[data-lp-showreel-video]');

      const sound =
        section.querySelector('[data-lp-showreel-sound]');

      if (!media || !video) return;

      section.dataset.lpShowreelReady =
        'true';

      const reducedMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

      const mobileQuery =
        window.matchMedia(
          '(max-width: 767px)'
        );

      let sourceLoaded = false;

      let currentSource = '';

      const getSource = () => {
        const desktop =
          section.dataset.desktopSrc || '';

        const mobile =
          section.dataset.mobileSrc || '';

        if (
          mobileQuery.matches &&
          mobile
        ) {
          return mobile;
        }

        return desktop;
      };


      const loadVideo = () => {
        const source = getSource();

        if (!source) return;

        if (
          sourceLoaded &&
          currentSource === source
        ) {
          return;
        }

        currentSource = source;
        sourceLoaded = true;

        video.src = source;
        video.load();

        const handleReady = () => {
          media.classList.add('is-ready');
        };

        if (video.readyState >= 3) {
          handleReady();
        } else {
          video.addEventListener(
            'canplay',
            handleReady,
            { once: true }
          );
        }
      };


      const playVideo = async () => {
        if (
          section.dataset.autoplay !==
          'true'
        ) {
          return;
        }

        if (!sourceLoaded) {
          loadVideo();
        }

        if (!video.src) return;

        try {
          await video.play();
        } catch (error) { }
      };


      const pauseVideo = () => {
        if (!video.paused) {
          video.pause();
        }
      };


      const poster =
        section.querySelector(
          '.lp-showreel__poster'
        );

      if (poster) {
        const posterReady = () => {
          media.classList.add(
            'is-poster-ready'
          );
        };

        if (poster.complete) {
          posterReady();
        } else {
          poster.addEventListener(
            'load',
            posterReady,
            { once: true }
          );
        }
      }


      const preloadObserver =
        new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (
                !entry.isIntersecting
              ) {
                return;
              }

              loadVideo();

              observer.unobserve(section);
            });
          },
          
          {
            rootMargin: mobileQuery.matches
              ? '250px 0px 250px 0px'
              : '700px 0px 700px 0px',

            threshold: 0
          }

        );

      preloadObserver.observe(section);


      const playbackObserver =
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                entry.isIntersecting &&
                entry.intersectionRatio >=
                0.35
              ) {
                section.classList.add(
                  'is-visible'
                );

                if (!reducedMotion) {
                  playVideo();
                }
              } else {
                pauseVideo();
              }
            });
          },
          {
            threshold:
              [0, 0.35, 0.6]
          }
        );

      playbackObserver.observe(section);


      sound?.addEventListener(
        'click',
        async () => {
          video.muted =
            !video.muted;

          const unmuted =
            !video.muted;

          sound.classList.toggle(
            'is-unmuted',
            unmuted
          );

          sound.setAttribute(
            'aria-pressed',
            unmuted
              ? 'true'
              : 'false'
          );

          sound.setAttribute(
            'aria-label',
            unmuted
              ? 'Mute showreel'
              : 'Unmute showreel'
          );

          if (video.paused) {
            try {
              await video.play();
            } catch (error) { }
          }
        }
      );


      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            pauseVideo();
          }
        }
      );


      const updateSource = () => {
        if (!sourceLoaded) return;

        const nextSource =
          getSource();

        if (
          !nextSource ||
          nextSource ===
          currentSource
        ) {
          return;
        }

        const wasPlaying =
          !video.paused;

        pauseVideo();

        currentSource = '';
        sourceLoaded = false;

        loadVideo();

        if (wasPlaying) {
          video.addEventListener(
            'canplay',
            () => {
              playVideo();
            },
            { once: true }
          );
        }
      };


      if (
        typeof mobileQuery
          .addEventListener ===
        'function'
      ) {
        mobileQuery.addEventListener(
          'change',
          updateSource
        );
      }
    });
  };


  initShowreels();


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initShowreels(event.target);
    }
  );
})();















(() => {
  const tabletQuery =
    window.matchMedia(
      '(max-width: 989px)'
    );

  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const initProcesses = (
    root = document
  ) => {
    const sections =
      root.querySelectorAll(
        '[data-lp-process]:not([data-lp-process-ready="true"])'
      );

    sections.forEach(
      (section) => {
        section.dataset
          .lpProcessReady =
          'true';

        const layout =
          section.querySelector(
            '.lp-process__layout'
          );

        const steps =
          Array.from(
            section.querySelectorAll(
              '[data-lp-process-step]'
            )
          );

        const triggers =
          Array.from(
            section.querySelectorAll(
              '[data-lp-process-trigger]'
            )
          );

        const visualWrap =
          section.querySelector(
            '[data-lp-process-visual-wrap]'
          );

        const visual =
          section.querySelector(
            '[data-lp-process-visual]'
          );

        const video =
          section.querySelector(
            '[data-lp-process-video]'
          );

        const playButton =
          section.querySelector(
            '[data-lp-process-video-play]'
          );

        if (
          !layout ||
          !steps.length ||
          !triggers.length ||
          !visualWrap ||
          !visual ||
          !video
        ) {
          return;
        }

        let image =
          visual.querySelector(
            '.lp-process__media-image'
          );

        let activeTrigger =
          triggers[0];

        let activeIndex = 0;

        let loadedVideoSource = '';

        let imageRequest = 0;

        let currentImageKey = '';

        const imageCache =
          new Map();

        const buildSrcset = (
          trigger,
          prefix
        ) => {
          return [
            [
              480,
              trigger.dataset[
              `${prefix}480`
              ]
            ],
            [
              720,
              trigger.dataset[
              `${prefix}720`
              ]
            ],
            [
              960,
              trigger.dataset[
              `${prefix}960`
              ]
            ],
            [
              1200,
              trigger.dataset[
              `${prefix}1200`
              ]
            ],
            [
              1600,
              trigger.dataset[
              `${prefix}1600`
              ]
            ]
          ]
            .filter(
              ([, src]) => src
            )
            .map(
              ([width, src]) =>
                `${src} ${width}w`
            )
            .join(', ');
        };

        const getFallback = (
          trigger,
          prefix
        ) => {
          return (
            trigger.dataset[
            `${prefix}1200`
            ] ||
            trigger.dataset[
            `${prefix}960`
            ] ||
            trigger.dataset[
            `${prefix}720`
            ] ||
            trigger.dataset[
            `${prefix}480`
            ] ||
            ''
          );
        };

        const ensureImage = () => {
          if (image) {
            return image;
          }

          image =
            document.createElement(
              'img'
            );

          image.className =
            'lp-process__media-image';

          image.alt = '';

          image.decoding =
            'async';

          visual.prepend(image);

          return image;
        };

        const stopVideo = () => {
          video.pause();

          visual.classList.remove(
            'is-video-playing'
          );
        };

        const preloadImage = (
          trigger,
          prefix
        ) => {
          const fallback =
            getFallback(
              trigger,
              prefix
            );

          if (!fallback) {
            return Promise.resolve(
              null
            );
          }

          const srcset =
            buildSrcset(
              trigger,
              prefix
            );

          const cacheKey =
            `${prefix}:${fallback}`;

          if (
            imageCache.has(
              cacheKey
            )
          ) {
            return imageCache.get(
              cacheKey
            );
          }

          const promise =
            new Promise(
              (resolve) => {
                const preload =
                  new Image();

                preload.decoding =
                  'async';

                if (srcset) {
                  preload.srcset =
                    srcset;

                  preload.sizes =
                    '(min-width: 1200px) 60vw, (min-width: 990px) 58vw, 100vw';
                }

                preload.src =
                  fallback;

                const done = () => {
                  resolve({
                    fallback,
                    srcset,
                    cacheKey
                  });
                };

                if (
                  typeof
                  preload.decode ===
                  'function'
                ) {
                  preload
                    .decode()
                    .then(done)
                    .catch(done);
                } else {
                  preload.onload =
                    done;

                  preload.onerror =
                    done;
                }
              }
            );

          imageCache.set(
            cacheKey,
            promise
          );

          return promise;
        };

        const showImage = async (
          trigger,
          prefix = 'image'
        ) => {
          const fallback =
            getFallback(
              trigger,
              prefix
            );

          if (!fallback) {
            return;
          }

          const nextKey =
            `${prefix}:${fallback}`;

          if (
            nextKey === currentImageKey
          ) {
            return;
          }

          const requestId =
            ++imageRequest;

          const loaded =
            await preloadImage(
              trigger,
              prefix
            );

          if (
            !loaded ||
            requestId !== imageRequest
          ) {
            return;
          }

          const nextImage =
            document.createElement(
              'img'
            );

          nextImage.className =
            'lp-process__media-image lp-process__media-image--incoming';

          nextImage.alt =
            trigger.dataset
              .mediaLabel || '';

          nextImage.decoding =
            'async';

          nextImage.src =
            loaded.fallback;

          if (loaded.srcset) {
            nextImage.srcset =
              loaded.srcset;
          }

          nextImage.sizes =
            '(min-width: 1200px) 60vw, (min-width: 990px) 58vw, 100vw';

          visual.insertBefore(
            nextImage,
            video
          );

          try {
            if (
              typeof nextImage.decode ===
              'function'
            ) {
              await nextImage.decode();
            }
          } catch (error) { }

          if (
            requestId !== imageRequest
          ) {
            nextImage.remove();
            return;
          }

          const previousImage =
            image;

          requestAnimationFrame(
            () => {
              nextImage.classList.add(
                'is-visible'
              );

              previousImage?.classList.add(
                'is-leaving'
              );
            }
          );

          const finishSwap = () => {
            if (
              previousImage &&
              previousImage !== nextImage
            ) {
              previousImage.remove();
            }

            nextImage.classList.remove(
              'lp-process__media-image--incoming',
              'is-visible'
            );

            image = nextImage;

            currentImageKey =
              nextKey;
          };

          if (reducedMotion.matches) {
            finishSwap();
            return;
          }

          window.setTimeout(
            finishSwap,
            260
          );
        };

        const updatePlayState = (
          trigger
        ) => {
          const isVideo =
            trigger.dataset
              .mediaType ===
            'video';

          const hasVideo =
            Boolean(
              trigger.dataset
                .videoSrc
            );

          playButton.hidden =
            !(
              isVideo &&
              hasVideo
            );

          if (
            isVideo &&
            hasVideo
          ) {
            playButton.setAttribute(
              'aria-label',
              `Play ${trigger.dataset
                .mediaLabel ||
              'process'
              } video`
            );
          }
        };

        const placeVisual = (
          step
        ) => {
          if (
            tabletQuery.matches
          ) {
            step.insertAdjacentElement(
              'beforeend',
              visualWrap
            );

            return;
          }

          layout.appendChild(
            visualWrap
          );
        };

        const setActiveStates = (
          index
        ) => {
          steps.forEach(
            (
              step,
              stepIndex
            ) => {
              const active =
                stepIndex ===
                index;

              step.classList.toggle(
                'is-active',
                active
              );

              const button =
                step.querySelector(
                  '[data-lp-process-trigger]'
                );

              button?.setAttribute(
                'aria-expanded',
                active
                  ? 'true'
                  : 'false'
              );
            }
          );
        };

        const activate = (
          trigger
        ) => {
          if (!trigger) {
            return;
          }

          const index =
            Number(
              trigger.dataset
                .stepIndex
            );

          const step =
            steps[index];

          if (!step) {
            return;
          }

          activeTrigger =
            trigger;

          activeIndex =
            index;

          setActiveStates(
            index
          );

          stopVideo();

          const mediaType =
            trigger.dataset
              .mediaType;

          if (
            mediaType ===
            'video'
          ) {
            showImage(
              trigger,
              'poster'
            );
          } else {
            showImage(
              trigger,
              'image'
            );
          }

          updatePlayState(
            trigger
          );

          placeVisual(step);
        };

        const playVideo =
          async () => {
            if (
              !activeTrigger
            ) {
              return;
            }

            const source =
              activeTrigger.dataset
                .videoSrc;

            if (!source) {
              return;
            }

            if (
              loadedVideoSource !==
              source
            ) {
              video.pause();

              video.src =
                source;

              const poster =
                activeTrigger
                  .dataset
                  .poster1200 ||
                activeTrigger
                  .dataset
                  .poster960 ||
                activeTrigger
                  .dataset
                  .poster720 ||
                '';

              if (poster) {
                video.poster =
                  poster;
              } else {
                video.removeAttribute(
                  'poster'
                );
              }

              video.load();

              loadedVideoSource =
                source;
            }

            visual.classList.add(
              'is-video-playing'
            );

            try {
              await video.play();
            } catch (error) {
              visual.classList.remove(
                'is-video-playing'
              );
            }
          };

        triggers.forEach(
          (trigger) => {
            trigger.addEventListener(
              'click',
              () => {
                activate(
                  trigger
                );
              }
            );
          }
        );

        playButton.addEventListener(
          'click',
          playVideo
        );

        const handleLayout =
          () => {
            const step =
              steps[
              activeIndex
              ];

            if (step) {
              placeVisual(
                step
              );
            }
          };

        if (
          typeof tabletQuery
            .addEventListener ===
          'function'
        ) {
          tabletQuery
            .addEventListener(
              'change',
              handleLayout
            );
        } else {
          tabletQuery
            .addListener(
              handleLayout
            );
        }

        document.addEventListener(
          'visibilitychange',
          () => {
            if (
              document.hidden
            ) {
              stopVideo();
            }
          }
        );

        if (
          image?.currentSrc ||
          image?.src
        ) {
          const initialPrefix =
            activeTrigger
              ?.dataset
              .mediaType ===
              'video'
              ? 'poster'
              : 'image';

          const initialFallback =
            getFallback(
              activeTrigger,
              initialPrefix
            );

          if (
            initialFallback
          ) {
            currentImageKey =
              `${initialPrefix}:${initialFallback}`;
          }
        }

        activate(
          activeTrigger
        );

        if (
          reducedMotion.matches
        ) {
          section.classList.add(
            'is-reduced-motion'
          );
        }
      }
    );
  };

  initProcesses();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initProcesses(
        event.target
      );
    }
  );
})();






































































































(() => {
  const sections = document.querySelectorAll('[data-lp-shift]');

  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.lpShiftReady === 'true') return;

    section.dataset.lpShiftReady = 'true';

    const track = section.querySelector('[data-shift-track]');

    const cards = Array.from(
      section.querySelectorAll('[data-shift-card]')
    );

    const nodes = Array.from(
      section.querySelectorAll('[data-shift-node]')
    );

    const connectors = Array.from(
      section.querySelectorAll('[data-shift-connector]')
    );

    const prevButton = section.querySelector('[data-shift-prev]');
    const nextButton = section.querySelector('[data-shift-next]');

    const paginationCurrent = section.querySelector(
      '[data-shift-pagination-current]'
    );

    const mobileCurrent = section.querySelector(
      '[data-shift-current]'
    );

    if (!track || !cards.length) return;

    let activeIndex = 0;
    let observer = null;

    const ratios = new Map();

    const mobileMedia = window.matchMedia('(max-width: 767px)');

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const setActive = (index) => {
      if (index < 0 || index >= cards.length) return;

      activeIndex = index;

      cards.forEach((card, cardIndex) => {
        const active = cardIndex === index;

        card.classList.toggle('is-active', active);

        if (active) {
          card.setAttribute('aria-current', 'step');
        } else {
          card.removeAttribute('aria-current');
        }
      });

      nodes.forEach((node, nodeIndex) => {
        node.classList.toggle(
          'is-active',
          nodeIndex === index
        );
      });

      connectors.forEach((connector, connectorIndex) => {
        connector.classList.toggle(
          'is-active',
          connectorIndex === index
        );
      });

      if (paginationCurrent) {
        paginationCurrent.textContent = String(index + 1).padStart(2, '0');
      }

      if (mobileCurrent) {
        mobileCurrent.textContent = index + 1;
      }

      if (prevButton) {
        prevButton.disabled = index === 0;
      }

      if (nextButton) {
        nextButton.disabled = index === cards.length - 1;
      }
    };

    const updateFromVisibility = () => {
      let bestIndex = activeIndex;
      let bestRatio = 0;

      cards.forEach((card, index) => {
        const ratio = ratios.get(card) || 0;

        if (ratio > bestRatio) {
          bestRatio = ratio;
          bestIndex = index;
        }
      });

      if (bestRatio > 0) {
        setActive(bestIndex);
      }
    };

    const createObserver = () => {
      if (observer) {
        observer.disconnect();
      }

      ratios.clear();

      const isMobile = mobileMedia.matches;

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            ratios.set(
              entry.target,
              entry.intersectionRatio
            );
          });

          updateFromVisibility();
        },
        {
          root: isMobile ? track : null,

          rootMargin: isMobile
            ? '0px -20% 0px -20%'
            : '-30% 0px -45% 0px',

          threshold: [
            0,
            0.2,
            0.4,
            0.6,
            0.8
          ]
        }
      );

      cards.forEach((card) => {
        observer.observe(card);
      });
    };

    const goTo = (index) => {
      if (index < 0 || index >= cards.length) return;

      setActive(index);

      cards[index].scrollIntoView({
        behavior: reducedMotion.matches
          ? 'auto'
          : 'smooth',

        block: 'nearest',
        inline: 'center'
      });
    };

    prevButton?.addEventListener('click', () => {
      goTo(activeIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      goTo(activeIndex + 1);
    });

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', () => {
        createObserver();
        setActive(activeIndex);
      });
    }

    setActive(0);
    createObserver();
  });
})();

































(() => {
  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const setImageSource = (
    image
  ) => {
    if (
      !image ||
      image.dataset.lpSourceReady ===
      'true'
    ) {
      return;
    }

    const src =
      image.dataset.src;

    if (!src) return;

    image.dataset.lpSourceReady =
      'true';

    if (
      image.dataset.srcset
    ) {
      image.srcset =
        image.dataset.srcset;
    }

    if (
      image.dataset.sizes
    ) {
      image.sizes =
        image.dataset.sizes;
    }

    image.src = src;

    const show = () => {
      image.classList.add(
        'is-loaded'
      );
    };

    if (image.complete) {
      show();
    } else {
      image.addEventListener(
        'load',
        show,
        {
          once: true
        }
      );
    }
  };

  const loadVideo = (
    video
  ) => {
    if (
      !video ||
      video.dataset.lpVideoReady ===
      'true'
    ) {
      return;
    }

    const src =
      video.dataset.videoSrc;

    if (!src) return;

    video.dataset.lpVideoReady =
      'true';

    video.src = src;

    video.load();

    const ready = () => {
      video.classList.add(
        'is-loaded'
      );

      const poster =
        video
          .closest(
            '[data-lp-editorial-media]'
          )
          ?.querySelector(
            '[data-lp-editorial-poster]'
          );

      poster?.classList.add(
        'is-video-ready'
      );
    };

    if (
      video.readyState >= 2
    ) {
      ready();
    } else {
      video.addEventListener(
        'loadeddata',
        ready,
        {
          once: true
        }
      );
    }
  };

  const initEditorial = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-editorial]:not([data-lp-editorial-ready="true"])'
      )
      .forEach((section) => {
        section.dataset
          .lpEditorialReady =
          'true';

        const media =
          section.querySelectorAll(
            '[data-lp-editorial-media]'
          );

        const reveals =
          section.querySelectorAll(
            '[data-lp-editorial-reveal]'
          );

        if (
          'IntersectionObserver' in
          window
        ) {
          const mediaObserver =
            new IntersectionObserver(
              (
                entries,
                observer
              ) => {
                entries.forEach(
                  (entry) => {
                    if (
                      !entry.isIntersecting
                    ) {
                      return;
                    }

                    const item =
                      entry.target;

                    setImageSource(
                      item.querySelector(
                        '[data-lp-editorial-image]'
                      )
                    );

                    setImageSource(
                      item.querySelector(
                        '[data-lp-editorial-poster]'
                      )
                    );

                    observer.unobserve(
                      item
                    );
                  }
                );
              },
              {
                root: null,
                rootMargin:
                  '300px 200px 300px 200px',
                threshold: 0
              }
            );

          media.forEach(
            (item) => {
              mediaObserver.observe(
                item
              );
            }
          );

          const videoObserver =
            new IntersectionObserver(
              (entries) => {
                entries.forEach(
                  async (entry) => {
                    const video =
                      entry.target
                        .querySelector(
                          '[data-lp-editorial-video]'
                        );

                    if (!video) {
                      return;
                    }

                    const visible =
                      entry
                        .isIntersecting &&
                      entry
                        .intersectionRatio >=
                      .4;

                    if (!visible) {
                      video.pause();

                      return;
                    }

                    loadVideo(video);

                    if (
                      video.dataset
                        .autoplay !==
                      'true' ||
                      reducedMotion.matches
                    ) {
                      return;
                    }

                    try {
                      await video.play();
                    } catch (error) { }
                  }
                );
              },
              {
                threshold:
                  [0, .4, .7]
              }
            );

          media.forEach(
            (item) => {
              if (
                item.querySelector(
                  '[data-lp-editorial-video]'
                )
              ) {
                videoObserver.observe(
                  item
                );
              }
            }
          );

          if (
            !reducedMotion.matches
          ) {
            const revealObserver =
              new IntersectionObserver(
                (
                  entries,
                  observer
                ) => {
                  entries.forEach(
                    (entry) => {
                      if (
                        !entry
                          .isIntersecting
                      ) {
                        return;
                      }

                      entry.target
                        .classList
                        .add(
                          'is-visible'
                        );

                      observer.unobserve(
                        entry.target
                      );
                    }
                  );
                },
                {
                  root: null,
                  rootMargin:
                    '0px 0px -8% 0px',
                  threshold: .08
                }
              );

            reveals.forEach(
              (element) => {
                revealObserver.observe(
                  element
                );
              }
            );
          } else {
            reveals.forEach(
              (element) => {
                element.classList.add(
                  'is-visible'
                );
              }
            );
          }
        } else {
          media.forEach(
            (item) => {
              setImageSource(
                item.querySelector(
                  '[data-lp-editorial-image]'
                )
              );

              setImageSource(
                item.querySelector(
                  '[data-lp-editorial-poster]'
                )
              );
            }
          );

          reveals.forEach(
            (element) => {
              element.classList.add(
                'is-visible'
              );
            }
          );
        }
      });
  };

  initEditorial();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initEditorial(
        event.target
      );
    }
  );

  document.addEventListener(
    'visibilitychange',
    () => {
      if (!document.hidden) {
        return;
      }

      document
        .querySelectorAll(
          '[data-lp-editorial-video]'
        )
        .forEach((video) => {
          video.pause();
        });
    }
  );
})();





















































(() => {
  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const initAboutProof = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-about-proof]:not([data-lp-about-proof-ready="true"])'
      )
      .forEach((section) => {
        section.dataset
          .lpAboutProofReady =
          'true';

        const elements =
          section.querySelectorAll(
            '[data-lp-about-proof-reveal]'
          );

        if (
          !elements.length ||
          reducedMotion.matches ||
          !(
            'IntersectionObserver'
            in window
          )
        ) {
          elements.forEach(
            (element) => {
              element.classList.add(
                'is-visible'
              );
            }
          );

          return;
        }

        const observer =
          new IntersectionObserver(
            (
              entries,
              observerInstance
            ) => {
              entries.forEach(
                (entry) => {
                  if (
                    !entry.isIntersecting
                  ) {
                    return;
                  }

                  entry.target
                    .classList
                    .add(
                      'is-visible'
                    );

                  observerInstance
                    .unobserve(
                      entry.target
                    );
                }
              );
            },
            {
              root: null,

              rootMargin:
                '0px 0px -8% 0px',

              threshold: .08
            }
          );

        elements.forEach(
          (element) => {
            observer.observe(
              element
            );
          }
        );
      });
  };

  initAboutProof();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAboutProof(
        event.target
      );
    }
  );
})();












































(() => {
  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const finePointer =
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

  const setImageSource = (
    image
  ) => {
    if (
      !image ||
      image.dataset.lpTeamSourceReady ===
      'true'
    ) {
      return;
    }

    const src =
      image.dataset.src;

    if (!src) return;

    image.dataset.lpTeamSourceReady =
      'true';

    if (image.dataset.srcset) {
      image.srcset =
        image.dataset.srcset;
    }

    if (image.dataset.sizes) {
      image.sizes =
        image.dataset.sizes;
    }

    image.src = src;

    const show = () => {
      image.classList.add(
        'is-loaded'
      );
    };

    if (image.complete) {
      show();
      return;
    }

    image.addEventListener(
      'load',
      show,
      {
        once: true
      }
    );
  };

  const initTeam = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-team]:not([data-lp-team-ready="true"])'
      )
      .forEach((section) => {

        section.dataset.lpTeamReady =
          'true';

        const cards =
          section.querySelectorAll(
            '[data-lp-team-card]'
          );

        const reveals =
          section.querySelectorAll(
            '[data-lp-team-reveal]'
          );

        if (
          'IntersectionObserver' in
          window
        ) {

          const imageObserver =
            new IntersectionObserver(
              (
                entries,
                observer
              ) => {

                entries.forEach(
                  (entry) => {

                    if (
                      !entry.isIntersecting
                    ) {
                      return;
                    }

                    const card =
                      entry.target;

                    setImageSource(
                      card.querySelector(
                        '[data-lp-team-image]'
                      )
                    );

                    observer.unobserve(
                      card
                    );
                  }
                );

              },
              {
                root: null,

                rootMargin:
                  '300px 160px 300px 160px',

                threshold: 0
              }
            );

          cards.forEach(
            (card) => {

              imageObserver.observe(
                card
              );

              if (
                finePointer.matches
              ) {

                let hoverPrepared =
                  false;

                card.addEventListener(
                  'pointerenter',
                  () => {

                    if (
                      hoverPrepared
                    ) {
                      return;
                    }

                    hoverPrepared =
                      true;

                    setImageSource(
                      card.querySelector(
                        '[data-lp-team-hover-image]'
                      )
                    );

                  },
                  {
                    passive: true
                  }
                );

              }

            }
          );

          if (
            !reducedMotion.matches
          ) {

            const revealObserver =
              new IntersectionObserver(
                (
                  entries,
                  observer
                ) => {

                  entries.forEach(
                    (entry) => {

                      if (
                        !entry.isIntersecting
                      ) {
                        return;
                      }

                      entry.target
                        .classList
                        .add(
                          'is-visible'
                        );

                      observer.unobserve(
                        entry.target
                      );

                    }
                  );

                },
                {
                  root: null,

                  rootMargin:
                    '0px 0px -8% 0px',

                  threshold: .08
                }
              );

            reveals.forEach(
              (element) => {

                revealObserver.observe(
                  element
                );

              }
            );

          } else {

            reveals.forEach(
              (element) => {

                element.classList.add(
                  'is-visible'
                );

              }
            );

          }

        } else {

          cards.forEach(
            (card) => {

              setImageSource(
                card.querySelector(
                  '[data-lp-team-image]'
                )
              );

            }
          );

          reveals.forEach(
            (element) => {

              element.classList.add(
                'is-visible'
              );

            }
          );

        }

      });
  };

  initTeam();

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initTeam(
        event.target
      );

    }
  );
})();































(() => {
  const finePointer =
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const loadImage = (image) => {
    if (!image) {
      return Promise.resolve(null);
    }

    if (
      image.dataset.lpShowcaseLoaded ===
      'true'
    ) {
      return Promise.resolve(image);
    }

    const src =
      image.dataset.src;

    if (!src) {
      image.classList.add(
        'is-loaded'
      );

      return Promise.resolve(
        image
      );
    }

    image.dataset.lpShowcaseLoaded =
      'true';

    if (image.dataset.srcset) {
      image.srcset =
        image.dataset.srcset;
    }

    if (image.dataset.sizes) {
      image.sizes =
        image.dataset.sizes;
    }

    image.src = src;

    return new Promise(
      (resolve) => {
        const ready = () => {
          image.classList.add(
            'is-loaded'
          );

          resolve(image);
        };

        if (
          image.complete &&
          image.naturalWidth > 0
        ) {
          ready();
          return;
        }

        image.addEventListener(
          'load',
          ready,
          { once: true }
        );

        image.addEventListener(
          'error',
          () => resolve(image),
          { once: true }
        );
      }
    );
  };

  const loadVideo = (video) => {
    if (
      !video ||
      video.dataset.lpShowcaseVideoLoaded ===
      'true'
    ) {
      return;
    }

    const src =
      video.dataset.videoSrc;

    if (!src) {
      return;
    }

    video.dataset.lpShowcaseVideoLoaded =
      'true';

    video.src = src;

    video.load();
  };

  const stopVideo = (card) => {
    const video =
      card.querySelector(
        '[data-lp-showcase-video]'
      );

    if (!video) {
      return;
    }

    video.pause();

    video.classList.remove(
      'is-ready'
    );

    card.classList.remove(
      'is-video-playing'
    );
  };

  const playVideo = async (card) => {
    if (reducedMotion.matches) {
      return;
    }

    const video =
      card.querySelector(
        '[data-lp-showcase-video]'
      );

    if (!video) {
      return;
    }

    loadVideo(video);

    const reveal = () => {
      video.classList.add(
        'is-ready'
      );

      card.classList.add(
        'is-video-playing'
      );
    };

    if (video.readyState >= 2) {
      reveal();
    } else {
      video.addEventListener(
        'canplay',
        reveal,
        { once: true }
      );
    }

    try {
      await video.play();
    } catch (error) {
      stopVideo(card);
    }
  };

  const prepareScrollPreview =
    async (card) => {
      const image =
        card.querySelector(
          '[data-lp-showcase-scroll-image]'
        );

      const frame =
        card.querySelector(
          '[data-lp-showcase-scroll-frame]'
        );

      if (!image || !frame) {
        return null;
      }

      await loadImage(image);

      const imageHeight =
        image.getBoundingClientRect()
          .height;

      const frameHeight =
        frame.getBoundingClientRect()
          .height;

      const distance =
        Math.max(
          imageHeight - frameHeight,
          0
        );

      const duration =
        Math.min(
          Math.max(
            distance / 30,
            14
          ),
          28
        );

      return {
        image,
        distance,
        duration
      };
    };

  const startScrollPreview =
    async (card) => {
      if (reducedMotion.matches) {
        return;
      }

      const result =
        await prepareScrollPreview(
          card
        );

      if (
        !result ||
        result.distance <= 0
      ) {
        return;
      }

      const {
        image,
        distance,
        duration
      } = result;

      card.classList.add(
        'is-preview-active'
      );

      image.style.transition =
        `transform ${duration}s cubic-bezier(.25,.46,.45,.94)`;

      requestAnimationFrame(
        () => {
          image.style.transform =
            `translate3d(0,-${distance}px,0)`;
        }
      );
    };

  const stopScrollPreview = (
    card
  ) => {
    const image =
      card.querySelector(
        '[data-lp-showcase-scroll-image]'
      );

    card.classList.remove(
      'is-preview-active'
    );

    if (!image) {
      return;
    }

    image.style.transition =
      'transform 1600ms cubic-bezier(.25,.46,.45,.94)';

    image.style.transform =
      'translate3d(0,0,0)';
  };

  const showImagePreview =
    async (card) => {
      const preview =
        card.querySelector(
          '[data-lp-showcase-preview-image]'
        );

      if (!preview) {
        return;
      }

      await loadImage(preview);

      card.classList.add(
        'is-preview-active'
      );
    };

  const hideImagePreview = (
    card
  ) => {
    card.classList.remove(
      'is-preview-active'
    );
  };

  const setupScrollProgress = (
    card
  ) => {
    const frame =
      card.querySelector(
        '[data-lp-showcase-scroll-frame]'
      );

    const image =
      card.querySelector(
        '[data-lp-showcase-scroll-image]'
      );

    const progress =
      card.querySelector(
        '[data-lp-showcase-progress]'
      );

    if (
      !frame ||
      !image ||
      !progress
    ) {
      return;
    }

    let raf = null;

    const update = () => {
      raf = null;

      const maxScroll =
        Math.max(
          frame.scrollHeight -
          frame.clientHeight,
          0
        );

      const value =
        maxScroll > 0
          ? Math.min(
            Math.max(
              frame.scrollTop /
              maxScroll,
              0
            ),
            1
          )
          : 0;

      progress.style.transform =
        `scaleX(${value})`;

      if (frame.scrollTop >= 8) {
        card.classList.add(
          'is-touch-scrolled'
        );
      }
    };

    const schedule = () => {
      if (raf) {
        return;
      }

      raf =
        requestAnimationFrame(
          update
        );
    };

    frame.addEventListener(
      'scroll',
      schedule,
      { passive: true }
    );

    loadImage(image).then(() => {
      requestAnimationFrame(
        update
      );
    });
  };

  const setupSlider = (
    card
  ) => {
    const slider =
      card.querySelector(
        '[data-lp-showcase-slider]'
      );

    if (!slider) {
      return;
    }

    const track =
      slider.querySelector(
        '[data-lp-showcase-slider-track]'
      );

    const slides =
      Array.from(
        slider.querySelectorAll(
          '[data-lp-showcase-slide]'
        )
      );

    const prev =
      slider.querySelector(
        '[data-lp-showcase-slider-prev]'
      );

    const next =
      slider.querySelector(
        '[data-lp-showcase-slider-next]'
      );

    const dots =
      Array.from(
        card.querySelectorAll(
          '[data-lp-showcase-slider-dot]'
        )
      );

    if (
      !track ||
      slides.length === 0
    ) {
      return;
    }

    let activeIndex = 0;
    let raf = null;

    const loadSlide = (
      index
    ) => {
      const slide =
        slides[index];

      if (!slide) {
        return;
      }

      loadImage(
        slide.querySelector(
          '[data-lp-showcase-slider-image]'
        )
      );
    };

    const prewarmAround = (
      index
    ) => {
      loadSlide(index);

      if (
        index + 1 <
        slides.length
      ) {
        loadSlide(
          index + 1
        );
      }

      if (index > 0) {
        loadSlide(
          index - 1
        );
      }
    };

    const setActive = (
      index
    ) => {
      activeIndex =
        Math.min(
          Math.max(
            index,
            0
          ),
          slides.length - 1
        );

      dots.forEach(
        (dot, dotIndex) => {
          const active =
            dotIndex ===
            activeIndex;

          dot.classList.toggle(
            'is-active',
            active
          );

          dot.setAttribute(
            'aria-current',
            active
              ? 'true'
              : 'false'
          );
        }
      );

      if (prev) {
        prev.disabled =
          activeIndex === 0;
      }

      if (next) {
        next.disabled =
          activeIndex ===
          slides.length - 1;
      }

      prewarmAround(
        activeIndex
      );
    };

    const goTo = async (
      index
    ) => {
      const target =
        Math.min(
          Math.max(
            index,
            0
          ),
          slides.length - 1
        );

      loadSlide(target);

      const slide =
        slides[target];

      if (!slide) {
        return;
      }

      track.scrollTo({
        left:
          slide.offsetLeft,
        behavior:
          reducedMotion.matches
            ? 'auto'
            : 'smooth'
      });

      setActive(target);
    };

    const syncFromScroll =
      () => {
        raf = null;

        if (
          track.clientWidth <= 0
        ) {
          return;
        }

        const index =
          Math.round(
            track.scrollLeft /
            track.clientWidth
          );

        if (
          index !==
          activeIndex
        ) {
          setActive(index);
        }
      };

    track.addEventListener(
      'scroll',
      () => {
        if (raf) {
          return;
        }

        raf =
          requestAnimationFrame(
            syncFromScroll
          );
      },
      {
        passive: true
      }
    );

    track.addEventListener(
      'pointerdown',
      () => {
        prewarmAround(
          activeIndex
        );
      },
      {
        passive: true,
        once: true
      }
    );

    track.addEventListener(
      'touchstart',
      () => {
        prewarmAround(
          activeIndex
        );
      },
      {
        passive: true,
        once: true
      }
    );

    prev?.addEventListener(
      'click',
      () => {
        goTo(
          activeIndex - 1
        );
      }
    );

    next?.addEventListener(
      'click',
      () => {
        goTo(
          activeIndex + 1
        );
      }
    );

    dots.forEach(
      (dot) => {
        dot.addEventListener(
          'click',
          () => {
            goTo(
              Number(
                dot.dataset
                  .slideIndex
              )
            );
          }
        );
      }
    );

    if (
      finePointer.matches
    ) {
      slider.addEventListener(
        'pointerenter',
        () => {
          prewarmAround(
            activeIndex
          );
        },
        {
          passive: true,
          once: true
        }
      );
    }

    setActive(0);
  };

  const initShowcase = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-showcase]:not([data-lp-showcase-ready="true"])'
      )
      .forEach(
        (section) => {
          section.dataset
            .lpShowcaseReady =
            'true';

          const cards =
            Array.from(
              section.querySelectorAll(
                '[data-lp-showcase-card]'
              )
            );

          const filters =
            Array.from(
              section.querySelectorAll(
                '[data-lp-showcase-filter]'
              )
            );

          const reveals =
            Array.from(
              section.querySelectorAll(
                '[data-lp-showcase-reveal]'
              )
            );

          if (
            'IntersectionObserver'
            in window
          ) {
            const touchObserver =
              new IntersectionObserver(
                (
                  entries,
                  observer
                ) => {
                  entries.forEach(
                    (entry) => {
                      if (
                        !entry
                          .isIntersecting
                      ) {
                        return;
                      }

                      const card =
                        entry.target;

                      if (
                        !finePointer.matches &&
                        card.dataset
                          .previewMode ===
                        'hover_scroll'
                      ) {
                        loadImage(
                          card.querySelector(
                            '[data-lp-showcase-scroll-image]'
                          )
                        );
                      }

                      observer.unobserve(
                        card
                      );
                    }
                  );
                },
                {
                  rootMargin:
                    '300px 160px 300px 160px',
                  threshold: 0
                }
              );

            cards.forEach(
              (card) => {
                touchObserver.observe(
                  card
                );
              }
            );

            if (
              !reducedMotion.matches
            ) {
              const revealObserver =
                new IntersectionObserver(
                  (
                    entries,
                    observer
                  ) => {
                    entries.forEach(
                      (entry) => {
                        if (
                          !entry
                            .isIntersecting
                        ) {
                          return;
                        }

                        entry.target
                          .classList.add(
                            'is-visible'
                          );

                        observer.unobserve(
                          entry.target
                        );
                      }
                    );
                  },
                  {
                    rootMargin:
                      '0px 0px -7% 0px',
                    threshold: .06
                  }
                );

              reveals.forEach(
                (element) => {
                  revealObserver.observe(
                    element
                  );
                }
              );
            } else {
              reveals.forEach(
                (element) => {
                  element.classList.add(
                    'is-visible'
                  );
                }
              );
            }
          } else {
            reveals.forEach(
              (element) => {
                element.classList.add(
                  'is-visible'
                );
              }
            );
          }

          cards.forEach(
            (card) => {
              const mode =
                card.dataset
                  .previewMode;

              if (
                mode ===
                'hover_scroll'
              ) {
                if (
                  finePointer.matches
                ) {
                  let timer =
                    null;

                  card.addEventListener(
                    'pointerenter',
                    () => {
                      clearTimeout(
                        timer
                      );

                      timer =
                        window.setTimeout(
                          () => {
                            startScrollPreview(
                              card
                            );
                          },
                          120
                        );
                    },
                    {
                      passive: true
                    }
                  );

                  card.addEventListener(
                    'pointerleave',
                    () => {
                      clearTimeout(
                        timer
                      );

                      stopScrollPreview(
                        card
                      );
                    },
                    {
                      passive: true
                    }
                  );
                } else {
                  setupScrollProgress(
                    card
                  );
                }
              }

              if (
                mode ===
                'image_preview'
              ) {
                if (
                  finePointer.matches
                ) {
                  let timer =
                    null;

                  card.addEventListener(
                    'pointerenter',
                    () => {
                      clearTimeout(
                        timer
                      );

                      timer =
                        window.setTimeout(
                          () => {
                            showImagePreview(
                              card
                            );
                          },
                          90
                        );
                    },
                    {
                      passive: true
                    }
                  );

                  card.addEventListener(
                    'pointerleave',
                    () => {
                      clearTimeout(
                        timer
                      );

                      hideImagePreview(
                        card
                      );
                    },
                    {
                      passive: true
                    }
                  );
                } else {
                  const media =
                    card.querySelector(
                      '[data-lp-showcase-media]'
                    );

                  media?.addEventListener(
                    'click',
                    () => {
                      if (
                        card.classList
                          .contains(
                            'is-preview-active'
                          )
                      ) {
                        hideImagePreview(
                          card
                        );
                      } else {
                        showImagePreview(
                          card
                        );
                      }
                    }
                  );
                }
              }

              if (
                mode ===
                'video_preview'
              ) {
                if (
                  finePointer.matches
                ) {
                  let timer =
                    null;

                  card.addEventListener(
                    'pointerenter',
                    () => {
                      clearTimeout(
                        timer
                      );

                      timer =
                        window.setTimeout(
                          () => {
                            playVideo(
                              card
                            );
                          },
                          120
                        );
                    },
                    {
                      passive: true
                    }
                  );

                  card.addEventListener(
                    'pointerleave',
                    () => {
                      clearTimeout(
                        timer
                      );

                      stopVideo(
                        card
                      );
                    },
                    {
                      passive: true
                    }
                  );
                }

                const button =
                  card.querySelector(
                    '[data-lp-showcase-play]'
                  );

                button?.addEventListener(
                  'click',
                  (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    playVideo(
                      card
                    );
                  }
                );
              }

              if (
                mode ===
                'image_slider'
              ) {
                setupSlider(
                  card
                );
              }
            }
          );

          const applyFilter = (
            key
          ) => {
            filters.forEach(
              (button) => {
                const active =
                  button.dataset
                    .lpShowcaseFilter ===
                  key;

                button.classList.toggle(
                  'is-active',
                  active
                );

                button.setAttribute(
                  'aria-pressed',
                  active
                    ? 'true'
                    : 'false'
                );
              }
            );

            cards.forEach(
              (card) => {
                const cardFilters =
                  card.dataset.filters
                    ?.split('|')
                    .filter(Boolean) ||
                  [];

                const matches =
                  key === 'all' ||
                  cardFilters.includes(
                    key
                  );

                if (!matches) {
                  stopVideo(card);
                  stopScrollPreview(
                    card
                  );
                  hideImagePreview(
                    card
                  );
                }

                card.hidden =
                  !matches;
              }
            );
          };

          filters.forEach(
            (button) => {
              button.addEventListener(
                'click',
                () => {
                  applyFilter(
                    button.dataset
                      .lpShowcaseFilter
                  );
                }
              );
            }
          );
        }
      );
  };

  initShowcase();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initShowcase(
        event.target
      );
    }
  );

  document.addEventListener(
    'visibilitychange',
    () => {
      if (!document.hidden) {
        return;
      }

      document
        .querySelectorAll(
          '[data-lp-showcase-video]'
        )
        .forEach(
          (video) => {
            video.pause();
          }
        );
    }
  );
})();









































(() => {
  const roots = document.querySelectorAll(
    '[data-lp-lead-form]:not([data-lp-lead-form-ready="true"])'
  );

  if (!roots.length) return;

  const fallbackCountries = [
    ['IN', 'India', '+91'],
    ['US', 'United States', '+1'],
    ['GB', 'United Kingdom', '+44'],
    ['AU', 'Australia', '+61'],
    ['AE', 'United Arab Emirates', '+971'],
    ['CA', 'Canada', '+1'],
    ['ZA', 'South Africa', '+27'],
    ['SG', 'Singapore', '+65'],
    ['NZ', 'New Zealand', '+64'],
    ['DE', 'Germany', '+49'],
    ['FR', 'France', '+33'],
    ['NL', 'Netherlands', '+31'],
    ['IE', 'Ireland', '+353'],
    ['IT', 'Italy', '+39'],
    ['ES', 'Spain', '+34'],
    ['PT', 'Portugal', '+351'],
    ['CH', 'Switzerland', '+41'],
    ['AT', 'Austria', '+43'],
    ['BE', 'Belgium', '+32'],
    ['SE', 'Sweden', '+46'],
    ['NO', 'Norway', '+47'],
    ['DK', 'Denmark', '+45'],
    ['FI', 'Finland', '+358'],
    ['PL', 'Poland', '+48'],
    ['CZ', 'Czechia', '+420'],
    ['TR', 'Türkiye', '+90'],
    ['SA', 'Saudi Arabia', '+966'],
    ['QA', 'Qatar', '+974'],
    ['KW', 'Kuwait', '+965'],
    ['OM', 'Oman', '+968'],
    ['BH', 'Bahrain', '+973'],
    ['JP', 'Japan', '+81'],
    ['KR', 'South Korea', '+82'],
    ['CN', 'China', '+86'],
    ['HK', 'Hong Kong', '+852'],
    ['MY', 'Malaysia', '+60'],
    ['ID', 'Indonesia', '+62'],
    ['TH', 'Thailand', '+66'],
    ['PH', 'Philippines', '+63'],
    ['VN', 'Vietnam', '+84'],
    ['BD', 'Bangladesh', '+880'],
    ['PK', 'Pakistan', '+92'],
    ['LK', 'Sri Lanka', '+94'],
    ['NP', 'Nepal', '+977'],
    ['BR', 'Brazil', '+55'],
    ['MX', 'Mexico', '+52'],
    ['AR', 'Argentina', '+54'],
    ['CL', 'Chile', '+56'],
    ['CO', 'Colombia', '+57'],
    ['PE', 'Peru', '+51']
  ];

  const noticeIcons = {
    error: `
      <svg viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
        <path d="M10 6.4v4.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="10" cy="13.7" r=".8" fill="currentColor"/>
      </svg>
    `,
    info: `
      <svg viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
        <path d="M10 9.2v4.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="10" cy="6.6" r=".8" fill="currentColor"/>
      </svg>
    `
  };

  const flagFromCountry = (country) => {
    if (!country || country.length !== 2) return '🌐';

    return country
      .toUpperCase()
      .replace(
        /./g,
        (character) =>
          String.fromCodePoint(
            127397 + character.charCodeAt()
          )
      );
  };

  const normalizeUrl = (value) => {
    const clean = String(value || '').trim();

    if (!clean) return '';

    return /^https?:\/\//i.test(clean)
      ? clean
      : `https://${clean}`;
  };

  const parsePublicUrl = (value) => {
    try {
      const url = new URL(
        normalizeUrl(value)
      );

      if (
        url.protocol !== 'https:' &&
        url.protocol !== 'http:'
      ) {
        return null;
      }

      const hostname = url.hostname
        .toLowerCase()
        .replace(/\.$/, '');

      if (
        !hostname ||
        hostname === 'localhost' ||
        hostname.endsWith('.local') ||
        hostname.endsWith('.test') ||
        hostname.endsWith('.example') ||
        /^\d{1,3}(?:\.\d{1,3}){3}$/.test(hostname) ||
        hostname.includes(':')
      ) {
        return null;
      }

      const parts = hostname.split('.');

      if (parts.length < 2) return null;

      const tld = parts[parts.length - 1];

      if (!/^[a-z]{2,24}$/i.test(tld)) {
        return null;
      }

      return url.toString();
    } catch (error) {
      return null;
    }
  };

  const tracking = () => {
    const params = new URLSearchParams(
      location.search
    );

    return {
      page_url: location.href,
      page_path: location.pathname,
      referrer: document.referrer || '',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      utm_term: params.get('utm_term') || '',
      gclid: params.get('gclid') || '',
      fbclid: params.get('fbclid') || ''
    };
  };

  roots.forEach((root) => {
    root.dataset.lpLeadFormReady = 'true';

    const form = root.querySelector('[data-lp-lead-form-element]');
    const submit = root.querySelector('[data-lp-lead-submit]');
    const submitText = root.querySelector('[data-lp-lead-submit-text]');
    const submitLoader = root.querySelector('[data-lp-lead-submit-loader]');
    const notice = root.querySelector('[data-lp-lead-form-notice]');
    const noticeIcon = root.querySelector('[data-lp-lead-form-notice-icon]');
    const noticeText = root.querySelector('[data-lp-lead-form-notice-text]');
    const success = root.querySelector('[data-lp-lead-success]');
    const whatsappLink = root.querySelector('[data-lp-lead-whatsapp]');
    const countryOpen = root.querySelector('[data-lp-lead-country-open]');
    const countryPicker = root.querySelector('[data-lp-lead-country-picker]');
    const countryClose = root.querySelector('[data-lp-lead-country-close]');
    const countrySearch = root.querySelector('[data-lp-lead-country-search]');
    const countryList = root.querySelector('[data-lp-lead-country-list]');
    const countryEmpty = root.querySelector('[data-lp-lead-country-empty]');
    const countryFlag = root.querySelector('[data-lp-lead-country-flag]');
    const countryCode = root.querySelector('[data-lp-lead-country-code]');
    const countryInput = root.querySelector('[data-lp-lead-country]');
    const callingCodeInput = root.querySelector('[data-lp-lead-calling-code]');
    const phoneInput = root.querySelector('[data-lp-lead-phone]');

    if (!form || !submit) return;

    const apiBase = (root.dataset.apiBase || '').replace(/\/$/, '');
    const previewMode = root.dataset.previewMode === 'true';
    const backendEnabled = Boolean(apiBase) && !previewMode;
    const source = root.dataset.formSource || 'contact-page';
    const businessWhatsapp = (root.dataset.whatsappNumber || '').replace(/\D/g, '');

    let countries = fallbackCountries.map(
      ([country, name, callingCode]) => ({
        country,
        name,
        calling_code: callingCode
      })
    );

    const setNotice = (type = '', message = '') => {
      if (!notice || !noticeIcon || !noticeText) return;

      if (!message) {
        notice.hidden = true;
        noticeIcon.innerHTML = '';
        noticeText.textContent = '';
        return;
      }

      noticeIcon.innerHTML = noticeIcons[type] || noticeIcons.info;
      noticeText.textContent = message;
      notice.hidden = false;
    };

    const fieldMessage = (field, message = '') => {
      if (!field) return;

      const messageBox = field.querySelector('[data-lp-field-message]');

      field.classList.toggle('is-error', Boolean(message));

      if (!messageBox) return;

      if (!message) {
        messageBox.hidden = true;
        messageBox.innerHTML = '';
        return;
      }

      messageBox.hidden = false;
      messageBox.innerHTML = `${noticeIcons.error}<span></span>`;
      messageBox.querySelector('span').textContent = message;
    };

    const clearErrors = () => {
      setNotice();
      form.querySelectorAll('[data-lp-lead-field]').forEach((field) => {
        fieldMessage(field);
      });
    };

    const setLoading = (loading) => {
      submit.disabled = loading;
      submit.classList.toggle('is-loading', loading);

      if (submitText) submitText.hidden = loading;
      if (submitLoader) submitLoader.hidden = !loading;

      submit.setAttribute('aria-busy', loading ? 'true' : 'false');
    };

    const updateCountryUI = (country, callingCode) => {
      if (countryFlag) countryFlag.textContent = flagFromCountry(country);
      if (countryCode) countryCode.textContent = callingCode;
      if (countryInput) countryInput.value = country;
      if (callingCodeInput) callingCodeInput.value = callingCode;
    };

    const renderCountries = (query = '') => {
      if (!countryList || !countryEmpty) return;

      const normalized = query.trim().toLowerCase();

      const filtered = countries.filter((item) => {
        if (!normalized) return true;

        return (
          item.name.toLowerCase().includes(normalized) ||
          item.country.toLowerCase().includes(normalized) ||
          item.calling_code.replace(/\s/g, '').includes(normalized.replace(/\s/g, ''))
        );
      });

      const fragment = document.createDocumentFragment();

      filtered.forEach((item) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'lp-lead-form__country-item';
        button.setAttribute('role', 'option');
        button.dataset.country = item.country;
        button.dataset.countryName = item.name;
        button.dataset.callingCode = item.calling_code;
        button.innerHTML = `
          <span class="lp-lead-form__country-item-flag">${flagFromCountry(item.country)}</span>
          <span class="lp-lead-form__country-item-name"></span>
          <span class="lp-lead-form__country-item-code"></span>
        `;
        button.querySelector('.lp-lead-form__country-item-name').textContent = item.name;
        button.querySelector('.lp-lead-form__country-item-code').textContent = item.calling_code;
        fragment.appendChild(button);
      });

      countryList.replaceChildren(fragment);
      countryEmpty.hidden = filtered.length > 0;
    };

    const loadCountries = async () => {
      if (!backendEnabled) return;

      try {
        const response = await fetch(`${apiBase}/v1/meta/countries`, {
          method: 'GET',
          credentials: 'omit'
        });

        if (!response.ok) return;

        const data = await response.json();

        if (Array.isArray(data.countries) && data.countries.length) {
          countries = data.countries;
        }
      } catch (error) { }
    };

    const openCountryPicker = async () => {
      if (!countryPicker) return;

      countryPicker.hidden = false;
      countryOpen?.setAttribute('aria-expanded', 'true');

      if (countrySearch) countrySearch.value = '';

      renderCountries();
      await loadCountries();
      renderCountries();

      window.setTimeout(() => {
        countrySearch?.focus({ preventScroll: true });
      }, 20);
    };

    const closeCountryPicker = () => {
      if (!countryPicker) return;

      countryPicker.hidden = true;
      countryOpen?.setAttribute('aria-expanded', 'false');
    };

    const validateField = (input) => {
      const field = input.closest('[data-lp-lead-field]');
      const required = input.dataset.required === 'true';
      const value = input.value.trim();

      if (required && !value) {
        return { field, message: 'This field is required.' };
      }

      if (!value) return { field, message: '' };

      if (input.name === 'first_name') {
        if (
          value.length < 2 ||
          value.length > 60 ||
          !/^[\p{L}\p{M} .'-]+$/u.test(value)
        ) {
          return { field, message: 'Please enter a valid first name.' };
        }
      }

      if (input.name === 'last_name') {
        if (
          value.length > 60 ||
          !/^[\p{L}\p{M} .'-]+$/u.test(value)
        ) {
          return { field, message: 'Please enter a valid last name.' };
        }
      }

      if (input.name === 'email') {
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        if (!valid) return { field, message: 'Please enter a valid email address.' };
      }

      if (input.name === 'phone_local') {
        const digits = value.replace(/\D/g, '');
        if (digits.length < 6 || digits.length > 14) {
          return { field, message: 'Please enter a valid phone or WhatsApp number.' };
        }
      }

      if (input.name === 'url') {
        if (!parsePublicUrl(value)) {
          return { field, message: 'Please enter a valid public website or social profile link.' };
        }
      }

      if (input.name === 'message') {
        if (value.length < 10) {
          return { field, message: 'Please add a little more detail so we can understand your enquiry.' };
        }

        if (value.length > 2000) {
          return { field, message: 'Please keep your message under 2,000 characters.' };
        }
      }

      return { field, message: '' };
    };

    const validateForm = () => {
      clearErrors();

      const inputs = [...form.querySelectorAll('[data-lp-lead-input]')];
      let firstInvalid = null;

      inputs.forEach((input) => {
        const result = validateField(input);
        fieldMessage(result.field, result.message);

        if (result.message && !firstInvalid) {
          firstInvalid = input;
        }
      });

      if (firstInvalid) {
        firstInvalid.focus();
        setNotice('error', 'Please check the highlighted fields and try again.');
        return false;
      }

      return true;
    };

    const payload = () => {
      const data = new FormData(form);
      const localPhone = String(data.get('phone_local') || '').replace(/\D/g, '');
      const callingCode = String(data.get('calling_code') || '');
      const urlValue = String(data.get('url') || '').trim();

      return {
        first_name: String(data.get('first_name') || '').trim(),
        last_name: String(data.get('last_name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        country: String(data.get('country') || '').trim(),
        calling_code: callingCode,
        phone: localPhone ? `${callingCode}${localPhone}` : '',
        company: String(data.get('company') || '').trim(),
        url: urlValue ? normalizeUrl(urlValue) : '',
        message: String(data.get('message') || '').trim(),
        source,
        source_page: String(data.get('source_page') || ''),
        section_id: String(data.get('section_id') || ''),
        ...tracking()
      };
    };

    const showSuccess = (data) => {
      form.hidden = true;

      if (success) {
        success.hidden = false;
        success.focus({ preventScroll: true });
      }

      if (whatsappLink && businessWhatsapp) {
        const message = `Hi Liquifyplus, I just sent a contact enquiry${data.first_name ? ` as ${data.first_name}` : ''
          }.`;

        whatsappLink.href = `https://wa.me/${businessWhatsapp}?text=${encodeURIComponent(message)}`;
      }

      root.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
    };

    phoneInput?.addEventListener('input', () => {
      const digits = phoneInput.value.replace(/\D/g, '');
      phoneInput.value = digits.slice(0, 14);
      fieldMessage(phoneInput.closest('[data-lp-lead-field]'));
    });

    form.querySelectorAll('[data-lp-lead-input]').forEach((input) => {
      input.addEventListener('input', () => {
        fieldMessage(input.closest('[data-lp-lead-field]'));
        setNotice();
      });

      input.addEventListener('blur', () => {
        const result = validateField(input);
        fieldMessage(result.field, result.message);
      });
    });

    countryOpen?.addEventListener('click', openCountryPicker);
    countryClose?.addEventListener('click', closeCountryPicker);

    countrySearch?.addEventListener('input', () => {
      renderCountries(countrySearch.value);
    });

    countryList?.addEventListener('click', (event) => {
      const item = event.target.closest('.lp-lead-form__country-item');
      if (!item) return;

      updateCountryUI(item.dataset.country, item.dataset.callingCode);
      closeCountryPicker();
      phoneInput?.focus({ preventScroll: true });
    });

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (
          countryPicker?.hidden ||
          countryPicker?.contains(event.target) ||
          countryOpen?.contains(event.target)
        ) {
          return;
        }

        closeCountryPicker();
      },
      { passive: true }
    );

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (form.querySelector('[data-lp-lead-honeypot]')?.value) return;
      if (!validateForm()) return;

      const data = payload();

      setLoading(true);
      setNotice('info', backendEnabled ? 'Sending your enquiry…' : 'Previewing your completed enquiry…');

      try {
        if (backendEnabled) {
          const response = await fetch(`${apiBase}/v1/contact`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'omit',
            body: JSON.stringify(data)
          });

          const result = await response.json().catch(() => ({}));

          if (!response.ok) {
            throw new Error(result.message || 'We could not send your enquiry. Please try again.');
          }
        } else {
          console.info(
            '[Liquifyplus Contact Form] Frontend preview mode: enquiry was not sent to the server.',
            data
          );

          await new Promise((resolve) => setTimeout(resolve, 450));
        }

        setNotice();
        showSuccess(data);
      } catch (error) {
        setNotice('error', error.message || 'We could not send your enquiry. Please try again.');
      } finally {
        setLoading(false);
      }
    });

    updateCountryUI('IN', '+91');
  });
})();
















































(() => {
  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const desktopPointer =
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

  const initCaseStudyShowcase = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-case-showcase]:not([data-lp-case-showcase-ready="true"])'
      )
      .forEach((section) => {
        const track =
          section.querySelector(
            '[data-lp-case-showcase-track]'
          );

        if (!track) {
          return;
        }

        section.dataset
          .lpCaseShowcaseReady =
          'true';

        const items =
          Array.from(
            section.querySelectorAll(
              '[data-lp-case-showcase-item]'
            )
          );

        if (!items.length) {
          return;
        }

        const videos =
          Array.from(
            section.querySelectorAll(
              '[data-lp-case-showcase-video]'
            )
          );


        /* --------------------------------
           Media loading state
        -------------------------------- */

        const markLoaded = (
          item
        ) => {
          item.classList.add(
            'is-loaded'
          );
        };


        items.forEach((item) => {
          const image =
            item.querySelector(
              '.lp-case-media__image'
            );

          const poster =
            item.querySelector(
              '.lp-case-media__poster'
            );

          if (image) {
            const imageReady = () => {
              markLoaded(item);
            };

            if (
              image.complete &&
              image.naturalWidth > 0
            ) {
              imageReady();
            } else {
              image.addEventListener(
                'load',
                imageReady,
                {
                  once: true
                }
              );

              image.addEventListener(
                'error',
                imageReady,
                {
                  once: true
                }
              );
            }
          }


          if (poster) {
            const posterReady = () => {
              markLoaded(item);
            };

            if (
              poster.complete &&
              poster.naturalWidth > 0
            ) {
              posterReady();
            } else {
              poster.addEventListener(
                'load',
                posterReady,
                {
                  once: true
                }
              );

              poster.addEventListener(
                'error',
                posterReady,
                {
                  once: true
                }
              );
            }
          }


          if (!image && !poster) {
            const video =
              item.querySelector(
                '[data-lp-case-showcase-video]'
              );

            if (!video) {
              markLoaded(item);
            }
          }
        });


        /* --------------------------------
           Lazy video loading
        -------------------------------- */

        const loadVideo = (
          video
        ) => {
          if (
            !video ||
            video.dataset
              .lpCaseVideoLoaded ===
            'true'
          ) {
            return;
          }

          const source =
            video.dataset.videoSrc;

          if (!source) {
            return;
          }

          video.dataset
            .lpCaseVideoLoaded =
            'true';

          video.muted = true;
          video.loop = true;
          video.playsInline = true;

          video.src = source;

          video.load();
        };


        const showVideo = (
          video
        ) => {
          const item =
            video.closest(
              '[data-lp-case-showcase-item]'
            );

          if (!item) {
            return;
          }

          item.classList.add(
            'is-video-ready',
            'is-loaded'
          );
        };


  
const playVideo =
  async (
    video
  ) => {
    if (
      !video ||
      reducedMotion.matches ||
      document.hidden
    ) {
      return;
    }

    loadVideo(video);

    if (!video.src) {
      return;
    }

    try {
      await video.play();
    } catch (error) {
      if (
        error.name !== 'AbortError'
      ) {
        console.warn(
          'LP Case Study Showcase playback failed:',
          error
        );
      }
    }
  };



        const pauseVideo = (
          video
        ) => {
          if (!video) {
            return;
          }

          video.pause();
        };


        videos.forEach(
          (video) => {
            video.muted = true;
            video.loop = true;
            video.playsInline = true;

            const ready = () => {
              showVideo(video);
            };

            video.addEventListener(
              'loadeddata',
              ready
            );

            video.addEventListener(
              'canplay',
              ready
            );

            video.addEventListener(
              'error',
              () => {
                const item =
                  video.closest(
                    '[data-lp-case-showcase-item]'
                  );

                item?.classList.add(
                  'is-loaded'
                );
              },
              {
                once: true
              }
            );
          }
        );


        /* --------------------------------
           Preload near viewport
        -------------------------------- */

        if (
          'IntersectionObserver' in
          window
        ) {
          const preloadObserver =
            new IntersectionObserver(
              (
                entries,
                observer
              ) => {
                entries.forEach(
                  (entry) => {
                    if (
                      !entry.isIntersecting
                    ) {
                      return;
                    }

                    const video =
                      entry.target
                        .querySelector(
                          '[data-lp-case-showcase-video]'
                        );

                    if (video) {
                      loadVideo(
                        video
                      );
                    }

                    observer.unobserve(
                      entry.target
                    );
                  }
                );
              },
              {
                root: null,

                rootMargin:
                  '300px 160px 300px 160px',

                threshold: 0
              }
            );


          items.forEach(
            (item) => {
              preloadObserver.observe(
                item
              );
            }
          );


          /* ------------------------------
             Autoplay only while visible
          ------------------------------ */

          const playbackObserver =
            new IntersectionObserver(
              (entries) => {
                entries.forEach(
                  (entry) => {
                    const video =
                      entry.target
                        .querySelector(
                          '[data-lp-case-showcase-video]'
                        );

                    if (!video) {
                      return;
                    }

                   
const shouldPlay =
  entry.isIntersecting &&
  entry.intersectionRatio > 0;

video.dataset
  .lpCaseVideoVisible =
  shouldPlay
    ? 'true'
    : 'false';


                    if (shouldPlay) {
                      playVideo(
                        video
                      );

                      return;
                    }

                    pauseVideo(
                      video
                    );
                  }
                );
              },
              {
                root: null,

                threshold: [
                  0,
                  0.25,
                  0.45,
                  0.7
                ]
              }
            );


          items.forEach(
            (item) => {
              playbackObserver.observe(
                item
              );
            }
          );
       
} else {
  videos.forEach(
    (video) => {
      video.dataset
        .lpCaseVideoVisible =
        'true';

      loadVideo(video);
      playVideo(video);
    }
  );
}



        /* --------------------------------
           Desktop grab / drag
        -------------------------------- */

        let dragging = false;

        let pointerId = null;

        let startX = 0;

        let startScrollLeft = 0;

        let moved = false;

        let previousSnapType = '';


        const stopDrag = (
          event
        ) => {
          if (!dragging) {
            return;
          }

          if (
            event &&
            pointerId !== null &&
            event.pointerId !==
            pointerId
          ) {
            return;
          }

          dragging = false;

          track.classList.remove(
            'is-dragging'
          );

          track.style.scrollSnapType =
            previousSnapType;

          if (
            pointerId !== null &&
            track.hasPointerCapture?.(
              pointerId
            )
          ) {
            try {
              track.releasePointerCapture(
                pointerId
              );
            } catch (error) { }
          }

          pointerId = null;
        };


        track.addEventListener(
          'pointerdown',
          (event) => {
            if (
              !desktopPointer.matches
            ) {
              return;
            }

            if (
              event.pointerType !==
              'mouse' &&
              event.pointerType !==
              'pen'
            ) {
              return;
            }

            if (
              event.button !== 0
            ) {
              return;
            }

            dragging = true;

            moved = false;

            pointerId =
              event.pointerId;

            startX =
              event.clientX;

            startScrollLeft =
              track.scrollLeft;

            previousSnapType =
              track.style
                .scrollSnapType;

            track.style
              .scrollSnapType =
              'none';

            track.classList.add(
              'is-dragging'
            );

            try {
              track.setPointerCapture(
                event.pointerId
              );
            } catch (error) { }
          }
        );


        track.addEventListener(
          'pointermove',
          (event) => {
            if (
              !dragging ||
              event.pointerId !==
              pointerId
            ) {
              return;
            }

            const delta =
              event.clientX -
              startX;

            if (
              Math.abs(delta) >
              4
            ) {
              moved = true;
            }

            track.scrollLeft =
              startScrollLeft -
              delta;
          }
        );


        track.addEventListener(
          'pointerup',
          stopDrag
        );


        track.addEventListener(
          'pointercancel',
          stopDrag
        );


        track.addEventListener(
          'lostpointercapture',
          () => {
            if (dragging) {
              dragging =
                false;

              track.classList.remove(
                'is-dragging'
              );

              track.style
                .scrollSnapType =
                previousSnapType;

              pointerId =
                null;
            }
          }
        );


        /* --------------------------------
           Prevent accidental click
           after dragging
        -------------------------------- */

        track.addEventListener(
          'click',
          (event) => {
            if (!moved) {
              return;
            }

            event.preventDefault();

            event.stopPropagation();

            moved = false;
          },
          true
        );


        /* --------------------------------
           Prevent native media drag
        -------------------------------- */

        track
          .querySelectorAll(
            'img, video'
          )
          .forEach((media) => {
            media.addEventListener(
              'dragstart',
              (event) => {
                event.preventDefault();
              }
            );
          });
      });
  };


  initCaseStudyShowcase();


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initCaseStudyShowcase(
        event.target
      );
    }
  );



document.addEventListener(
  'visibilitychange',
  () => {
    document
      .querySelectorAll(
        '[data-lp-case-showcase-video]'
      )
      .forEach((video) => {
        if (document.hidden) {
          video.pause();
          return;
        }

        if (
          reducedMotion.matches ||
          video.dataset.lpCaseVideoVisible !==
            'true' ||
          video.dataset.lpCaseVideoLoaded !==
            'true'
        ) {
          return;
        }

        video.play().catch(
          (error) => {
            if (
              error.name !== 'AbortError'
            ) {
              console.warn(
                'LP Case Study Showcase resume failed:',
                error
              );
            }
          }
        );
      });
  }
);



})();


































































(() => {
  const initCaseStudyFigma = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-lp-case-figma]:not([data-lp-case-figma-ready="true"])'
      )
      .forEach((section) => {
        const preview =
          section.querySelector(
            '[data-lp-case-figma-preview]'
          );

        const launch =
          section.querySelector(
            '[data-lp-case-figma-launch]'
          );

        const embed =
          section.querySelector(
            '[data-lp-case-figma-embed]'
          );

        if (
          !preview ||
          !launch ||
          !embed
        ) {
          return;
        }

        section.dataset
          .lpCaseFigmaReady =
          'true';

        const previewImage =
          preview.querySelector(
            '.lp-case-figma__preview-image'
          );

        if (previewImage) {
          const markReady = () => {
            previewImage.classList.add(
              'is-loaded'
            );
          };

          if (
            previewImage.complete &&
            previewImage.naturalWidth > 0
          ) {
            markReady();
          } else {
            previewImage.addEventListener(
              'load',
              markReady,
              {
                once: true
              }
            );

            previewImage.addEventListener(
              'error',
              markReady,
              {
                once: true
              }
            );
          }
        }

        let iframeCreated = false;

        const loadFigma = () => {
          if (iframeCreated) {
            return;
          }

          const src =
            embed.dataset.figmaSrc;

          if (!src) {
            return;
          }

          iframeCreated = true;

          const iframe =
            document.createElement(
              'iframe'
            );

          iframe.className =
            'lp-case-figma__iframe';

          iframe.src = src;

          iframe.loading = 'lazy';

          iframe.allowFullscreen =
            true;

          iframe.referrerPolicy =
            'strict-origin-when-cross-origin';

          iframe.setAttribute(
            'title',
            'Interactive Figma project'
          );

          iframe.addEventListener(
            'load',
            () => {
              embed.classList.add(
                'is-loaded'
              );
            },
            {
              once: true
            }
          );

          preview.hidden = true;

          embed.hidden = false;

          embed.appendChild(
            iframe
          );
        };

        launch.addEventListener(
          'click',
          loadFigma
        );
      });
  };

  initCaseStudyFigma();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initCaseStudyFigma(
        event.target
      );
    }
  );
})();





















(() => {
  const serviceCopy = {
    'new-store': {
      urlLabel: 'Website or Instagram',
      urlPlaceholder: 'Website, Instagram or marketplace URL',
      urlOptional: true,
      questions: [
        {
          id: 'new_store_stage',
          label: 'Where are you right now?',
          placeholder: 'Select your current stage',
          options: [
            ['starting-new', 'Starting a new brand'],
            ['brand-exists', 'Brand already exists'],
            ['selling-offline', 'Selling offline'],
            ['marketplaces-social', 'Selling on marketplaces/social'],
            ['planning', 'Still planning']
          ]
        },
        {
          id: 'new_store_need',
          label: 'What do you need help with?',
          placeholder: 'Select what you need',
          options: [
            ['design', 'Store design'],
            ['development', 'Shopify development'],
            ['products', 'Product setup'],
            ['features', 'Custom features'],
            ['import', 'Product/data import'],
            ['not-sure', 'Not sure yet']
          ]
        }
      ]
    },

    migration: {
      urlLabel: 'Current website URL',
      urlPlaceholder: 'yourstore.com',
      questions: [
        {
          id: 'migration_platform',
          label: 'Current platform',
          placeholder: 'Select your platform',
          options: [
            ['woocommerce', 'WooCommerce'],
            ['magento', 'Magento'],
            ['wix', 'Wix'],
            ['squarespace', 'Squarespace'],
            ['bigcommerce', 'BigCommerce'],
            ['custom', 'Custom website'],
            ['other', 'Another platform']
          ]
        },
        {
          id: 'migration_design',
          label: 'What should happen to the design?',
          placeholder: 'Select an option',
          options: [
            ['keep-similar', 'Keep it similar'],
            ['improve', 'Improve it during migration'],
            ['redesign', 'Complete redesign'],
            ['not-sure', 'Not sure yet']
          ]
        }
      ]
    },

    redesign: {
      urlLabel: 'Shopify store URL',
      urlPlaceholder: 'yourstore.com',
      questions: [
        {
          id: 'redesign_reason',
          label: 'Main reason for redesign',
          placeholder: 'Select the main reason',
          options: [
            ['outdated', 'Store looks outdated'],
            ['hard-to-shop', 'Hard to shop'],
            ['brand-changed', 'Brand has changed'],
            ['low-conversion', 'Low conversion'],
            ['mobile', 'Mobile needs improvement'],
            ['multiple', 'More than one issue']
          ]
        },
        {
          id: 'redesign_scope',
          label: 'What do you want redesigned?',
          placeholder: 'Select the scope',
          options: [
            ['full-store', 'Full store'],
            ['homepage', 'Homepage'],
            ['product-pages', 'Product pages'],
            ['collection-pages', 'Collection pages'],
            ['cart', 'Cart'],
            ['key-pages', 'A few key pages'],
            ['not-sure', 'Not sure yet']
          ]
        }
      ]
    },

    'custom-development': {
      urlLabel: 'Shopify store URL',
      urlPlaceholder: 'yourstore.com',
      urlOptional: true,
      questions: [
        {
          id: 'development_type',
          label: 'Type of development',
          placeholder: 'Select development type',
          options: [
            ['custom-theme', 'Custom theme development'],
            ['figma-shopify', 'Figma to Shopify'],
            ['custom-sections', 'Custom sections'],
            ['custom-pages', 'Custom pages/templates'],
            ['functions', 'Shopify Functions'],
            ['app-integration', 'App integration'],
            ['multiple', 'Multiple things'],
            ['not-sure', 'Not sure yet']
          ]
        },
        {
          id: 'development_design',
          label: 'Design status',
          placeholder: 'Select design status',
          options: [
            ['figma-ready', 'Figma is ready'],
            ['in-progress', 'Design is in progress'],
            ['need-design', 'We need design too'],
            ['no-design', 'No design needed'],
            ['not-sure', 'Not sure yet']
          ]
        }
      ]
    },

    'custom-feature': {
      urlLabel: 'Shopify store URL',
      urlPlaceholder: 'yourstore.com',
      questions: [
        {
          id: 'feature_type',
          label: 'Feature you need',
          placeholder: 'Select feature type',
          options: [
            ['product-quiz', 'Product quiz'],
            ['product-finder', 'Product finder'],
            ['routine-builder', 'Routine builder'],
            ['shade-finder', 'Shade finder'],
            ['bundle-builder', 'Bundle builder'],
            ['custom-cart', 'Custom cart'],
            ['calculator', 'Calculator'],
            ['custom-app', 'Custom app'],
            ['other', 'Something else'],
            ['not-sure', 'Not sure yet']
          ]
        },
        {
          id: 'feature_stage',
          label: 'Current feature status',
          placeholder: 'Select current status',
          options: [
            ['fresh', 'Starting fresh'],
            ['improve', 'Existing feature needs improvement'],
            ['broken', 'Existing feature is broken'],
            ['not-sure', 'Not sure yet']
          ]
        }
      ]
    },

    'store-improvement': {
      urlLabel: 'Shopify store URL',
      urlPlaceholder: 'yourstore.com',
      questions: [
        {
          id: 'improvement_area',
          label: 'What do you want to improve?',
          placeholder: 'Select an area',
          options: [
            ['product-pages', 'Product pages'],
            ['discovery', 'Navigation & product discovery'],
            ['cart', 'Cart experience'],
            ['mobile', 'Mobile UX'],
            ['landing-pages', 'Landing pages'],
            ['speed', 'Store speed'],
            ['journey', 'Overall buying journey'],
            ['not-sure', 'Not sure yet']
          ]
        },
        {
          id: 'improvement_reason',
          label: 'Main reason',
          placeholder: 'Select the main reason',
          options: [
            ['low-conversion', 'Low conversion'],
            ['drop-off', 'Customers are dropping off'],
            ['mobile-weak', 'Mobile experience feels weak'],
            ['hard-to-use', 'Store is hard to use'],
            ['slow', 'Store is slow'],
            ['limited', 'Current setup feels limited'],
            ['multiple', 'More than one reason'],
            ['not-sure', 'Not sure yet']
          ]
        }
      ]
    },

    'store-rescue': {
      urlLabel: 'Shopify store URL',
      urlPlaceholder: 'yourstore.com',
      questions: [
        {
          id: 'rescue_issue',
          label: 'What is happening?',
          placeholder: 'Select the closest issue',
          options: [
            ['broken', 'Something is broken'],
            ['unfinished', 'Developer left it unfinished'],
            ['slow', 'Store is slow'],
            ['mobile', 'Mobile experience has issues'],
            ['apps-code', 'Apps/code are causing problems'],
            ['multiple', 'Multiple problems']
          ]
        },
        {
          id: 'rescue_impact',
          label: 'Is this stopping customers from buying?',
          placeholder: 'Select impact',
          options: [
            ['yes', 'Yes'],
            ['partly', 'Partly'],
            ['no', 'No'],
            ['not-sure', 'Not sure']
          ]
        }
      ]
    }
  };

  const countryNames = {
    IN: 'India',
    US: 'United States',
    GB: 'United Kingdom',
    AU: 'Australia',
    AE: 'United Arab Emirates',
    CA: 'Canada',
    ZA: 'South Africa',
    SG: 'Singapore'
  };

  const flagMarkup = (country) => {
    const flags = {
      IN: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="16" fill="#fff"/>
          <rect width="24" height="5.33" fill="#FF9933"/>
          <rect y="10.67" width="24" height="5.33" fill="#138808"/>
          <circle cx="12" cy="8" r="1.65" fill="none" stroke="#000080" stroke-width=".55"/>
          <circle cx="12" cy="8" r=".35" fill="#000080"/>
        </svg>
      `,

      US: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="16" fill="#fff"/>
          <path d="M0 0h24v2H0zm0 4h24v2H0zm0 4h24v2H0zm0 4h24v2H0z" fill="#B22234"/>
          <rect width="10" height="8.6" fill="#3C3B6E"/>
          <g fill="#fff">
            <circle cx="2" cy="2" r=".5"/>
            <circle cx="5" cy="2" r=".5"/>
            <circle cx="8" cy="2" r=".5"/>
            <circle cx="3.5" cy="4.3" r=".5"/>
            <circle cx="6.5" cy="4.3" r=".5"/>
            <circle cx="2" cy="6.5" r=".5"/>
            <circle cx="5" cy="6.5" r=".5"/>
            <circle cx="8" cy="6.5" r=".5"/>
          </g>
        </svg>
      `,

      GB: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="16" fill="#012169"/>
          <path d="M0 0 24 16M24 0 0 16" stroke="#fff" stroke-width="4"/>
          <path d="M0 0 24 16M24 0 0 16" stroke="#C8102E" stroke-width="1.7"/>
          <path d="M12 0v16M0 8h24" stroke="#fff" stroke-width="5"/>
          <path d="M12 0v16M0 8h24" stroke="#C8102E" stroke-width="2.6"/>
        </svg>
      `,

      AU: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="16" fill="#012169"/>
          <circle cx="17" cy="5" r="1" fill="#fff"/>
          <circle cx="19.5" cy="10.5" r=".8" fill="#fff"/>
          <circle cx="14" cy="11.5" r=".7" fill="#fff"/>
          <circle cx="20.5" cy="13.5" r=".55" fill="#fff"/>
          <rect width="11" height="8" fill="#012169"/>
          <path d="M0 0 11 8M11 0 0 8" stroke="#fff" stroke-width="2"/>
          <path d="M5.5 0v8M0 4h11" stroke="#fff" stroke-width="2.7"/>
          <path d="M5.5 0v8M0 4h11" stroke="#C8102E" stroke-width="1.4"/>
        </svg>
      `,

      AE: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="5.33" fill="#009639"/>
          <rect y="5.33" width="24" height="5.34" fill="#fff"/>
          <rect y="10.67" width="24" height="5.33" fill="#000"/>
          <rect width="6" height="16" fill="#CE1126"/>
        </svg>
      `,

      CA: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="16" fill="#fff"/>
          <rect width="5" height="16" fill="#D80621"/>
          <rect x="19" width="5" height="16" fill="#D80621"/>
          <path d="m12 3 1 2 1.7-.7-.7 2 1.5 1-2 .5.4 2-1.9-1.1-1.9 1.1.4-2-2-.5 1.5-1-.7-2 1.7.7Z" fill="#D80621"/>
        </svg>
      `,

      ZA: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="8" fill="#DE3831"/>
          <rect y="8" width="24" height="8" fill="#002395"/>
          <path d="M0 0 10 8 0 16Z" fill="#000"/>
          <path d="m0 1.8 7.9 6.2L0 14.2" fill="none" stroke="#FFB612" stroke-width="2"/>
          <path d="m0 3 6.5 5L0 13" fill="none" stroke="#007A4D" stroke-width="4"/>
          <path d="M6 8h18" stroke="#fff" stroke-width="4"/>
          <path d="M6 8h18" stroke="#007A4D" stroke-width="2.4"/>
        </svg>
      `,

      SG: `
        <svg viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="8" fill="#EF3340"/>
          <rect y="8" width="24" height="8" fill="#fff"/>
          <circle cx="6" cy="4" r="2.4" fill="#fff"/>
          <circle cx="7" cy="4" r="2" fill="#EF3340"/>
          <circle cx="8.6" cy="2.3" r=".3" fill="#fff"/>
          <circle cx="9.3" cy="3.4" r=".3" fill="#fff"/>
          <circle cx="9" cy="4.8" r=".3" fill="#fff"/>
        </svg>
      `
    };

    return flags[country] || '';
  };

  const makeId = () =>
    window.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const cleanPhone = (value) =>
    String(value || '').replace(/\D/g, '');

  const normalizeUrl = (value) => {
    const clean =
      String(value || '').trim();

    if (!clean) {
      return '';
    }

    return /^https?:\/\//i.test(clean)
      ? clean
      : `https://${clean}`;
  };

  const validPublicUrl = (value) => {
    if (!value) return true;

    try {
      const url =
        new URL(
          normalizeUrl(value)
        );

      const host =
        url.hostname.toLowerCase();

      if (
        ![
          'http:',
          'https:'
        ].includes(url.protocol)
      ) {
        return false;
      }

      if (
        !host ||
        host === 'localhost' ||
        host.endsWith('.local') ||
        host.endsWith('.test') ||
        host.endsWith('.example')
      ) {
        return false;
      }

      if (
        /^\d{1,3}(?:\.\d{1,3}){3}$/.test(host) ||
        host.includes(':')
      ) {
        return false;
      }

      const parts =
        host.split('.');

      if (parts.length < 2) {
        return false;
      }

      return /^[a-z]{2,24}$/i.test(
        parts.at(-1)
      );
    } catch (_) {
      return false;
    }
  };

  const enhanceCountrySelect = (
    select
  ) => {
    if (
      !select ||
      select.dataset.lpCountryEnhanced ===
      'true'
    ) {
      return;
    }

    select.dataset.lpCountryEnhanced =
      'true';

    const wrapper =
      document.createElement('div');

    wrapper.className =
      'lp-service-country-picker';

    select.parentNode.insertBefore(
      wrapper,
      select
    );

    wrapper.appendChild(
      select
    );

    const trigger =
      document.createElement('button');

    trigger.type =
      'button';

    trigger.className =
      'lp-service-country-picker__trigger';

    trigger.setAttribute(
      'aria-haspopup',
      'listbox'
    );

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );

    const menu =
      document.createElement('div');

    menu.className =
      'lp-service-country-picker__menu';

    menu.hidden = true;

    menu.setAttribute(
      'role',
      'listbox'
    );

    wrapper.append(
      trigger,
      menu
    );

    const renderTrigger = () => {
      const option =
        select.selectedOptions[0];

      const country =
        option?.dataset.country ||
        'IN';

      trigger.innerHTML = `
        <span class="lp-service-country-picker__flag">
          ${flagMarkup(country)}
        </span>

        <span class="lp-service-country-picker__code">
          ${select.value}
        </span>

        <span
          class="lp-service-country-picker__chevron"
          aria-hidden="true"
        ></span>
      `;
    };

    [...select.options].forEach(
      (option, index) => {
        const country =
          option.dataset.country;

        const button =
          document.createElement('button');

        button.type =
          'button';

        button.className =
          'lp-service-country-picker__option';

        button.setAttribute(
          'role',
          'option'
        );

        const setSelectedState =
          () => {
            const selected =
              select.selectedIndex ===
              index;

            button.classList.toggle(
              'is-selected',
              selected
            );

            button.setAttribute(
              'aria-selected',
              selected
                ? 'true'
                : 'false'
            );
          };

        button.innerHTML = `
          <span class="lp-service-country-picker__flag">
            ${flagMarkup(country)}
          </span>

          <span>
            ${countryNames[country] || country}
          </span>

          <span class="lp-service-country-picker__option-code">
            ${option.value}
          </span>
        `;

        setSelectedState();

        button.addEventListener(
          'click',
          () => {
            select.selectedIndex =
              index;

            select.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );

            [
              ...menu.querySelectorAll(
                '.lp-service-country-picker__option'
              )
            ].forEach(
              (item, itemIndex) => {
                const selected =
                  itemIndex === index;

                item.classList.toggle(
                  'is-selected',
                  selected
                );

                item.setAttribute(
                  'aria-selected',
                  selected
                    ? 'true'
                    : 'false'
                );
              }
            );

            renderTrigger();
            wrapper.classList.add('is-ready');

            menu.hidden =
              true;

            trigger.setAttribute(
              'aria-expanded',
              'false'
            );

            trigger.focus();
          }
        );

        menu.appendChild(
          button
        );
      }
    );

    trigger.addEventListener(
      'click',
      () => {
        const opening =
          menu.hidden;

        menu.hidden =
          !opening;

        trigger.setAttribute(
          'aria-expanded',
          opening
            ? 'true'
            : 'false'
        );

        if (opening) {
          menu
            .querySelector(
              '.is-selected'
            )
            ?.focus();
        }
      }
    );

    wrapper.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape'
        ) {
          menu.hidden =
            true;

          trigger.setAttribute(
            'aria-expanded',
            'false'
          );

          trigger.focus();
        }
      }
    );

    document.addEventListener(
      'click',
      (event) => {
        if (
          wrapper.contains(
            event.target
          )
        ) {
          return;
        }

        menu.hidden =
          true;

        trigger.setAttribute(
          'aria-expanded',
          'false'
        );
      }
    );

    renderTrigger();
  };

  const initServiceHero = (
    root
  ) => {
    if (
      !root ||
      root.dataset.lpServiceHeroReady ===
      'true'
    ) {
      return;
    }

    root.dataset.lpServiceHeroReady =
      'true';

    const service =
      root.dataset.service ||
      'migration';

    const config =
      serviceCopy[service] ||
      serviceCopy.migration;

    const apiBase =
      String(
        root.dataset.apiBase ||
        ''
      ).replace(/\/$/, '');

    const previewMode =
      root.dataset.previewMode ===
      'true';

    const backendEnabled =
      Boolean(apiBase) &&
      !previewMode;

    const businessWhatsapp =
      cleanPhone(
        root.dataset.businessWhatsapp
      );

    const sourceContext =
      root.dataset.sourceContext ||
      'service-page-hero';

    const quickForm =
      root.querySelector(
        '[data-lp-service-quick-form]'
      );

    const quickCountry =
      root.querySelector(
        '[data-lp-service-quick-country]'
      );

    const quickPhone =
      root.querySelector(
        '[data-lp-service-quick-phone]'
      );

    const quickStatus =
      root.querySelector(
        '[data-lp-service-quick-status]'
      );

    const form =
      root.querySelector(
        '[data-lp-service-form]'
      );

    const formCard =
      root.querySelector(
        '[data-lp-service-form-card]'
      );

    const success =
      root.querySelector(
        '[data-lp-service-success]'
      );

    const projectFields =
      root.querySelector(
        '[data-lp-service-project-fields]'
      );

    const urlInput =
      root.querySelector(
        '[data-lp-service-url]'
      );

    const urlLabel =
      root.querySelector(
        '[data-lp-service-url-label]'
      );

    const formStatus =
      root.querySelector(
        '[data-lp-service-form-status]'
      );

    const countrySelect =
      root.querySelector(
        '[data-lp-service-country]'
      );

    const timelineSelect =
      form?.elements.timeline;

    const budgetSelect =
      form?.elements.budget;

    const steps =
      root.querySelector(
        '[data-lp-service-steps]'
      );

    const privacy =
      root.querySelector(
        '[data-lp-service-privacy]'
      );

    if (
      !quickForm ||
      !quickCountry ||
      !quickPhone ||
      !form ||
      !projectFields ||
      !urlInput ||
      !countrySelect ||
      !timelineSelect ||
      !budgetSelect ||
      !success
    ) {
      return;
    }

    const state = {
      sessionId:
        makeId(),

      leadId: '',
      leadToken: '',

      currentStep: 1,

      firstName: '',
      phone: '',
      email: '',
      url: '',

      timeline: '',
      budget: '',

      note: '',

      answers: {}
    };

    enhanceCountrySelect(
      quickCountry
    );

    enhanceCountrySelect(
      countrySelect
    );

    const tracking = () => {
      const params =
        new URLSearchParams(
          location.search
        );

      return {
        page_url:
          location.href,

        page_path:
          location.pathname,

        referrer:
          document.referrer || '',

        utm_source:
          params.get(
            'utm_source'
          ) || '',

        utm_medium:
          params.get(
            'utm_medium'
          ) || '',

        utm_campaign:
          params.get(
            'utm_campaign'
          ) || '',

        utm_content:
          params.get(
            'utm_content'
          ) || '',

        utm_term:
          params.get(
            'utm_term'
          ) || '',

        gclid:
          params.get(
            'gclid'
          ) || '',

        fbclid:
          params.get(
            'fbclid'
          ) || ''
      };
    };

    const payload = (
      source
    ) => ({
      session_id:
        state.sessionId,

      service,

      budget:
        state.budget,

      first_name:
        state.firstName,

      country:
        countrySelect
          .selectedOptions[0]
          ?.dataset.country ||
        'IN',

      calling_code:
        countrySelect.value,

      phone:
        state.phone,

      timeline:
        state.timeline,

      answers:
        state.answers,

      url:
        state.url,

      email:
        state.email,

      note:
        state.note,

      source,

      source_cta:
        source ===
          'service-hero-whatsapp'
          ? 'Chat on WhatsApp'
          : 'Service hero form',

      source_context:
        sourceContext,

      ...tracking()
    });

    const request = async (
      path,
      options = {}
    ) => {
      if (!backendEnabled) {
        return {
          preview: true
        };
      }

      const response =
        await fetch(
          `${apiBase}${path}`,
          {
            method:
              options.method ||
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              ...(state.leadToken
                ? {
                  'X-Lead-Token':
                    state.leadToken
                }
                : {})
            },

            body:
              options.body
                ? JSON.stringify(
                  options.body
                )
                : undefined,

            credentials:
              'omit',

            keepalive:
              Boolean(
                options.keepalive
              )
          }
        );

      const data =
        await response
          .json()
          .catch(
            () => ({})
          );

      if (!response.ok) {
        throw new Error(
          data.message ||
          'We could not save your enquiry. Please try again.'
        );
      }

      return data;
    };

    const startLead = async (
      source
    ) => {
      if (
        state.leadId ||
        !backendEnabled
      ) {
        return;
      }

      const result =
        await request(
          '/v1/leads/start',
          {
            body:
              payload(source)
          }
        );

      state.leadId =
        result.lead_id ||
        '';

      state.leadToken =
        result.token ||
        '';
    };

    const saveLead = async (
      source
    ) => {
      if (
        !state.leadId ||
        !backendEnabled
      ) {
        return;
      }

      await request(
        `/v1/leads/${encodeURIComponent(
          state.leadId
        )}`,
        {
          method: 'PATCH',

          body:
            payload(source)
        }
      );
    };

    const completeLead =
      async () => {
        if (!backendEnabled) {
          return;
        }

        if (!state.leadId) {
          await startLead(
            'service-hero-form'
          );
        }

        await request(
          `/v1/leads/${encodeURIComponent(
            state.leadId
          )}/complete`,
          {
            body:
              payload(
                'service-hero-form'
              )
          }
        );
      };

    const setStatus = (
      element,
      message,
      error = false
    ) => {
      if (!element) return;

      element.textContent =
        message || '';

      element.classList.toggle(
        'is-error',
        Boolean(error)
      );
    };

    const createProjectSelect = (
      question
    ) => {
      const field =
        document.createElement(
          'div'
        );

      field.className =
        'lp-service-hero__field';

      const label =
        document.createElement(
          'label'
        );

      const selectId =
        `LPServiceProject-${question.id}-${makeId()}`;

      label.htmlFor =
        selectId;

      label.innerHTML =
        `${question.label} <span aria-hidden="true">*</span>`;

      const wrap =
        document.createElement(
          'div'
        );

      wrap.className =
        'lp-service-hero__select-wrap';

      const select =
        document.createElement(
          'select'
        );

      select.id =
        selectId;

      select.dataset.lpProjectSelect =
        question.id;

      select.required =
        true;

      const placeholder =
        document.createElement(
          'option'
        );

      placeholder.value =
        '';

      placeholder.textContent =
        question.placeholder;

      select.appendChild(
        placeholder
      );

      question.options.forEach(
        ([value, optionLabel]) => {
          const option =
            document.createElement(
              'option'
            );

          option.value =
            value;

          option.textContent =
            optionLabel;

          select.appendChild(
            option
          );
        }
      );

      select.addEventListener(
        'change',
        () => {
          state.answers[
            question.id
          ] = select.value;
        }
      );

      wrap.appendChild(
        select
      );

      field.append(
        label,
        wrap
      );

      projectFields.appendChild(
        field
      );
    };

    projectFields.innerHTML =
      '';

    config.questions.forEach(
      createProjectSelect
    );

    urlLabel.textContent =
      config.urlLabel ||
      'Store URL';

    urlInput.placeholder =
      config.urlPlaceholder ||
      'yourstore.com';

    if (config.urlOptional) {
      const optional =
        document.createElement(
          'span'
        );

      optional.className =
        'lp-service-hero__optional';

      optional.textContent =
        ' Optional';

      urlLabel.appendChild(
        optional
      );
    }

    timelineSelect.addEventListener(
      'change',
      () => {
        state.timeline =
          timelineSelect.value;
      }
    );

    budgetSelect.addEventListener(
      'change',
      () => {
        state.budget =
          budgetSelect.value;
      }
    );

    const showStep = (
      step
    ) => {
      state.currentStep =
        step;

      root
        .querySelectorAll(
          '[data-lp-service-panel]'
        )
        .forEach(
          (panel) => {
            const active =
              Number(
                panel.dataset
                  .lpServicePanel
              ) === step;

            panel.hidden =
              !active;

            panel.classList.toggle(
              'is-active',
              active
            );
          }
        );

      root
        .querySelectorAll(
          '[data-lp-service-step-nav]'
        )
        .forEach(
          (nav) => {
            const navStep =
              Number(
                nav.dataset
                  .lpServiceStepNav
              );

            nav.classList.toggle(
              'is-active',
              navStep === step
            );

            nav.classList.toggle(
              'is-complete',
              navStep < step
            );

            if (
              navStep === step
            ) {
              nav.setAttribute(
                'aria-current',
                'step'
              );
            } else {
              nav.removeAttribute(
                'aria-current'
              );
            }
          }
        );

      setStatus(
        formStatus,
        ''
      );

      if (
        window.innerWidth <= 767 &&
        formCard
      ) {
        formCard.scrollIntoView({
          behavior:
            window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches
              ? 'auto'
              : 'smooth',

          block:
            'start'
        });
      }
    };

    const validateStep1 =
      () => {
        const name =
          form.elements
            .first_name
            .value
            .trim();

        const local =
          cleanPhone(
            form.elements
              .phone
              .value
          );

        const email =
          form.elements
            .email
            .value
            .trim();

        if (
          name.length < 2
        ) {
          return 'Please enter your first name.';
        }

        if (
          local.length < 6 ||
          local.length > 14
        ) {
          return 'Please enter a valid WhatsApp number.';
        }

        if (
          email &&
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
            email
          )
        ) {
          return 'Please enter a valid email address.';
        }

        state.firstName =
          name;

        state.phone =
          `${countrySelect.value}${local}`;

        state.email =
          email;

        return '';
      };

    const validateStep2 =
      () => {
        const url =
          urlInput.value.trim();

        if (
          !config.urlOptional &&
          !url
        ) {
          return 'Please enter your store or website URL.';
        }

        if (
          url &&
          !validPublicUrl(url)
        ) {
          return 'Please enter a valid public website URL.';
        }

        const selects =
          [
            ...projectFields.querySelectorAll(
              '[data-lp-project-select]'
            )
          ];

        for (
          const select
          of selects
        ) {
          if (!select.value) {
            return 'Please complete the project details.';
          }

          state.answers[
            select.dataset.lpProjectSelect
          ] = select.value;
        }

        state.url =
          url
            ? normalizeUrl(
              url
            )
            : '';

        return '';
      };

    root
      .querySelectorAll(
        '[data-lp-service-next]'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            async () => {
              const next =
                Number(
                  button.dataset
                    .lpServiceNext
                );

              if (
                next === 2
              ) {
                const error =
                  validateStep1();

                if (error) {
                  setStatus(
                    formStatus,
                    error,
                    true
                  );

                  return;
                }

                button.disabled =
                  true;

                try {
                  setStatus(
                    formStatus,
                    backendEnabled
                      ? 'Saving your details…'
                      : ''
                  );

                  await startLead(
                    'service-hero-form'
                  );

                  showStep(2);
                } catch (
                errorObject
                ) {
                  setStatus(
                    formStatus,
                    errorObject.message,
                    true
                  );
                } finally {
                  button.disabled =
                    false;
                }

                return;
              }

              if (
                next === 3
              ) {
                const error =
                  validateStep2();

                if (error) {
                  setStatus(
                    formStatus,
                    error,
                    true
                  );

                  return;
                }

                button.disabled =
                  true;

                try {
                  await saveLead(
                    'service-hero-form'
                  );

                  showStep(3);
                } catch (
                errorObject
                ) {
                  setStatus(
                    formStatus,
                    errorObject.message,
                    true
                  );
                } finally {
                  button.disabled =
                    false;
                }
              }
            }
          );
        }
      );

    root
      .querySelectorAll(
        '[data-lp-service-back]'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              showStep(
                Number(
                  button.dataset
                    .lpServiceBack
                )
              );
            }
          );
        }
      );

    quickForm.addEventListener(
      'submit',
      async (event) => {
        event.preventDefault();

        setStatus(
          quickStatus,
          ''
        );

        const local =
          cleanPhone(
            quickPhone.value
          );

        if (
          local.length < 6 ||
          local.length > 14
        ) {
          setStatus(
            quickStatus,
            'Please enter a valid WhatsApp number.',
            true
          );

          return;
        }

        if (
          !businessWhatsapp
        ) {
          setStatus(
            quickStatus,
            'WhatsApp is not configured yet.',
            true
          );

          return;
        }

        const quickCountryOption =
          quickCountry
            .selectedOptions[0];

        const quickPayload = {
          ...payload(
            'service-hero-whatsapp'
          ),

          session_id:
            makeId(),

          country:
            quickCountryOption
              ?.dataset.country ||
            'IN',

          calling_code:
            quickCountry.value,

          phone:
            `${quickCountry.value}${local}`,

          first_name: '',
          email: '',
          url: '',
          timeline: '',
          budget: '',
          note: '',
          answers: {}
        };

        const submitButton =
          quickForm.querySelector(
            'button[type="submit"]'
          );

        submitButton.disabled =
          true;

        try {
          if (
            backendEnabled
          ) {
            await request(
              '/v1/leads/start',
              {
                body:
                  quickPayload
              }
            );
          }

          setStatus(
            quickStatus,
            'Saved — opening WhatsApp…'
          );

          const serviceLabel =
            service.replace(
              /-/g,
              ' '
            );

          const message =
            `Hi Liquifyplus, I’m interested in ${serviceLabel}.`;

          window.open(
            `https://wa.me/${businessWhatsapp}?text=${encodeURIComponent(
              message
            )}`,
            '_blank',
            'noopener'
          );
        } catch (
        errorObject
        ) {
          setStatus(
            quickStatus,
            errorObject.message ||
            'We could not save your number. Please try again.',
            true
          );
        } finally {
          submitButton.disabled =
            false;
        }
      }
    );

    form.addEventListener(
      'submit',
      async (event) => {
        event.preventDefault();

        setStatus(
          formStatus,
          ''
        );

        state.timeline =
          timelineSelect.value;

        state.budget =
          budgetSelect.value;

        if (
          !state.timeline
        ) {
          setStatus(
            formStatus,
            'Please choose when you want to start.',
            true
          );

          timelineSelect.focus();

          return;
        }

        if (
          !state.budget
        ) {
          setStatus(
            formStatus,
            'Please choose a budget range.',
            true
          );

          budgetSelect.focus();

          return;
        }

        state.note =
          form.elements.note
            .value
            .trim();

        const submit =
          form.querySelector(
            '.lp-service-hero__submit'
          );

        submit.disabled =
          true;

        try {
          setStatus(
            formStatus,
            backendEnabled
              ? 'Sending your enquiry…'
              : ''
          );

          await completeLead();

          root
            .querySelectorAll(
              '[data-lp-service-panel]'
            )
            .forEach(
              (panel) => {
                panel.hidden =
                  true;
              }
            );

          if (steps) {
            steps.hidden =
              true;
          }

          if (privacy) {
            privacy.hidden =
              true;
          }

          const successTitle =
            success.querySelector(
              '[data-lp-service-success-title]'
            );

          if (successTitle) {
            successTitle.innerHTML =
              state.firstName
                ? `Thanks, ${state.firstName}<br><span>We’ve got your enquiry.</span>`
                : `Thanks<br><span>We’ve got your enquiry.</span>`;
          }

          success.hidden =
            false;

          setStatus(
            formStatus,
            ''
          );
        } catch (
        errorObject
        ) {
          setStatus(
            formStatus,
            errorObject.message ||
            'We could not send your enquiry. Please try again.',
            true
          );
        } finally {
          submit.disabled =
            false;
        }
      }
    );
  };

  const initServiceHeroes = (
    scope = document
  ) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-service-hero]'
      )
    ) {
      roots.push(
        scope
      );
    }

    scope
      .querySelectorAll?.(
        '[data-lp-service-hero]'
      )
      .forEach(
        (root) => {
          roots.push(
            root
          );
        }
      );

    roots.forEach(
      initServiceHero
    );
  };

  initServiceHeroes();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initServiceHeroes(
        event.target
      );
    }
  );
})();







































(() => {
  const initServiceStory = (root) => {
    if (
      !root ||
      root.dataset.lpServiceStoryReady === 'true'
    ) {
      return;
    }

    root.dataset.lpServiceStoryReady = 'true';

    const tabs = [
      ...root.querySelectorAll(
        '[data-lp-story-tab]'
      )
    ];

    const panels = [
      ...root.querySelectorAll(
        '[data-lp-story-panel]'
      )
    ];

    const prev =
      root.querySelector(
        '[data-lp-story-prev]'
      );

    const next =
      root.querySelector(
        '[data-lp-story-next]'
      );

    const mobileSteps = [
      ...root.querySelectorAll(
        '[data-lp-story-mobile-step]'
      )
    ];

    if (!tabs.length) {
      return;
    }

    root.style.setProperty(
      '--lp-story-columns',
      String(tabs.length)
    );

    let activeIndex = 0;

    const setDesktopStep = (
      index,
      focusTab = false
    ) => {
      const safeIndex =
        Math.max(
          0,
          Math.min(
            index,
            tabs.length - 1
          )
        );

      activeIndex = safeIndex;

      tabs.forEach(
        (tab, tabIndex) => {
          const active =
            tabIndex === safeIndex;

          tab.classList.toggle(
            'is-active',
            active
          );

          tab.setAttribute(
            'aria-selected',
            active
              ? 'true'
              : 'false'
          );

          tab.tabIndex =
            active ? 0 : -1;
        }
      );

      panels.forEach(
        (panel, panelIndex) => {
          const active =
            panelIndex === safeIndex;

          panel.classList.toggle(
            'is-active',
            active
          );

          panel.hidden =
            !active;
        }
      );

      if (focusTab) {
        tabs[safeIndex]?.focus();
      }
    };

    tabs.forEach(
      (tab, index) => {
        tab.addEventListener(
          'click',
          () => {
            setDesktopStep(index);
          }
        );

        tab.addEventListener(
          'keydown',
          (event) => {
            let nextIndex = null;

            if (
              event.key ===
              'ArrowRight'
            ) {
              nextIndex =
                index >= tabs.length - 1
                  ? 0
                  : index + 1;
            }

            if (
              event.key ===
              'ArrowLeft'
            ) {
              nextIndex =
                index <= 0
                  ? tabs.length - 1
                  : index - 1;
            }

            if (
              event.key === 'Home'
            ) {
              nextIndex = 0;
            }

            if (
              event.key === 'End'
            ) {
              nextIndex =
                tabs.length - 1;
            }

            if (
              nextIndex === null
            ) {
              return;
            }

            event.preventDefault();

            setDesktopStep(
              nextIndex,
              true
            );
          }
        );
      }
    );

    prev?.addEventListener(
      'click',
      () => {
        setDesktopStep(
          activeIndex <= 0
            ? tabs.length - 1
            : activeIndex - 1
        );
      }
    );

    next?.addEventListener(
      'click',
      () => {
        setDesktopStep(
          activeIndex >=
            tabs.length - 1
            ? 0
            : activeIndex + 1
        );
      }
    );

    const setMobileStep = (
      index
    ) => {
      mobileSteps.forEach(
        (step, stepIndex) => {
          const active =
            stepIndex === index;

          const trigger =
            step.querySelector(
              '[data-lp-story-mobile-trigger]'
            );

          const panel =
            step.querySelector(
              '[data-lp-story-mobile-panel]'
            );

          step.classList.toggle(
            'is-active',
            active
          );

          trigger?.setAttribute(
            'aria-expanded',
            active
              ? 'true'
              : 'false'
          );

          if (panel) {
            panel.hidden =
              !active;
          }
        }
      );
    };

    mobileSteps.forEach(
      (step, index) => {
        const trigger =
          step.querySelector(
            '[data-lp-story-mobile-trigger]'
          );

        trigger?.addEventListener(
          'click',
          () => {
            const alreadyActive =
              step.classList.contains(
                'is-active'
              );

            if (alreadyActive) {
              return;
            }

            setMobileStep(index);
          }
        );
      }
    );

    setDesktopStep(0);
    setMobileStep(0);
  };

  const initServiceStories = (
    scope = document
  ) => {
    if (
      scope.matches?.(
        '[data-lp-service-story]'
      )
    ) {
      initServiceStory(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-service-story]'
      )
      .forEach(
        initServiceStory
      );
  };

  initServiceStories();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initServiceStories(
        event.target
      );
    }
  );
})();































































(() => {
  const initExpandCards = (root) => {
    if (
      !root ||
      root.dataset.lpExpandCardsReady === 'true'
    ) {
      return;
    }

    root.dataset.lpExpandCardsReady = 'true';

    const cards = [
      ...root.querySelectorAll('[data-lp-expand-card]')
    ];

    if (!cards.length) {
      return;
    }

    const setActive = (card) => {
      cards.forEach((item) => {
        item.classList.toggle(
          'is-active',
          item === card
        );
      });
    };

    cards.forEach((card) => {
      card.addEventListener(
        'focusin',
        () => {
          setActive(card);
        }
      );

      card.addEventListener(
        'pointerdown',
        () => {
          setActive(card);
        },
        {
          passive: true
        }
      );
    });
  };

  const initExpandCardSections = (
    scope = document
  ) => {
    if (
      scope.matches?.('[data-lp-expand-cards]')
    ) {
      initExpandCards(scope);
    }

    scope
      .querySelectorAll?.('[data-lp-expand-cards]')
      .forEach(initExpandCards);
  };

  initExpandCardSections();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initExpandCardSections(event.target);
    }
  );
})();






(() => {
  const initExpandCarouselDrag = (scope = document) => {
    scope
      .querySelectorAll?.('[data-lp-expand-cards]')
      .forEach((section) => {
        if (section.dataset.lpExpandDragReady === 'true') {
          return;
        }

        const track = section.querySelector(
          '[data-lp-expand-track]'
        );

        if (!track) {
          return;
        }

        section.dataset.lpExpandDragReady = 'true';

        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let targetScrollLeft = 0;
        let currentScrollLeft = 0;
        let animationFrame = null;
        let dragging = false;
        let moved = false;

        const DRAG_THRESHOLD = 8;
        const DRAG_SPEED = 0.48;
        const EASING = 0.12;

        const isDesktopCarousel = () =>
          window.innerWidth >= 1101 &&
          section.classList.contains(
            'lp-expand-cards--desktop-carousel'
          ) &&
          track.scrollWidth > track.clientWidth + 2;

        const updateState = () => {
          section.classList.toggle(
            'is-desktop-carousel-draggable',
            isDesktopCarousel()
          );
        };

        const animate = () => {
          const delta =
            targetScrollLeft - currentScrollLeft;

          currentScrollLeft += delta * EASING;
          track.scrollLeft = currentScrollLeft;

          if (Math.abs(delta) > 0.35) {
            animationFrame =
              requestAnimationFrame(animate);
            return;
          }

          currentScrollLeft = targetScrollLeft;
          track.scrollLeft = targetScrollLeft;
          animationFrame = null;
        };

        const requestScrollUpdate = () => {
          if (animationFrame) {
            return;
          }

          animationFrame =
            requestAnimationFrame(animate);
        };

        const startDrag = (event) => {
          if (
            event.pointerType !== 'mouse' ||
            event.button !== 0 ||
            !isDesktopCarousel()
          ) {
            return;
          }

          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = track.scrollLeft;
          currentScrollLeft = track.scrollLeft;
          targetScrollLeft = track.scrollLeft;
          dragging = false;
          moved = false;
        };

        const moveDrag = (event) => {
          if (
            pointerId !== event.pointerId ||
            !isDesktopCarousel()
          ) {
            return;
          }

          const distance =
            event.clientX - startX;

          if (
            !dragging &&
            Math.abs(distance) >= DRAG_THRESHOLD
          ) {
            dragging = true;
            moved = true;

            section.classList.add(
              'is-expand-carousel-dragging'
            );

            track.setPointerCapture?.(
              event.pointerId
            );
          }

          if (!dragging) {
            return;
          }

          event.preventDefault();

          targetScrollLeft =
            startScrollLeft -
            distance * DRAG_SPEED;

          requestScrollUpdate();
        };

        const stopDrag = (event) => {
          if (pointerId !== event.pointerId) {
            return;
          }

          if (
            track.hasPointerCapture?.(
              event.pointerId
            )
          ) {
            track.releasePointerCapture(
              event.pointerId
            );
          }

          pointerId = null;
          dragging = false;

          section.classList.remove(
            'is-expand-carousel-dragging'
          );

          window.setTimeout(() => {
            moved = false;
          }, 0);
        };

        track.addEventListener(
          'pointerdown',
          startDrag
        );

        track.addEventListener(
          'pointermove',
          moveDrag
        );

        track.addEventListener(
          'pointerup',
          stopDrag
        );

        track.addEventListener(
          'pointercancel',
          stopDrag
        );

        track.addEventListener(
          'dragstart',
          (event) => {
            if (isDesktopCarousel()) {
              event.preventDefault();
            }
          }
        );

        track.addEventListener(
          'click',
          (event) => {
            if (!moved) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();
          },
          true
        );

        updateState();

        if ('ResizeObserver' in window) {
          const observer =
            new ResizeObserver(updateState);

          observer.observe(track);
        } else {
          window.addEventListener(
            'resize',
            updateState,
            {
              passive: true
            }
          );
        }
      });
  };

  initExpandCarouselDrag();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initExpandCarouselDrag(event.target);
    }
  );
})();




































(() => {
  const initServiceProof = (root) => {
    if (
      !root ||
      root.dataset.lpServiceProofReady === 'true'
    ) {
      return;
    }

    root.dataset.lpServiceProofReady = 'true';

    const slider =
      root.querySelector('[data-lp-proof-slider]');

    const stories = [
      ...root.querySelectorAll('[data-lp-proof-story]')
    ];

    const prev =
      root.querySelector('[data-lp-proof-prev]');

    const next =
      root.querySelector('[data-lp-proof-next]');

    const dialog =
      root.querySelector('[data-lp-proof-dialog]');

    const close =
      root.querySelector('[data-lp-proof-close]');

    const video =
      root.querySelector('[data-lp-proof-video]');

    const videoTitle =
      root.querySelector('[data-lp-proof-video-title]');

    const videoToggle =
      root.querySelector(
        '[data-lp-proof-video-toggle]'
      );

    const pauseIcon =
      root.querySelector(
        '[data-lp-proof-pause-icon]'
      );

    const playIcon =
      root.querySelector(
        '[data-lp-proof-play-icon]'
      );

    if (!stories.length) {
      return;
    }

    let activeIndex = 0;
    let rafId = null;

    const reducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

    const setActive = (index) => {
      activeIndex = Math.max(
        0,
        Math.min(index, stories.length - 1)
      );

      stories.forEach((story, storyIndex) => {
        story.classList.toggle(
          'is-active',
          storyIndex === activeIndex
        );
      });
    };

    const getClosestStory = () => {
      if (!slider) return 0;

      const sliderBox =
        slider.getBoundingClientRect();

      const sliderCenter =
        sliderBox.left +
        sliderBox.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      stories.forEach((story, index) => {
        const box =
          story.getBoundingClientRect();

        const center =
          box.left +
          box.width / 2;

        const distance =
          Math.abs(
            center - sliderCenter
          );

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const syncActive = () => {
      rafId = null;

      setActive(
        getClosestStory()
      );
    };

    slider?.addEventListener(
      'scroll',
      () => {
        if (rafId) return;

        rafId =
          requestAnimationFrame(
            syncActive
          );
      },
      {
        passive: true
      }
    );

    const scrollToStory = (
      index,
      behavior = null
    ) => {
      const safeIndex =
        Math.max(
          0,
          Math.min(
            index,
            stories.length - 1
          )
        );

      stories[safeIndex]?.scrollIntoView({
        behavior:
          behavior ||
          (
            reducedMotion.matches
              ? 'auto'
              : 'smooth'
          ),
        block: 'nearest',
        inline: 'center'
      });

      setActive(safeIndex);
    };

    prev?.addEventListener(
      'click',
      () => {
        scrollToStory(
          activeIndex <= 0
            ? stories.length - 1
            : activeIndex - 1
        );
      }
    );

    next?.addEventListener(
      'click',
      () => {
        scrollToStory(
          activeIndex >=
            stories.length - 1
            ? 0
            : activeIndex + 1
        );
      }
    );

    const updateVideoState = () => {
      if (!video) return;

      const playing =
        !video.paused &&
        !video.ended;

      if (pauseIcon) {
        pauseIcon.hidden =
          !playing;
      }

      if (playIcon) {
        playIcon.hidden =
          playing;
      }

      if (videoToggle) {
        videoToggle.setAttribute(
          'aria-pressed',
          playing
            ? 'true'
            : 'false'
        );

        videoToggle.setAttribute(
          'aria-label',
          playing
            ? 'Pause video'
            : 'Play video'
        );
      }
    };

    const stopVideo = () => {
      if (!video) return;

      video.pause();

      video.removeAttribute('src');

      video.load();

      if (videoTitle) {
        videoTitle.textContent = '';
      }

      updateVideoState();
    };

    const toggleVideo =
      async () => {
        if (!video) return;

        if (
          video.paused ||
          video.ended
        ) {
          try {
            await video.play();
          } catch (error) { }
        } else {
          video.pause();
        }

        updateVideoState();
      };

    const openStory =
      async (story) => {
        if (
          !dialog ||
          !video
        ) {
          return;
        }

        const src =
          story.dataset.videoSrc;

        if (!src) {
          return;
        }

        video.src = src;

        if (videoTitle) {
          videoTitle.textContent =
            story.dataset.videoTitle ||
            '';
        }

        video.load();

        if (
          typeof dialog.showModal ===
          'function'
        ) {
          dialog.showModal();
        } else {
          dialog.setAttribute(
            'open',
            ''
          );
        }

        try {
          await video.play();
        } catch (error) { }

        updateVideoState();
      };

    stories.forEach(
      (story, index) => {
        story.addEventListener(
          'click',
          () => {
            setActive(index);
            openStory(story);
          }
        );
      }
    );

    videoToggle?.addEventListener(
      'click',
      toggleVideo
    );

    video?.addEventListener(
      'click',
      toggleVideo
    );

    video?.addEventListener(
      'play',
      updateVideoState
    );

    video?.addEventListener(
      'pause',
      updateVideoState
    );

    video?.addEventListener(
      'ended',
      updateVideoState
    );

    video?.addEventListener(
      'contextmenu',
      (event) => {
        event.preventDefault();
      }
    );

    close?.addEventListener(
      'click',
      () => {
        if (dialog?.open) {
          dialog.close();
        } else {
          stopVideo();
        }
      }
    );

    dialog?.addEventListener(
      'click',
      (event) => {
        if (event.target !== dialog) {
          return;
        }

        dialog.close();
      }
    );

    dialog?.addEventListener(
      'close',
      stopVideo
    );

    dialog?.addEventListener(
      'cancel',
      (event) => {
        event.preventDefault();

        dialog.close();
      }
    );

    const initialIndex =
      stories.length > 1
        ? 1
        : 0;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToStory(
          initialIndex,
          'auto'
        );
      });
    });

    updateVideoState();
  };

  const initServiceProofs = (
    scope = document
  ) => {
    if (
      scope.matches?.(
        '[data-lp-service-proof]'
      )
    ) {
      initServiceProof(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-service-proof]'
      )
      .forEach(
        initServiceProof
      );
  };

  initServiceProofs();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initServiceProofs(
        event.target
      );
    }
  );
})();























(() => {
  const initExpandCards = (root) => {
    if (
      !root ||
      root.dataset.lpExpandCardsReady === 'true'
    ) {
      return;
    }

    root.dataset.lpExpandCardsReady = 'true';

    const track = root.querySelector(
      '[data-lp-expand-track]'
    );

    const cards = [
      ...root.querySelectorAll(
        '[data-lp-expand-card]'
      )
    ];

    if (!track || !cards.length) {
      return;
    }

    const mobileQuery = window.matchMedia(
      '(max-width: 767px)'
    );

    let observer = null;
    let rafId = null;

    const clearActive = () => {
      cards.forEach((card) => {
        card.classList.remove('is-active');
      });
    };

    const setActive = (activeCard) => {
      cards.forEach((card) => {
        card.classList.toggle(
          'is-active',
          card === activeCard
        );
      });
    };

    const getMostVisibleCard = () => {
      if (!mobileQuery.matches) {
        return null;
      }

      const trackRect =
        track.getBoundingClientRect();

      let bestCard = null;
      let bestRatio = 0;
      let bestCenterDistance = Infinity;

      const trackCenter =
        trackRect.left +
        trackRect.width / 2;

      cards.forEach((card) => {
        const rect =
          card.getBoundingClientRect();

        const visibleLeft =
          Math.max(
            rect.left,
            trackRect.left
          );

        const visibleRight =
          Math.min(
            rect.right,
            trackRect.right
          );

        const visibleWidth =
          Math.max(
            0,
            visibleRight - visibleLeft
          );

        const ratio =
          rect.width > 0
            ? visibleWidth / rect.width
            : 0;

        const cardCenter =
          rect.left +
          rect.width / 2;

        const centerDistance =
          Math.abs(
            cardCenter - trackCenter
          );

        if (
          ratio > bestRatio ||
          (
            Math.abs(ratio - bestRatio) < 0.01 &&
            centerDistance < bestCenterDistance
          )
        ) {
          bestRatio = ratio;
          bestCard = card;
          bestCenterDistance =
            centerDistance;
        }
      });

      if (
        bestCard &&
        bestRatio >= 0.96
      ) {
        return bestCard;
      }

      return null;
    };

    const updateMobileState = () => {
      if (!mobileQuery.matches) {
        clearActive();
        return;
      }

      const visibleCard =
        getMostVisibleCard();

      if (visibleCard) {
        setActive(visibleCard);
      }
    };

    const scheduleUpdate = () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId =
        requestAnimationFrame(() => {
          requestAnimationFrame(
            updateMobileState
          );
        });
    };

    const setupObserver = () => {
      observer?.disconnect();
      observer = null;

      if (!mobileQuery.matches) {
        clearActive();
        return;
      }

      if ('IntersectionObserver' in window) {
        observer =
          new IntersectionObserver(
            () => {
              scheduleUpdate();
            },
            {
              root: track,
              threshold: [
                0,
                0.5,
                0.75,
                0.9,
                0.95,
                0.98,
                1
              ]
            }
          );

        cards.forEach((card) => {
          observer.observe(card);
        });
      }

      scheduleUpdate();

      setTimeout(
        scheduleUpdate,
        120
      );

      setTimeout(
        scheduleUpdate,
        350
      );
    };

    track.addEventListener(
      'scroll',
      scheduleUpdate,
      {
        passive: true
      }
    );

    track.addEventListener(
      'touchend',
      () => {
        setTimeout(
          scheduleUpdate,
          80
        );

        setTimeout(
          scheduleUpdate,
          250
        );
      },
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      () => {
        setupObserver();
      },
      {
        passive: true
      }
    );

    if (
      typeof mobileQuery.addEventListener ===
      'function'
    ) {
      mobileQuery.addEventListener(
        'change',
        setupObserver
      );
    } else {
      mobileQuery.addListener(
        setupObserver
      );
    }

    setupObserver();
  };

  const initExpandCardSections = (
    scope = document
  ) => {
    if (
      scope.matches?.(
        '[data-lp-expand-cards]'
      )
    ) {
      initExpandCards(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-expand-cards]'
      )
      .forEach(
        initExpandCards
      );
  };

  initExpandCardSections();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initExpandCardSections(
        event.target
      );
    }
  );
})();









(() => {
  const SELECTOR = '[data-lp-product-performance]';

  const prepareDrawPath = (path) => {
    if (!path || typeof path.getTotalLength !== 'function') return;

    const length = path.getTotalLength();

    path.style.strokeDasharray = `${length}`;
    path.style.strokeDashoffset = `${length}`;
  };

  const initProductPerformance = (root) => {
    if (!root || root.dataset.lpMotionReady === 'true') return;
    if (!window.gsap) return;

    const gsap = window.gsap;
    const q = gsap.utils.selector(root);

    root.dataset.lpMotionReady = 'true';

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const divider = q('.lp-pp__draw-line')[0];

    const metricBoxPaths = q(
      '.lp-pp__metric-box-path'
    );

    const chartPaths = q(
      '.lp-pp__chart-path'
    );

    const drawPaths = [
      divider,
      ...metricBoxPaths,
      ...chartPaths
    ].filter(Boolean);

    drawPaths.forEach(prepareDrawPath);

    const setInitialState = () => {
      gsap.set(root, {
        opacity: 1
      });

      gsap.set(
        q('.lp-pp__shell'),
        {
          opacity: 0,
          scale: 0.985,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        q('.lp-pp__browser'),
        {
          opacity: 0,
          y: 8
        }
      );

      gsap.set(
        q('.lp-pp__dots > *'),
        {
          opacity: 0,
          scale: 0.35,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        q('.lp-pp__gallery-thumbs > *'),
        {
          opacity: 0,
          y: 10
        }
      );

      gsap.set(
        q('.lp-pp__main-image'),
        {
          opacity: 0,
          scale: 0.985,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        [
          ...q('.lp-pp__product-title'),
          ...q('.lp-pp__price'),
          ...q('.lp-pp__copy-lines'),
          ...q('.lp-pp__color-control'),
          ...q('.lp-pp__size-control'),
          ...q('.lp-pp__quantity-control'),
          ...q('.lp-pp__add-cart'),
          ...q('.lp-pp__buy-now')
        ],
        {
          opacity: 0,
          y: 8
        }
      );

      gsap.set(
        q('.lp-pp__metric-box'),
        {
          opacity: 1
        }
      );

      gsap.set(
        metricBoxPaths,
        {
          fillOpacity: 0
        }
      );

      gsap.set(
        [
          ...q('.lp-pp__metric-label'),
          ...q('.lp-pp__metric-value')
        ],
        {
          opacity: 0,
          y: 7
        }
      );

      gsap.set(
        q('.lp-pp__metric-chart'),
        {
          opacity: 1
        }
      );


      gsap.set(
        q('.lp-pp__chart-path'),
        {
          opacity: 0
        }
      );

      drawPaths.forEach((path) => {
        if (
          !path ||
          typeof path.getTotalLength !== 'function'
        ) {
          return;
        }

        const length = path.getTotalLength();

        path.style.strokeDasharray = `${length}`;
        path.style.strokeDashoffset = `${length}`;
      });
    };

    if (reducedMotion) {
      gsap.set(
        q('g'),
        {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1
        }
      );

      gsap.set(
        metricBoxPaths,
        {
          fillOpacity: 1
        }
      );

      drawPaths.forEach((path) => {
        path.style.strokeDashoffset = '0';
      });

      return;
    }

    setInitialState();

    const tl = gsap.timeline({
      paused: true,
      repeat: -1,
      repeatDelay: 0,
      defaults: {
        ease: 'power2.out'
      }
    });

    tl.to(
      q('.lp-pp__shell'),
      {
        opacity: 1,
        scale: 1,
        duration: 0.55
      }
    )

      .to(
        q('.lp-pp__browser'),
        {
          opacity: 1,
          y: 0,
          duration: 0.45
        },
        '-=0.18'
      )

      .to(
        q('.lp-pp__dots > *'),
        {
          opacity: 1,
          scale: 1,
          duration: 0.28,
          stagger: 0.08,
          ease: 'back.out(1.6)'
        },
        '-=0.08'
      )

      .to(
        divider,
        {
          strokeDashoffset: 0,
          duration: 0.5,
          ease: 'power1.inOut'
        },
        '-=0.03'
      )

      .to(
        q('.lp-pp__gallery-thumbs > *'),
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          stagger: 0.055
        },
        '+=0.08'
      )

      .to(
        q('.lp-pp__main-image'),
        {
          opacity: 1,
          scale: 1,
          duration: 0.5
        },
        '-=0.15'
      )

      .to(
        q('.lp-pp__product-title'),
        {
          opacity: 1,
          y: 0,
          duration: 0.3
        }
      )

      .to(
        q('.lp-pp__price'),
        {
          opacity: 1,
          y: 0,
          duration: 0.3
        },
        '-=0.12'
      )

      .to(
        q('.lp-pp__copy-lines'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.1'
      )

      .to(
        q('.lp-pp__color-control'),
        {
          opacity: 1,
          y: 0,
          duration: 0.3
        },
        '-=0.08'
      )

      .to(
        q('.lp-pp__size-control'),
        {
          opacity: 1,
          y: 0,
          duration: 0.3
        },
        '-=0.08'
      )

      .to(
        q('.lp-pp__quantity-control'),
        {
          opacity: 1,
          y: 0,
          duration: 0.3
        },
        '-=0.08'
      )

      .to(
        q('.lp-pp__add-cart'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.06'
      )

      .to(
        q('.lp-pp__buy-now'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.08'
      )

      .to(
        metricBoxPaths,
        {
          strokeDashoffset: 0,
          duration: 0.52,
          stagger: 0.14,
          ease: 'power1.inOut'
        },
        '+=0.12'
      )

      .to(
        metricBoxPaths,
        {
          fillOpacity: 1,
          duration: 0.22,
          stagger: 0.08
        },
        '-=0.25'
      )

      .to(
        q('.lp-pp__metric-label--1'),
        {
          opacity: 1,
          y: 0,
          duration: 0.26
        }
      )

      .to(
        q('.lp-pp__metric-value--1'),
        {
          opacity: 1,
          y: 0,
          duration: 0.26
        },
        '-=0.1'
      )

      .set(
        q('.lp-pp__metric-chart--1 .lp-pp__chart-path'),
        {
          opacity: 1
        }
      )

      .to(
        q('.lp-pp__metric-chart--1 .lp-pp__chart-path'),
        {
          strokeDashoffset: 0,
          duration: 0.65,
          ease: 'power1.inOut'
        }
      )

      .to(
        q('.lp-pp__metric-label--2'),
        {
          opacity: 1,
          y: 0,
          duration: 0.26
        },
        '-=0.05'
      )

      .to(
        q('.lp-pp__metric-value--2'),
        {
          opacity: 1,
          y: 0,
          duration: 0.26
        },
        '-=0.1'
      )

      .set(
        q('.lp-pp__metric-chart--2 .lp-pp__chart-path'),
        {
          opacity: 1
        }
      )

      .to(
        q('.lp-pp__metric-chart--2 .lp-pp__chart-path'),
        {
          strokeDashoffset: 0,
          duration: 0.65,
          ease: 'power1.inOut'
        }
      )

      .to(
        q('.lp-pp__metric-label--3'),
        {
          opacity: 1,
          y: 0,
          duration: 0.26
        },
        '-=0.05'
      )

      .to(
        q('.lp-pp__metric-value--3'),
        {
          opacity: 1,
          y: 0,
          duration: 0.26
        },
        '-=0.1'
      )

      .set(
        q('.lp-pp__metric-chart--3 .lp-pp__chart-path'),
        {
          opacity: 1
        }
      )

      .to(
        q('.lp-pp__metric-chart--3 .lp-pp__chart-path'),
        {
          strokeDashoffset: 0,
          duration: 0.65,
          ease: 'power1.inOut'
        }
      )

      .to({}, {
        duration: 1.6
      })

      .to(
        root,
        {
          opacity: 0,
          duration: 0.28,
          ease: 'power1.in'
        }
      )

      .call(() => {
        setInitialState();
      })

      .set(root, {
        opacity: 1
      });

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;

        if (entry.isIntersecting) {
          tl.resume();
        } else {
          tl.pause();
        }
      },
      {
        rootMargin: '120px 0px',
        threshold: 0.05
      }
    );

    observer.observe(root);

    root._lpProductPerformanceTimeline = tl;
    root._lpProductPerformanceObserver = observer;
  };

  const destroyProductPerformance = (root) => {
    if (!root) return;

    root._lpProductPerformanceTimeline?.kill();
    root._lpProductPerformanceObserver?.disconnect();

    delete root._lpProductPerformanceTimeline;
    delete root._lpProductPerformanceObserver;

    root.removeAttribute('data-lp-motion-ready');
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(SELECTOR)) {
      initProductPerformance(scope);
    }

    scope
      .querySelectorAll?.(SELECTOR)
      .forEach(initProductPerformance);
  };

  const boot = () => {
    if (window.gsap) {
      initAll();
      return;
    }

    let attempts = 0;

    const waitForGsap = window.setInterval(() => {
      attempts += 1;

      if (window.gsap) {
        window.clearInterval(waitForGsap);
        initAll();
        return;
      }

      if (attempts >= 50) {
        window.clearInterval(waitForGsap);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      if (event.target.matches?.(SELECTOR)) {
        destroyProductPerformance(event.target);
      }

      event.target
        .querySelectorAll?.(SELECTOR)
        .forEach(destroyProductPerformance);
    }
  );
})();














(() => {
  const SELECTOR = '[data-lp-premium-theme]';

  const prepDraw = (path) => {
    if (!path || typeof path.getTotalLength !== 'function') return;

    const length = path.getTotalLength();

    path.style.strokeDasharray = `${length}`;
    path.style.strokeDashoffset = `${length}`;
  };

  const initPremiumTheme = (root) => {
    if (!root) return;
    if (root.dataset.lpPremiumThemeReady === 'true') return;
    if (!window.gsap) return;

    const gsap = window.gsap;
    const q = gsap.utils.selector(root);

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    root.dataset.lpPremiumThemeReady = 'true';

    const connectorPaths = q('.lp-pt__connector path');

    const dividerPaths = q(
      '.lp-pt__draw-path path'
    );

    const drawPaths = [
      ...connectorPaths,
      ...dividerPaths
    ];

    drawPaths.forEach(prepDraw);

    const setInitialState = () => {
      gsap.set(root, {
        opacity: 1
      });

      gsap.set(
        q('.lp-pt__premium-shell'),
        {
          opacity: 0,
          scale: 0.985,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        q('.lp-pt__premium-title'),
        {
          opacity: 0,
          y: 8
        }
      );

      gsap.set(
        q('.lp-pt__premium-subtitle'),
        {
          opacity: 0,
          y: 6
        }
      );

      gsap.set(
        q('.lp-pt__premium-card'),
        {
          opacity: 0,
          y: 14
        }
      );

      gsap.set(
        q('.lp-pt__browser-shell'),
        {
          opacity: 0,
          scale: 0.985,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        q('.lp-pt__browser-dots > *'),
        {
          opacity: 0,
          scale: 0.35,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        q('.lp-pt__browser-hero'),
        {
          opacity: 0,
          y: 10
        }
      );

      gsap.set(
        q('.lp-pt__browser-block'),
        {
          opacity: 0,
          y: 12
        }
      );

      gsap.set(
        q('.lp-pt__ai-shell'),
        {
          opacity: 0,
          scale: 0.985,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        q('.lp-pt__ai-title'),
        {
          opacity: 0,
          y: 8
        }
      );

      gsap.set(
        q('.lp-pt__ai-composer'),
        {
          opacity: 0,
          y: 18
        }
      );

      gsap.set(
        q('.lp-pt__ai-prompt'),
        {
          opacity: 0,
          y: 18
        }
      );

      gsap.set(
        q('.lp-pt__ai-response'),
        {
          opacity: 0,
          y: 8
        }
      );

      gsap.set(
        q('.lp-pt__bottom-card'),
        {
          opacity: 0,
          y: 16,
          scale: 0.985,
          transformOrigin: '50% 50%'
        }
      );

      drawPaths.forEach((path) => {
        if (
          !path ||
          typeof path.getTotalLength !== 'function'
        ) {
          return;
        }

        const length = path.getTotalLength();

        path.style.strokeDasharray = `${length}`;
        path.style.strokeDashoffset = `${length}`;
      });
    };

    if (reducedMotion) {
      gsap.set(
        q('g'),
        {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1
        }
      );

      drawPaths.forEach((path) => {
        path.style.strokeDashoffset = '0';
      });

      return;
    }

    setInitialState();

    const tl = gsap.timeline({
      paused: true,
      repeat: -1,
      repeatDelay: 0,
      defaults: {
        ease: 'power2.out'
      }
    });

    tl.to(
      q('.lp-pt__premium-shell'),
      {
        opacity: 1,
        scale: 1,
        duration: 0.5
      }
    )

      .to(
        q('.lp-pt__premium-title'),
        {
          opacity: 1,
          y: 0,
          duration: 0.34
        },
        '-=0.12'
      )

      .to(
        q('.lp-pt__premium-subtitle'),
        {
          opacity: 1,
          y: 0,
          duration: 0.28
        },
        '-=0.14'
      )

      .to(
        q('.lp-pt__premium-card--1'),
        {
          opacity: 1,
          y: 0,
          duration: 0.38
        },
        '+=0.04'
      )

      .to(
        q('.lp-pt__premium-card--2'),
        {
          opacity: 1,
          y: 0,
          duration: 0.38
        },
        '-=0.12'
      )

      .to(
        q('.lp-pt__premium-card--3'),
        {
          opacity: 1,
          y: 0,
          duration: 0.38
        },
        '-=0.12'
      )

      .to(
        q('.lp-pt__browser-shell'),
        {
          opacity: 1,
          scale: 1,
          duration: 0.5
        },
        '+=0.12'
      )

      .to(
        q('.lp-pt__browser-dots > *'),
        {
          opacity: 1,
          scale: 1,
          duration: 0.24,
          stagger: 0.07,
          ease: 'back.out(1.5)'
        },
        '-=0.12'
      )

      .to(
        q(
          '.lp-pt__browser-top-divider path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.42,
          ease: 'power1.inOut'
        },
        '-=0.04'
      )

      .to(
        q('.lp-pt__browser-hero'),
        {
          opacity: 1,
          y: 0,
          duration: 0.42
        },
        '+=0.04'
      )

      .to(
        q(
          '.lp-pt__browser-content-divider path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.42,
          ease: 'power1.inOut'
        },
        '-=0.08'
      )

      .to(
        q('.lp-pt__browser-block--1'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '+=0.04'
      )

      .to(
        q('.lp-pt__browser-block--2'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.1'
      )

      .to(
        q('.lp-pt__browser-block--3'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.1'
      )

      .to(
        q('.lp-pt__browser-block--4'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.1'
      )

      .to(
        q(
          '.lp-pt__connector--theme-browser path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.62,
          ease: 'power1.inOut'
        },
        '+=0.08'
      )

      .to(
        q('.lp-pt__ai-shell'),
        {
          opacity: 1,
          scale: 1,
          duration: 0.5
        },
        '+=0.1'
      )

      .to(
        q('.lp-pt__ai-title'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.14'
      )

      .to(
        q('.lp-pt__ai-composer'),
        {
          opacity: 1,
          y: 0,
          duration: 0.38,
          ease: 'power3.out'
        },
        '+=0.06'
      )

      .to(
        q('.lp-pt__ai-prompt'),
        {
          opacity: 1,
          y: 0,
          duration: 0.42,
          ease: 'power3.out'
        },
        '+=0.12'
      )

      .to(
        q('.lp-pt__ai-composer'),
        {
          opacity: 0.62,
          duration: 0.2
        },
        '-=0.06'
      )

      .to(
        q('.lp-pt__ai-response--1'),
        {
          opacity: 1,
          y: 0,
          duration: 0.36
        },
        '+=0.08'
      )

      .to(
        q('.lp-pt__ai-response--2'),
        {
          opacity: 1,
          y: 0,
          duration: 0.36
        },
        '-=0.1'
      )

      .to(
        q('.lp-pt__ai-response--3'),
        {
          opacity: 1,
          y: 0,
          duration: 0.36
        },
        '-=0.1'
      )

      .to(
        q('.lp-pt__ai-response--4'),
        {
          opacity: 1,
          y: 0,
          duration: 0.36
        },
        '-=0.1'
      )

      .to(
        q(
          '.lp-pt__connector--ai-browser path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.66,
          ease: 'power1.inOut'
        },
        '+=0.08'
      )

      .to(
        q(
          '.lp-pt__connector--browser-bottom path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.46,
          ease: 'power1.inOut'
        },
        '+=0.1'
      )

      .to(
        [
          q(
            '.lp-pt__connector--branch-left path'
          )[0],

          q(
            '.lp-pt__connector--branch-right path'
          )[0]
        ].filter(Boolean),
        {
          strokeDashoffset: 0,
          duration: 0.62,
          stagger: 0.08,
          ease: 'power1.inOut'
        }
      )

      .to(
        q(
          '.lp-pt__connector--bottom-left path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.3,
          ease: 'power1.inOut'
        }
      )

      .to(
        q('.lp-pt__bottom-card--1'),
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.38
        },
        '-=0.04'
      )

      .to(
        q(
          '.lp-pt__connector--bottom-center path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.3,
          ease: 'power1.inOut'
        },
        '-=0.12'
      )

      .to(
        q('.lp-pt__bottom-card--2'),
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.38
        },
        '-=0.04'
      )

      .to(
        q(
          '.lp-pt__connector--bottom-right path'
        ),
        {
          strokeDashoffset: 0,
          duration: 0.3,
          ease: 'power1.inOut'
        },
        '-=0.12'
      )

      .to(
        q('.lp-pt__bottom-card--3'),
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.38
        },
        '-=0.04'
      )

      .to(
        {},
        {
          duration: 1.8
        }
      )

      .to(
        root,
        {
          opacity: 0,
          duration: 0.3,
          ease: 'power1.in'
        }
      )

      .call(() => {
        setInitialState();
      })

      .set(
        root,
        {
          opacity: 1
        }
      );

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;

        if (entry.isIntersecting) {
          tl.resume();
        } else {
          tl.pause();
        }
      },
      {
        rootMargin: '160px 0px',
        threshold: 0.05
      }
    );

    observer.observe(root);

    root._lpPremiumThemeTimeline = tl;
    root._lpPremiumThemeObserver = observer;
  };

  const destroyPremiumTheme = (root) => {
    if (!root) return;

    root._lpPremiumThemeTimeline?.kill();
    root._lpPremiumThemeObserver?.disconnect();

    delete root._lpPremiumThemeTimeline;
    delete root._lpPremiumThemeObserver;

    root.removeAttribute(
      'data-lp-premium-theme-ready'
    );
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(SELECTOR)) {
      initPremiumTheme(scope);
    }

    scope
      .querySelectorAll?.(SELECTOR)
      .forEach(initPremiumTheme);
  };

  const boot = () => {
    if (window.gsap) {
      initAll();
      return;
    }

    let attempts = 0;

    const waitForGsap = window.setInterval(
      () => {
        attempts += 1;

        if (window.gsap) {
          window.clearInterval(waitForGsap);

          initAll();

          return;
        }

        if (attempts >= 50) {
          window.clearInterval(waitForGsap);
        }
      },
      100
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      if (event.target.matches?.(SELECTOR)) {
        destroyPremiumTheme(event.target);
      }

      event.target
        .querySelectorAll?.(SELECTOR)
        .forEach(destroyPremiumTheme);
    }
  );
})();






















(() => {
  const SELECTOR = '[data-lp-ai-audit]';

  const preparePath = (path) => {
    if (
      !path ||
      typeof path.getTotalLength !== 'function'
    ) {
      return;
    }

    const length = path.getTotalLength();

    path.style.strokeDasharray = `${length}`;
    path.style.strokeDashoffset = `${length}`;
  };

  const initAiAudit = (root) => {
    if (!root) return;

    if (
      root.dataset.lpAiAuditReady === 'true'
    ) {
      return;
    }

    if (!window.gsap) return;

    root.dataset.lpAiAuditReady = 'true';

    const gsap = window.gsap;
    const q = gsap.utils.selector(root);

    const reducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

    const connectors = q(
      '.lp-aa__connector'
    );

    connectors.forEach(preparePath);

    const setInitialState = () => {
      gsap.set(root, {
        opacity: 1
      });

      gsap.set(
        q('.lp-aa__center-shell'),
        {
          opacity: 0,
          scale: 0.96,
          transformOrigin: '50% 50%'
        }
      );

      gsap.set(
        [
          ...q('.lp-aa__center-title'),
          ...q('.lp-aa__center-total'),
          ...q('.lp-aa__center-number'),
          ...q('.lp-aa__center-lines > *')
        ],
        {
          opacity: 0,
          y: 8
        }
      );

      gsap.set(
        q('.lp-aa__item'),
        {
          opacity: 0,
          y: 10,
          scale: 0.96,
          transformOrigin: '50% 50%'
        }
      );

      connectors.forEach(
        preparePath
      );
    };

    if (reducedMotion) {
      gsap.set(
        [
          ...q('.lp-aa__center-shell'),
          ...q('.lp-aa__center-title'),
          ...q('.lp-aa__center-total'),
          ...q('.lp-aa__center-number'),
          ...q('.lp-aa__center-lines'),
          ...q('.lp-aa__item')
        ],
        {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1
        }
      );

      connectors.forEach((path) => {
        path.style.strokeDashoffset = '0';
      });

      return;
    }

    setInitialState();

    const tl = gsap.timeline({
      paused: true,
      repeat: -1,
      defaults: {
        ease: 'power2.out'
      }
    });

    tl.to(
      q('.lp-aa__center-shell'),
      {
        opacity: 1,
        scale: 1,
        duration: 0.5
      }
    )

      .to(
        q('.lp-aa__center-title'),
        {
          opacity: 1,
          y: 0,
          duration: 0.28
        },
        '-=0.12'
      )

      .to(
        q('.lp-aa__center-total'),
        {
          opacity: 1,
          y: 0,
          duration: 0.24
        },
        '-=0.08'
      )

      .to(
        q('.lp-aa__center-number'),
        {
          opacity: 1,
          y: 0,
          duration: 0.32
        },
        '-=0.06'
      )

      .to(
        q('.lp-aa__center-lines > *'),
        {
          opacity: 1,
          y: 0,
          duration: 0.24,
          stagger: 0.07
        },
        '-=0.08'
      );

    for (
      let index = 1;
      index <= 6;
      index += 1
    ) {
      tl.to(
        q(
          `.lp-aa__connector--${index}`
        ),
        {
          strokeDashoffset: 0,
          duration: 0.42,
          ease: 'power1.inOut'
        },
        index === 1
          ? '+=0.1'
          : '+=0.04'
      );

      tl.to(
        q(
          `.lp-aa__item--${index}`
        ),
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.34
        },
        '-=0.08'
      );
    }

    tl.to(
      {},
      {
        duration: 1.8
      }
    )

      .to(
        root,
        {
          opacity: 0,
          duration: 0.28,
          ease: 'power1.in'
        }
      )

      .call(() => {
        setInitialState();
      })

      .set(
        root,
        {
          opacity: 1
        }
      );

    const observer =
      new IntersectionObserver(
        ([entry]) => {
          if (!entry) return;

          if (entry.isIntersecting) {
            tl.resume();
          } else {
            tl.pause();
          }
        },
        {
          rootMargin: '160px 0px',
          threshold: 0.05
        }
      );

    observer.observe(root);

    root._lpAiAuditTimeline = tl;
    root._lpAiAuditObserver = observer;
  };

  const destroyAiAudit = (root) => {
    if (!root) return;

    root._lpAiAuditTimeline?.kill();
    root._lpAiAuditObserver?.disconnect();

    delete root._lpAiAuditTimeline;
    delete root._lpAiAuditObserver;

    root.removeAttribute(
      'data-lp-ai-audit-ready'
    );
  };

  const initAll = (
    scope = document
  ) => {
    if (scope.matches?.(SELECTOR)) {
      initAiAudit(scope);
    }

    scope
      .querySelectorAll?.(SELECTOR)
      .forEach(initAiAudit);
  };

  const boot = () => {
    if (window.gsap) {
      initAll();
      return;
    }

    let attempts = 0;

    const timer =
      window.setInterval(() => {
        attempts += 1;

        if (window.gsap) {
          window.clearInterval(timer);
          initAll();
          return;
        }

        if (attempts >= 40) {
          window.clearInterval(timer);
        }
      }, 100);
  };

  boot();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      if (
        event.target.matches?.(SELECTOR)
      ) {
        destroyAiAudit(event.target);
      }

      event.target
        .querySelectorAll?.(SELECTOR)
        .forEach(destroyAiAudit);
    }
  );
})();


















(() => {
  const SELECTOR = '[data-lp-chatgpt-ui]';
  const CTA_COLOR_STEPS = [
    {
      background: '#FF1E26',
      text: '#FFFFFF'
    },
    {
      background: '#242424',
      text: '#FFFFFF'
    },
    {
      background: '#D8CBB5',
      text: '#242424'
    },
    {
      background: '#B87333',
      text: '#FFFFFF'
    },
    {
      background: '#6E7C4E',
      text: '#FFFFFF'
    }
  ];

  const setVisibleState = (gsap, q) => {
    gsap.set(
      [
        ...q('.lp-cg__browser-shell'),
        ...q('.lp-cg__browser-top'),
        ...q('.lp-cg__chrome-dot'),
        ...q('.lp-cg__chrome-divider'),
        ...q('.lp-cg__sidebar-card'),
        ...q('.lp-cg__stage-shell'),
        ...q('.lp-cg__stage-media > *'),
        ...q('.lp-cg__right-header > *'),
        ...q('.lp-cg__product-title > *'),
        ...q('.lp-cg__product-price > *'),
        ...q('.lp-cg__product-description > *'),
        ...q('.lp-cg__swatch'),
        ...q('.lp-cg__cta'),
        ...q('.lp-cg__variant'),
        ...q('.lp-cg__variant-lines > *'),
        ...q('.lp-cg__type-shell'),
        ...q('.lp-cg__type-dot'),
        ...q('.lp-cg__type-segment'),
        ...q('.lp-cg__type-caret')
      ],
      {
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
        scaleX: 1,
        transformOrigin: '50% 50%'
      }
    );
  };

  const setInitialState = (gsap, q) => {
    gsap.set(
      [
        ...q('.lp-cg__browser-shell'),
        ...q('.lp-cg__browser-top')
      ],
      {
        opacity: 0,
        y: 12
      }
    );

    gsap.set(q('.lp-cg__chrome-dot'), {
      opacity: 0,
      scale: 0.7,
      transformOrigin: '50% 50%'
    });

    gsap.set(q('.lp-cg__chrome-divider'), {
      opacity: 0,
      scaleX: 0,
      transformOrigin: '0% 50%'
    });

    gsap.set(q('.lp-cg__sidebar-card'), {
      opacity: 0,
      x: -14,
      scale: 0.96,
      transformOrigin: '50% 50%'
    });

    gsap.set(q('.lp-cg__stage-shell'), {
      opacity: 0,
      y: 12,
      scale: 0.98,
      transformOrigin: '50% 50%'
    });

    gsap.set(q('.lp-cg__stage-media > *'), {
      opacity: 0,
      y: 10
    });

    gsap.set(
      [
        ...q('.lp-cg__right-header > *'),
        ...q('.lp-cg__product-title > *'),
        ...q('.lp-cg__product-price > *'),
        ...q('.lp-cg__product-description > *')
      ],
      {
        opacity: 0,
        y: 8
      }
    );

    gsap.set(q('.lp-cg__swatch'), {
      opacity: 0,
      scale: 0.8,
      transformOrigin: '50% 50%'
    });

    gsap.set(q('.lp-cg__cta'), {
      opacity: 0,
      y: 8,
      scale: 0.96,
      transformOrigin: '50% 50%'
    });

    gsap.set(q('.lp-cg__variant'), {
      opacity: 0,
      y: 10,
      scale: 0.96,
      transformOrigin: '50% 50%'
    });

    gsap.set(q('.lp-cg__variant-lines > *'), {
      opacity: 0,
      y: 6
    });

    gsap.set(
      [
        ...q('.lp-cg__type-shell'),
        ...q('.lp-cg__type-dot')
      ],
      {
        opacity: 0,
        y: 8
      }
    );

    gsap.set(q('.lp-cg__type-segment'), {
      opacity: 0
    });

    gsap.set(q('.lp-cg__type-caret'), {
      opacity: 0
    });
  };

  const initChatgptUi = (root) => {
    if (!root || root.dataset.lpChatgptUiReady === 'true') {
      return;
    }

    if (!window.gsap) {
      return;
    }

    root.dataset.lpChatgptUiReady = 'true';

    const gsap = window.gsap;
    const q = gsap.utils.selector(root);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      setVisibleState(gsap, q);
      return;
    }

    setInitialState(gsap, q);

    const tl = gsap.timeline({
      paused: true,
      repeat: -1,
      defaults: {
        ease: 'power2.out'
      }
    });

    tl.to(
      q('.lp-cg__browser-shell, .lp-cg__browser-top'),
      {
        opacity: 1,
        y: 0,
        duration: 0.46,
        stagger: 0.06
      }
    )
      .to(
        q('.lp-cg__chrome-dot'),
        {
          opacity: 1,
          scale: 1,
          duration: 0.18,
          stagger: 0.06
        },
        '-=0.08'
      )
      .to(
        q('.lp-cg__chrome-divider'),
        {
          opacity: 1,
          scaleX: 1,
          duration: 0.24,
          ease: 'power1.out'
        },
        '-=0.02'
      )
      .to(
        q('.lp-cg__sidebar-card'),
        {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 0.3,
          stagger: 0.08
        },
        '+=0.04'
      )
      .to(
        q('.lp-cg__stage-shell'),
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.32
        },
        '-=0.12'
      )
      .to(
        q('.lp-cg__stage-media > *'),
        {
          opacity: 1,
          y: 0,
          duration: 0.24,
          stagger: 0.05
        },
        '-=0.14'
      )
      .to(
        q('.lp-cg__right-header > *'),
        {
          opacity: 1,
          y: 0,
          duration: 0.22,
          stagger: 0.05
        },
        '+=0.02'
      )
      .to(
        q('.lp-cg__product-title > *'),
        {
          opacity: 1,
          y: 0,
          duration: 0.28
        },
        '-=0.06'
      )
      .to(
        q('.lp-cg__product-price > *'),
        {
          opacity: 1,
          y: 0,
          duration: 0.24
        },
        '-=0.08'
      )
      .to(
        q('.lp-cg__product-description > *'),
        {
          opacity: 1,
          y: 0,
          duration: 0.22,
          stagger: 0.06
        },
        '-=0.06'
      )
      .to(
        q('.lp-cg__swatch'),
        {
          opacity: 1,
          scale: 1,
          duration: 0.2,
          stagger: 0.04
        },
        '-=0.08'
      )
      .to(
        q('.lp-cg__cta'),
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.24
        },
        '-=0.06'
      );

    CTA_COLOR_STEPS.forEach(({ background, text }) => {
      tl.to(
        q('.lp-cg__cta-bg path'),
        {
          fill: background,
          duration: 0.22,
          ease: 'power1.inOut'
        },
        '+=0.05'
      )
        .to(
          q('.lp-cg__cta-text path'),
          {
            fill: text,
            duration: 0.22,
            ease: 'power1.inOut'
          },
          '<'
        );
    });

    [1, 2, 3].forEach((index) => {
      tl.to(
        q(`.lp-cg__variant--${index}`),
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.28
        },
        index === 1 ? '+=0.06' : '+=0.04'
      ).to(
        q(`.lp-cg__variant--${index} .lp-cg__variant-lines > *`),
        {
          opacity: 1,
          y: 0,
          duration: 0.18,
          stagger: 0.04
        },
        '-=0.08'
      );
    });

    tl.to(
      q('.lp-cg__type-shell, .lp-cg__type-dot'),
      {
        opacity: 1,
        y: 0,
        duration: 0.2,
        stagger: 0.03
      },
      '+=0.06'
    )
      .to(
        q('.lp-cg__type-segment'),
        {
          opacity: 1,
          duration: 0.08,
          stagger: 0.11
        },
        '-=0.02'
      )
      .to(
        q('.lp-cg__type-caret'),
        {
          opacity: 1,
          duration: 0.01
        },
        '-=0.04'
      )
      .to(
        q('.lp-cg__type-caret'),
        {
          opacity: 0,
          duration: 0.16,
          repeat: 5,
          yoyo: true,
          ease: 'none'
        }
      )
      .to(
        {},
        {
          duration: 1.6
        }
      )
      .call(() => {
        setInitialState(gsap, q);
      })
      .set(root, {
        opacity: 1
      });

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) {
          return;
        }

        if (entry.isIntersecting) {
          tl.restart();
        } else {
          tl.pause();
        }
      },
      {
        rootMargin: '160px 0px',
        threshold: 0.05
      }
    );

    observer.observe(root);

    root._lpChatgptUiTimeline = tl;
    root._lpChatgptUiObserver = observer;
  };

  const destroyChatgptUi = (root) => {
    if (!root) {
      return;
    }

    root._lpChatgptUiTimeline?.kill();
    root._lpChatgptUiObserver?.disconnect();

    delete root._lpChatgptUiTimeline;
    delete root._lpChatgptUiObserver;

    root.removeAttribute('data-lp-chatgpt-ui-ready');
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(SELECTOR)) {
      initChatgptUi(scope);
    }

    scope.querySelectorAll?.(SELECTOR).forEach(initChatgptUi);
  };

  const boot = () => {
    if (window.gsap) {
      initAll();
      return;
    }

    let attempts = 0;

    const timer = window.setInterval(() => {
      attempts += 1;

      if (window.gsap) {
        window.clearInterval(timer);
        initAll();
        return;
      }

      if (attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  boot();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.(SELECTOR)) {
      destroyChatgptUi(event.target);
    }

    event.target.querySelectorAll?.(SELECTOR).forEach(destroyChatgptUi);
  });
})();
















(() => {
  const instances = new WeakMap();

  const initStackBuild = (scope = document) => {
    if (!window.gsap) return;

    const roots = [];

    if (
      scope.matches?.('[data-lp-stack-build]') &&
      scope.dataset.lpStackBuildReady !== 'true'
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-stack-build]:not([data-lp-stack-build-ready="true"])'
      )
      .forEach((root) => {
        roots.push(root);
      });

    roots.forEach((root) => {
      root.dataset.lpStackBuildReady = 'true';

      const q = gsap.utils.selector(root);

      const backShell = q(
        '.lp-stack-build__back-shell'
      );

      const shopifyLogo = q(
        '.lp-stack-build__shopify-logo'
      );

      const shopifyPlusLogo = q(
        '.lp-stack-build__shopify-plus-logo'
      );

      const middleShell = q(
        '.lp-stack-build__middle-shell'
      );

      const middleLines = q(
        '.lp-stack-build__middle-lines > *'
      );

      const frontShell = q(
        '.lp-stack-build__front-shell'
      );

      const dots = q(
        '.lp-stack-build__dots > *'
      );

      const divider = q(
        '.lp-stack-build__divider path'
      );

      const image = q(
        '.lp-stack-build__image > *'
      );

      const rightLines = q(
        '.lp-stack-build__right-lines > *'
      );

      const liquidCode = q(
        '.lp-stack-build__liquid-code > *'
      );

      const reducedMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

      const animatedGroups = [
        ...backShell,
        ...shopifyLogo,
        ...shopifyPlusLogo,
        ...middleShell,
        ...middleLines,
        ...frontShell,
        ...dots,
        ...divider,
        ...image,
        ...rightLines,
        ...liquidCode
      ];

      const dividerLengths = new Map();

      divider.forEach((path) => {
        const length = path.getTotalLength();

        dividerLengths.set(
          path,
          length
        );
      });

      const setVisibleState = () => {
        gsap.killTweensOf(
          animatedGroups
        );

        gsap.set(
          animatedGroups,
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            scaleX: 1,
            clearProps:
              'transformOrigin'
          }
        );

        divider.forEach(
          (path) => {
            gsap.set(path, {
              strokeDasharray:
                'none',

              strokeDashoffset:
                0
            });
          }
        );
      };

      if (reducedMotion.matches) {
        setVisibleState();

        instances.set(
          root,
          {
            timeline: null,
            observer: null,
            reducedMotion
          }
        );

        return;
      }

      const setInitialState = () => {
        gsap.set(
          backShell,
          {
            opacity: 0,
            y: 14
          }
        );

        gsap.set(
          shopifyLogo,
          {
            opacity: 0,
            scale: 0.9,
            transformOrigin:
              'center center'
          }
        );

        gsap.set(
          shopifyPlusLogo,
          {
            opacity: 0,
            scale: 0.9,
            transformOrigin:
              'center center'
          }
        );

        gsap.set(
          middleShell,
          {
            opacity: 0,
            y: 14
          }
        );

        gsap.set(
          middleLines,
          {
            opacity: 0,
            scaleX: 0,
            transformOrigin:
              'left center'
          }
        );

        gsap.set(
          frontShell,
          {
            opacity: 0,
            y: 14
          }
        );

        gsap.set(
          dots,
          {
            opacity: 0,
            scale: 0,
            transformOrigin:
              'center center'
          }
        );

        divider.forEach(
          (path) => {
            const length =
              dividerLengths.get(
                path
              );

            gsap.set(path, {
              opacity: 1,

              strokeDasharray:
                length,

              strokeDashoffset:
                length
            });
          }
        );

        gsap.set(
          image,
          {
            opacity: 0,
            scale: 0.96,
            transformOrigin:
              'center center'
          }
        );

        gsap.set(
          rightLines,
          {
            opacity: 0,
            scaleX: 0,
            transformOrigin:
              'left center'
          }
        );

        gsap.set(
          liquidCode,
          {
            opacity: 0,
            y: 6
          }
        );
      };

      setInitialState();

      const timeline =
        gsap.timeline({
          paused: true,
          repeat: -1,
          repeatDelay: 0.6
        });

      timeline
        .to(
          backShell,
          {
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: 'power2.out'
          }
        )

        .to(
          shopifyLogo,
          {
            opacity: 1,
            scale: 1,
            duration: 0.32,
            ease: 'back.out(1.4)'
          },
          '-=.1'
        )

        .to(
          shopifyPlusLogo,
          {
            opacity: 1,
            scale: 1,
            duration: 0.32,
            ease: 'back.out(1.4)'
          },
          '-=.06'
        )

        .to(
          middleShell,
          {
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: 'power2.out'
          },
          '+=.18'
        )

        .to(
          middleLines,
          {
            opacity: 1,
            scaleX: 1,
            duration: 0.24,
            stagger: 0.035,
            ease: 'power2.out'
          },
          '-=.12'
        )

        .to(
          frontShell,
          {
            opacity: 1,
            y: 0,
            duration: 0.46,
            ease: 'power2.out'
          },
          '+=.18'
        )

        .to(
          dots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.19,
            stagger: 0.065,
            ease: 'back.out(1.6)'
          },
          '-=.08'
        )

        .to(
          divider,
          {
            strokeDashoffset: 0,
            duration: 0.42,
            ease: 'power2.inOut'
          },
          '-=.02'
        )

        .to(
          image,
          {
            opacity: 1,
            scale: 1,
            duration: 0.34,
            stagger: 0.035,
            ease: 'power2.out'
          },
          '-=.1'
        )

        .to(
          rightLines,
          {
            opacity: 1,
            scaleX: 1,
            duration: 0.25,
            stagger: 0.075,
            ease: 'power2.out'
          },
          '-=.12'
        )

        .to(
          liquidCode,
          {
            opacity: 1,
            y: 0,
            duration: 0.55,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          {},
          {
            duration: 2
          }
        )

        .to(
          animatedGroups,
          {
            opacity: 0,
            duration: 0.25,
            ease: 'power1.in'
          }
        )

        .call(
          setInitialState
        );

      let observer = null;

      if (
        'IntersectionObserver'
        in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach(
                (entry) => {
                  if (
                    entry.isIntersecting
                  ) {
                    timeline.play();
                  } else {
                    timeline.pause();
                  }
                }
              );
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      const handleReducedMotion =
        (event) => {
          if (event.matches) {
            timeline.pause(0);
            setVisibleState();
            return;
          }

          setInitialState();
          timeline.restart();
        };

      reducedMotion.addEventListener?.(
        'change',
        handleReducedMotion
      );

      instances.set(
        root,
        {
          timeline,
          observer,
          reducedMotion,
          handleReducedMotion
        }
      );
    });
  };

  const destroyStackBuild = (
    scope
  ) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-stack-build]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-stack-build]'
      )
      .forEach((root) => {
        roots.push(root);
      });

    roots.forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instance.reducedMotion
        ?.removeEventListener?.(
          'change',
          instance.handleReducedMotion
        );

      instances.delete(root);

      delete root.dataset
        .lpStackBuildReady;
    });
  };

  const bootStackBuild = (
    attempt = 0
  ) => {
    if (window.gsap) {
      initStackBuild();
      return;
    }

    if (attempt >= 120) {
      return;
    }

    requestAnimationFrame(
      () => {
        bootStackBuild(
          attempt + 1
        );
      }
    );
  };

  bootStackBuild();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (window.gsap) {
        initStackBuild(
          event.target
        );
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyStackBuild(
        event.target
      );
    }
  );
})();




























(() => {
  const instances = new WeakMap();

  const initBrowserBuild = (scope = document) => {
    if (!window.gsap) return;

    const illustrations = [];

    if (
      scope.matches?.('[data-lp-browser-build]') &&
      scope.dataset.lpBrowserBuildReady !== 'true'
    ) {
      illustrations.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-browser-build]:not([data-lp-browser-build-ready="true"])'
      )
      .forEach((illustration) => {
        illustrations.push(illustration);
      });

    illustrations.forEach((illustration) => {
      illustration.dataset.lpBrowserBuildReady = 'true';

      const q = gsap.utils.selector(illustration);

      const shell = q('.lp-browser-build__shell');
      const dots = q('.lp-browser-build__dot');
      const divider = q('.lp-browser-build__divider path');
      const image = q('.lp-browser-build__image > *');
      const rightLines = q('.lp-browser-build__right-lines > *');
      const htmlBadge = q('.lp-browser-build__badge--html');
      const cssBadge = q('.lp-browser-build__badge--css');
      const jsBadge = q('.lp-browser-build__badge--js');

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      const dividerLengths = new Map();

      divider.forEach((path) => {
        dividerLengths.set(
          path,
          path.getTotalLength()
        );
      });

      const lineLengths = new Map();

      rightLines.forEach((path) => {
        if (typeof path.getTotalLength !== 'function') return;

        lineLengths.set(
          path,
          path.getTotalLength()
        );
      });

      const setVisibleState = () => {
        gsap.set(
          [
            shell,
            dots,
            image,
            htmlBadge,
            cssBadge,
            jsBadge
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        divider.forEach((path) => {
          gsap.set(path, {
            opacity: 1,
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        rightLines.forEach((path) => {
          gsap.set(path, {
            opacity: 1,
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });
      };

      const setInitialState = () => {
        gsap.set(shell, {
          opacity: 0,
          y: 10
        });

        gsap.set(dots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        divider.forEach((path) => {
          const length = dividerLengths.get(path);

          gsap.set(path, {
            opacity: 1,
            strokeDasharray: length,
            strokeDashoffset: length
          });
        });

        gsap.set(image, {
          opacity: 0,
          y: 7,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        rightLines.forEach((path) => {
          const length = lineLengths.get(path);

          gsap.set(path, {
            opacity: 1,
            strokeDasharray: length,
            strokeDashoffset: length
          });
        });

        gsap.set(
          [
            htmlBadge,
            cssBadge,
            jsBadge
          ],
          {
            opacity: 0,
            y: 8,
            scale: 0.94,
            transformOrigin: 'center center'
          }
        );
      };

      if (reducedMotion.matches) {
        setVisibleState();

        instances.set(illustration, {
          timeline: null,
          observer: null,
          reducedMotion
        });

        return;
      }

      setInitialState();

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        /* 01 — Browser */
        .to(shell, {
          opacity: 1,
          y: 0,
          duration: 0.48,
          ease: 'power2.out'
        })

        /* 02 — Dots */
        .to(
          dots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.2,
            stagger: 0.07,
            ease: 'back.out(1.8)'
          },
          '-=.08'
        )

        /* 03 — Divider */
        .to(
          divider,
          {
            strokeDashoffset: 0,
            duration: 0.46,
            ease: 'power2.inOut'
          },
          '+=.02'
        )

        /* 04 — Left image */
        .to(
          image,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            stagger: 0.05,
            ease: 'power2.out'
          },
          '-=.06'
        )

        /* 05 — Right-side lines */
        .to(
          rightLines,
          {
            strokeDashoffset: 0,
            duration: 0.26,
            stagger: 0.055,
            ease: 'power2.inOut'
          },
          '+=.02'
        )

        /* 06 — HTML */
        .to(
          htmlBadge,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.4)'
          },
          '+=.08'
        )

        /* 07 — CSS */
        .to(
          cssBadge,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.4)'
          },
          '-=.08'
        )

        /* 08 — JS */
        .to(
          jsBadge,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.4)'
          },
          '-=.08'
        )

        /* Hold */
        .to({}, {
          duration: 2
        })

        /* Fade complete illustration */
        .to(
          illustration,
          {
            opacity: 0,
            duration: 0.24,
            ease: 'power1.in'
          }
        )

        /* Reset */
        .call(() => {
          setInitialState();

          gsap.set(illustration, {
            opacity: 1
          });
        });

      let observer = null;

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                timeline.play();
              } else {
                timeline.pause();
              }
            });
          },
          {
            threshold: 0.15
          }
        );

        observer.observe(illustration);
      } else {
        timeline.play();
      }

      const handleReducedMotion = (event) => {
        if (event.matches) {
          timeline.pause(0);
          setVisibleState();
          return;
        }

        setInitialState();
        timeline.restart();
      };

      reducedMotion.addEventListener?.(
        'change',
        handleReducedMotion
      );

      instances.set(illustration, {
        timeline,
        observer,
        reducedMotion,
        handleReducedMotion
      });
    });
  };

  const destroyBrowserBuild = (scope) => {
    const illustrations = [];

    if (scope.matches?.('[data-lp-browser-build]')) {
      illustrations.push(scope);
    }

    scope
      .querySelectorAll?.('[data-lp-browser-build]')
      .forEach((illustration) => {
        illustrations.push(illustration);
      });

    illustrations.forEach((illustration) => {
      const instance = instances.get(illustration);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instance.reducedMotion?.removeEventListener?.(
        'change',
        instance.handleReducedMotion
      );

      instances.delete(illustration);

      delete illustration.dataset.lpBrowserBuildReady;
    });
  };

  const bootBrowserBuild = (attempt = 0) => {
    if (window.gsap) {
      initBrowserBuild();
      return;
    }

    if (attempt >= 120) return;

    requestAnimationFrame(() => {
      bootBrowserBuild(attempt + 1);
    });
  };

  bootBrowserBuild();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (!window.gsap) return;

      initBrowserBuild(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyBrowserBuild(event.target);
    }
  );
})();
















(() => {
  const instances = new WeakMap();

  const initProblemCheckoutFlow = (scope = document) => {
    if (!window.gsap) return;

    const roots = [];

    if (
      scope.matches?.('[data-lp-problem-checkout-flow]') &&
      scope.dataset.lpProblemCheckoutFlowReady !== 'true'
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-checkout-flow]:not([data-lp-problem-checkout-flow-ready="true"])'
      )
      .forEach((root) => roots.push(root));

    roots.forEach((root) => {
      root.dataset.lpProblemCheckoutFlowReady = 'true';

      const q = gsap.utils.selector(root);

      const cart = q('.lp-pcf__cart');

      const connector1 = q(
        '.lp-pcf__connector--1 .lp-pcf__connector-line'
      );

      const connector1Dot = q(
        '.lp-pcf__connector--1 .lp-pcf__connector-dot'
      );

      const panel = q('.lp-pcf__panel-shell');

      const row1 = q('.lp-pcf__row--1');
      const row2 = q('.lp-pcf__row--2');
      const row3 = q('.lp-pcf__row--3');

      const connector2 = q(
        '.lp-pcf__connector--2 .lp-pcf__connector-line'
      );

      const connector2Dot = q(
        '.lp-pcf__connector--2 .lp-pcf__connector-dot'
      );

      const payment = q('.lp-pcf__payment');
      const success = q('.lp-pcf__success');
      const label = q('.lp-pcf__label');

      const rowLines = q('.lp-pcf__line');

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );







      const lineLengths = new Map();

      rowLines.forEach((path) => {
        const length = path.getTotalLength();

        lineLengths.set(path, length);
      });

      const connectorLengths = new Map();

      [...connector1, ...connector2].forEach((path) => {
        connectorLengths.set(
          path,
          path.getTotalLength()
        );
      });

    


      const setVisible = () => {
        gsap.set(
          [
            cart,
            panel,
            row1,
            row2,
            row3,
            payment,
            success,
            label
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        rowLines.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });
      };

      const setInitial = () => {
        gsap.set(cart, {
          opacity: 0,
          x: -10
        });
        [...connector1, ...connector2].forEach((path) => {
          const length = connectorLengths.get(path);

          gsap.set(path, {
            opacity: 0,
            strokeDasharray: length,
            strokeDashoffset: length
          });
        });

        gsap.set(
          [...connector1Dot, ...connector2Dot],
          {
            opacity: 0,
            scale: 0,
            transformOrigin: 'center center'
          }
        );

        gsap.set(panel, {
          opacity: 0,
          y: 8,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        gsap.set([row1, row2, row3], {
          opacity: 0
        });

        rowLines.forEach((path) => {
          const length = lineLengths.get(path);

          gsap.set(path, {
            strokeDasharray: length,
            strokeDashoffset: length
          });
        });

        gsap.set(payment, {
          opacity: 0,
          x: 10
        });

        gsap.set(success, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(label, {
          opacity: 0,
          y: 6
        });
      };

      if (reducedMotion.matches) {
        setVisible();
        return;
      }

      setInitial();









      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        .to(cart, {
          opacity: 1,
          x: 0,
          duration: 0.35,
          ease: 'power2.out'
        })

        .to(
          connector1,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.3,
            ease: 'power2.inOut'
          },
          '+=.06'
        )

        .to(
          connector1Dot,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.7)'
          },
          '-=.1'
        )

        .to(
          panel,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.4,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(row1, {
          opacity: 1,
          duration: 0.18
        })

        .to(
          q('.lp-pcf__row--1 .lp-pcf__line'),
          {
            strokeDashoffset: 0,
            duration: 0.28,
            ease: 'power2.inOut'
          },
          '-=.08'
        )

        .to(row2, {
          opacity: 1,
          duration: 0.18
        })

        .to(
          q('.lp-pcf__row--2 .lp-pcf__line'),
          {
            strokeDashoffset: 0,
            duration: 0.28,
            ease: 'power2.inOut'
          },
          '-=.08'
        )

        .to(row3, {
          opacity: 1,
          duration: 0.18
        })

        .to(
          q('.lp-pcf__row--3 .lp-pcf__line'),
          {
            strokeDashoffset: 0,
            duration: 0.28,
            ease: 'power2.inOut'
          },
          '-=.08'
        )

        .to(
          connector2,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.3,
            ease: 'power2.inOut'
          },
          '+=.06'
        )

        .to(
          connector2Dot,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.7)'
          },
          '-=.1'
        )

        .to(
          payment,
          {
            opacity: 1,
            x: 0,
            duration: 0.35,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          success,
          {
            opacity: 1,
            scale: 1,
            duration: 0.26,
            ease: 'back.out(1.7)'
          },
          '-=.05'
        )

        .to(
          label,
          {
            opacity: 1,
            y: 0,
            duration: 0.35,
            ease: 'power2.out'
          },
          '+=.06'
        )

        .to({}, {
          duration: 2
        })

        .to(root, {
          opacity: 0,
          duration: 0.25,
          ease: 'power1.in'
        })

        .call(() => {
          setInitial();

          gsap.set(root, {
            opacity: 1
          });
        });

      let observer = null;









      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                timeline.play();
              } else {
                timeline.pause();
              }
            });
          },
          {
            threshold: 0.15
          }
        );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyProblemCheckoutFlow = (scope) => {
    scope
      .querySelectorAll?.('[data-lp-problem-checkout-flow]')
      .forEach((root) => {
        const instance = instances.get(root);

        if (!instance) return;

        instance.timeline?.kill();
        instance.observer?.disconnect();

        instances.delete(root);

        delete root.dataset.lpProblemCheckoutFlowReady;
      });
  };

  const boot = (attempt = 0) => {
    if (window.gsap) {
      initProblemCheckoutFlow();
      return;
    }

    if (attempt >= 120) return;

    requestAnimationFrame(() => {
      boot(attempt + 1);
    });
  };

  boot();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initProblemCheckoutFlow(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyProblemCheckoutFlow(event.target);
    }
  );
})();
















/* =========================================================
   SVG ANIMATION: COMMERCE API FLOW
   Snippet: lp-problem-commerce-api-flow.liquid
   CSS: lp-problem-commerce-api-flow.css
   ========================================================= */


(() => {
  const instances = new WeakMap();

  const initCommerceApiFlow = (scope = document) => {
    if (!window.gsap) return;

    const roots = [];

    if (
      scope.matches?.('[data-lp-problem-commerce-api-flow]') &&
      scope.dataset.lpCommerceApiFlowReady !== 'true'
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-commerce-api-flow]:not([data-lp-commerce-api-flow-ready="true"])'
      )
      .forEach((root) => {
        roots.push(root);
      });

    roots.forEach((root) => {
      root.dataset.lpCommerceApiFlowReady = 'true';

      const q = gsap.utils.selector(root);

      const commerceShell = q('.lp-caf__commerce-shell');
      const database = q('.lp-caf__database');
      const commerceLabel = q('.lp-caf__commerce-label');

      const leftConnectors = q(
        '.lp-caf__connectors-left .lp-caf__connector'
      );

      const nodes = q('.lp-caf__node');

      const apiShell = q('.lp-caf__api-shell');
      const apiLabel = q('.lp-caf__api-label');

      const rightConnectors = q(
        '.lp-caf__connectors-right .lp-caf__connector'
      );

      const storefrontShell = q('.lp-caf__storefront-shell');
      const browserDotsGroup = q('.lp-caf__browser-dots');
const browserDots = q('.lp-caf__browser-dots > *');
      const browserDivider = q('.lp-caf__browser-divider path');
      const storefrontImage = q('.lp-caf__storefront-image > *');
      const storefrontLines = q('.lp-caf__storefront-lines > *');
      const storefrontLabel = q('.lp-caf__storefront-label');

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      const connectorLengths = new Map();

      [
        ...leftConnectors,
        ...rightConnectors,
        ...browserDivider
      ].forEach((path) => {
        if (typeof path.getTotalLength !== 'function') return;

        connectorLengths.set(
          path,
          path.getTotalLength()
        );
      });

    const setPathHidden = (paths) => {
  paths.forEach((path) => {
    const length = connectorLengths.get(path);

    if (!length) return;

    gsap.set(path, {
      opacity: 0,
      strokeDasharray: length,
      strokeDashoffset: length
    });
  });
};

  const setPathVisible = (paths) => {
  paths.forEach((path) => {
    gsap.set(path, {
      opacity: 1,
      strokeDasharray: 'none',
      strokeDashoffset: 0
    });
  });
};
      const setVisibleState = () => {
        gsap.set(
          [
            commerceShell,
            database,
            commerceLabel,
            nodes,
            apiShell,
            apiLabel,
            storefrontShell,
            browserDots,
            storefrontImage,
            storefrontLines,
            storefrontLabel
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            scaleX: 1
          }
        );

        setPathVisible([
          ...leftConnectors,
          ...rightConnectors,
          ...browserDivider
        ]);
      };

      const setInitialState = () => {
        gsap.set(root, {
          opacity: 1
        });

        gsap.set(commerceShell, {
          opacity: 0,
          x: -12
        });

        gsap.set(database, {
          opacity: 0,
          scale: 0.92,
          transformOrigin: 'center center'
        });

        gsap.set(commerceLabel, {
          opacity: 0,
          y: 5
        });

        setPathHidden(leftConnectors);

        gsap.set(nodes, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(apiShell, {
          opacity: 0,
          scale: 0.92,
          transformOrigin: 'center center'
        });

        gsap.set(apiLabel, {
          opacity: 0,
          scale: 0.9,
          transformOrigin: 'center center'
        });

        setPathHidden(rightConnectors);

        gsap.set(storefrontShell, {
          opacity: 0,
          x: 12
        });

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        setPathHidden(browserDivider);

        gsap.set(storefrontImage, {
          opacity: 0,
          y: 5,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        gsap.set(storefrontLines, {
          opacity: 0,
          scaleX: 0,
          transformOrigin: 'left center'
        });

        gsap.set(storefrontLabel, {
          opacity: 0,
          y: 5
        });
      };

     if (reducedMotion.matches) {
  setVisibleState();

  gsap.set(browserDotsGroup, {
    visibility: 'visible'
  });

  root.classList.add('is-gsap-ready');

  return;
}

setInitialState();

gsap.set(browserDotsGroup, {
  visibility: 'visible'
});

root.classList.add('is-gsap-ready');

const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.7
      });

      timeline

        /* LEFT BLOCK */
        .to(commerceShell, {
          opacity: 1,
          x: 0,
          duration: 0.42,
          ease: 'power2.out'
        })

        .to(
          database,
          {
            opacity: 1,
            scale: 1,
            duration: 0.35,
            ease: 'back.out(1.4)'
          },
          '-=.12'
        )

        .to(
          commerceLabel,
          {
            opacity: 1,
            y: 0,
            duration: 0.28,
            ease: 'power2.out'
          },
          '-=.06'
        )

       .to(
  leftConnectors,
  {
    opacity: 1,
    strokeDashoffset: 0,
    duration: 0.42,
    stagger: 0.08,
    ease: 'power2.inOut'
  },
  '+=.08'
)

        .to(
          nodes.slice(0, 2),
          {
            opacity: 1,
            scale: 1,
            duration: 0.22,
            stagger: 0.08,
            ease: 'back.out(1.8)'
          },
          '-=.15'
        )

        /* API */
        .to(
          apiShell,
          {
            opacity: 1,
            scale: 1,
            duration: 0.36,
            ease: 'back.out(1.3)'
          },
          '-=.04'
        )

        .to(
          apiLabel,
          {
            opacity: 1,
            scale: 1,
            duration: 0.24,
            ease: 'power2.out'
          },
          '-=.13'
        )

       .to(
  rightConnectors,
  {
    opacity: 1,
    strokeDashoffset: 0,
    duration: 0.4,
    stagger: 0.08,
    ease: 'power2.inOut'
  },
  '+=.08'
)

        .to(
          q('.lp-caf__node--3'),
          {
            opacity: 1,
            scale: 1,
            duration: 0.22,
            ease: 'back.out(1.7)'
          },
          '-=.14'
        )

        /* STOREFRONT */
        .to(
          storefrontShell,
          {
            opacity: 1,
            x: 0,
            duration: 0.42,
            ease: 'power2.out'
          },
          '-=.04'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.055,
            ease: 'back.out(1.8)'
          },
          '-=.09'
        )

        .to(
  browserDivider,
  {
    opacity: 1,
    strokeDashoffset: 0,
    duration: 0.34,
    ease: 'power2.inOut'
  },
  '-=.02'
)

        .to(
          storefrontImage,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            stagger: 0.045,
            ease: 'power2.out'
          },
          '-=.06'
        )

        .to(
          storefrontLines,
          {
            opacity: 1,
            scaleX: 1,
            duration: 0.28,
            stagger: 0.08,
            ease: 'power2.out'
          },
          '-=.08'
        )

        .to(
          storefrontLabel,
          {
            opacity: 1,
            y: 0,
            duration: 0.32,
            ease: 'power2.out'
          },
          '+=.02'
        )

        /* HOLD */
        .to({}, {
          duration: 2
        })

        /* RESET */
        .to(root, {
          opacity: 0,
          duration: 0.24,
          ease: 'power1.in'
        })

        .call(() => {
          setInitialState();

          gsap.set(root, {
            opacity: 1
          });
        });

      let observer = null;

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                timeline.play();
              } else {
                timeline.pause();
              }
            });
          },
          {
            threshold: 0.15
          }
        );

        observer.observe(root);
      } else {
        timeline.play();
      }

      const handleReducedMotion = (event) => {
        if (event.matches) {
          timeline.pause(0);
          setVisibleState();
          return;
        }

        setInitialState();
        timeline.restart();
      };

      reducedMotion.addEventListener?.(
        'change',
        handleReducedMotion
      );

      instances.set(root, {
        timeline,
        observer,
        reducedMotion,
        handleReducedMotion
      });
    });
  };

  const destroyCommerceApiFlow = (scope) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-commerce-api-flow]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-commerce-api-flow]'
      )
      .forEach((root) => {
        roots.push(root);
      });

    roots.forEach((root) => {
      const instance = instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instance.reducedMotion?.removeEventListener?.(
        'change',
        instance.handleReducedMotion
      );

      instances.delete(root);

      delete root.dataset.lpCommerceApiFlowReady;
    });
  };

  const bootCommerceApiFlow = (attempt = 0) => {
    if (window.gsap) {
      initCommerceApiFlow();
      return;
    }

    if (attempt >= 120) return;

    requestAnimationFrame(() => {
      bootCommerceApiFlow(attempt + 1);
    });
  };

  bootCommerceApiFlow();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (!window.gsap) return;

      initCommerceApiFlow(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyCommerceApiFlow(event.target);
    }
  );
})();












/* =========================================================
   SVG ANIMATION: APP ECOSYSTEM
   Snippet: lp-problem-app-ecosystem.liquid
   CSS: lp-problem-app-ecosystem.css
   ========================================================= */


(() => {
  const instances = new WeakMap();

  const initProblemAppEcosystem = (scope = document) => {
    if (!window.gsap) return;

    const roots = [];

    if (
      scope.matches?.('[data-lp-problem-app-ecosystem]') &&
      scope.dataset.lpProblemAppEcosystemReady !== 'true'
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-app-ecosystem]:not([data-lp-problem-app-ecosystem-ready="true"])'
      )
      .forEach((root) => {
        roots.push(root);
      });

    roots.forEach((root) => {
      root.dataset.lpProblemAppEcosystemReady = 'true';

      const q = gsap.utils.selector(root);

      const shopify = q('.lp-pae__shopify');

      const connector1 = q(
        '.lp-pae__connector-group--1 .lp-pae__connector'
      );

      const connector2 = q(
        '.lp-pae__connector-group--2 .lp-pae__connector'
      );

      const connector3 = q(
        '.lp-pae__connector-group--3 .lp-pae__connector'
      );

      const connector4 = q(
        '.lp-pae__connector-group--4 .lp-pae__connector'
      );

      const app1 = q('.lp-pae__app--1');
      const app2 = q('.lp-pae__app--2');
      const app3 = q('.lp-pae__app--3');
      const app4 = q('.lp-pae__app--4');

      const allConnectors = [
        ...connector1,
        ...connector2,
        ...connector3,
        ...connector4
      ];

      const allApps = [
        ...app1,
        ...app2,
        ...app3,
        ...app4
      ];

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      const connectorLengths = new Map();

      allConnectors.forEach((path) => {
        const length = path.getTotalLength();

        connectorLengths.set(path, length);
      });

      const hideConnector = (paths) => {
        paths.forEach((path) => {
          const length = connectorLengths.get(path);

          if (!length) return;

          const reverse =
            path.dataset.reverse === 'true';

          gsap.set(path, {
            visibility: 'visible',
            opacity: 0,
            strokeDasharray: length,
            strokeDashoffset: reverse
              ? -length
              : length
          });
        });
      };
      const showConnector = (paths) => {
        paths.forEach((path) => {
          gsap.set(path, {
            visibility: 'visible',
            opacity: 1,
            strokeDasharray: '2 2',
            strokeDashoffset: 0
          });
        });
      };

      const setVisibleState = () => {
        gsap.set(
          [
            shopify,
            allApps
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        showConnector(allConnectors);
      };

      const setInitialState = () => {
        gsap.set(root, {
          opacity: 1
        });

        gsap.set(shopify, {
          opacity: 0,
          scale: 0.86,
          transformOrigin: 'center center'
        });

        gsap.set(allApps, {
          opacity: 0,
          scale: 0.9,
          transformOrigin: 'center center'
        });

        hideConnector(allConnectors);
      };

      if (reducedMotion.matches) {
        setVisibleState();
        return;
      }

      setInitialState();

      root.classList.add('is-gsap-ready');

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        /* 01 — Shopify */
        .to(shopify, {
          opacity: 1,
          scale: 1,
          duration: 0.42,
          ease: 'back.out(1.45)'
        })

        /* 02 — Connector 1 */
        .to(
          connector1,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            ease: 'power2.inOut'
          },
          '+=.12'
        )

        /* 03 — App 1 */
        .to(
          app1,
          {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.5)'
          },
          '-=.05'
        )

        .to(
          connector2,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            ease: 'power2.inOut'
          },
          '+=.12'
        )

        /* 05 — App 2 */
        .to(
          app2,
          {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.5)'
          },
          '-=.05'
        )

        .to(
          connector3,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            ease: 'power2.inOut'
          },
          '+=.12'
        )


        /* 07 — App 3 */
        .to(
          app3,
          {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.5)'
          },
          '-=.05'
        )

        .to(
          connector4,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            ease: 'power2.inOut'
          },
          '+=.12'
        )

        /* 09 — App 4 */
        .to(
          app4,
          {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.5)'
          },
          '-=.05'
        )

        /* Hold */
        .to({}, {
          duration: 2
        })

        /* Soft fade before restart */
        .to(root, {
          opacity: 0,
          duration: 0.24,
          ease: 'power1.in'
        })

        .call(() => {
          setInitialState();

          gsap.set(root, {
            opacity: 1
          });
        });

      let observer = null;

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                timeline.play();
              } else {
                timeline.pause();
              }
            });
          },
          {
            threshold: 0.15
          }
        );

        observer.observe(root);
      } else {
        timeline.play();
      }

      const handleReducedMotion = (event) => {
        if (event.matches) {
          timeline.pause(0);
          setVisibleState();
          return;
        }

        setInitialState();
        timeline.restart();
      };

      reducedMotion.addEventListener?.(
        'change',
        handleReducedMotion
      );

      instances.set(root, {
        timeline,
        observer,
        reducedMotion,
        handleReducedMotion
      });
    });
  };

  const destroyProblemAppEcosystem = (scope) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-app-ecosystem]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-app-ecosystem]'
      )
      .forEach((root) => {
        roots.push(root);
      });

    roots.forEach((root) => {
      const instance = instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instance.reducedMotion?.removeEventListener?.(
        'change',
        instance.handleReducedMotion
      );

      instances.delete(root);

      delete root.dataset.lpProblemAppEcosystemReady;
    });
  };

  const bootProblemAppEcosystem = (attempt = 0) => {
    if (window.gsap) {
      initProblemAppEcosystem();
      return;
    }

    if (attempt >= 120) return;

    requestAnimationFrame(() => {
      bootProblemAppEcosystem(attempt + 1);
    });
  };

  bootProblemAppEcosystem();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (!window.gsap) return;

      initProblemAppEcosystem(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyProblemAppEcosystem(event.target);
    }
  );
})();












/* =========================================================
   SVG ANIMATION: Social Performance
   Snippet: lp-problem-social-performance.liquid
   CSS: lp-problem-social-performance.css
   ========================================================= */

   (() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-social-performance]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-social-performance]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };


  const initProblemSocialPerformance = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpSocialPerformanceReady ===
        'true'
      ) {
        return;
      }

      root.dataset.lpSocialPerformanceReady =
        'true';

      const q = gsap.utils.selector(root);

      const base = q('.lp-spp__base');
      const cart = q('.lp-spp__cart');
      const dashboard = q('.lp-spp__dashboard');

      const socials = q('.lp-spp__social');

      const trend = q('.lp-spp__trend');
      const trendLine =
        q('.lp-spp__trend-line');

      const bars = q('.lp-spp__bar');
      const barFills =
        q('.lp-spp__bar-fill');

      const alert = q('.lp-spp__alert');
      const alertRing =
        q('.lp-spp__alert-ring');
      const alertDot =
        q('.lp-spp__alert-dot');

      const animated =
        q('.lp-spp__animated');


      /*
        Calculate trend line length only once.
      */
      const trendLengths = new Map();

      trendLine.forEach((path) => {
        trendLengths.set(
          path,
          path.getTotalLength()
        );
      });


      const getColors = () => {
        const styles =
          getComputedStyle(root);

        return {
          bar:
            styles
              .getPropertyValue(
                '--lp-spp-bar'
              )
              .trim() || '#111111',

          danger:
            styles
              .getPropertyValue(
                '--lp-spp-danger'
              )
              .trim() || '#ff1e26'
        };
      };


      const hideTrend = () => {
        trendLine.forEach((path) => {
          const length =
            trendLengths.get(path);

          gsap.set(path, {
            opacity: 0,
            strokeDasharray: length,
            strokeDashoffset: length
          });
        });
      };


      const setInitialState = () => {
        const colors = getColors();

        gsap.set(animated, {
          visibility: 'visible'
        });

        gsap.set(base, {
          opacity: 0,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(cart, {
          opacity: 0,
          scale: 0.72,
          x: -12,
          transformOrigin: 'center center'
        });

        gsap.set(dashboard, {
          opacity: 0,
          scale: 0.96,
          y: -12,
          transformOrigin: 'center center'
        });

        gsap.set(socials, {
          opacity: 0,
          scale: 0.65,
          y: -6,
          transformOrigin: 'center center'
        });

        gsap.set(trend, {
          opacity: 1
        });

        hideTrend();

        gsap.set(bars, {
          opacity: 0,
          y: 18,
          scale: 0.94,
          transformOrigin: 'center bottom'
        });

        gsap.set(barFills, {
          fill: colors.bar
        });

        gsap.set(alert, {
          opacity: 0,
          scale: 0.6,
          transformOrigin: 'center center'
        });

        gsap.set(alertRing, {
          opacity: 0
        });

        gsap.set(alertDot, {
          opacity: 0
        });
      };


      const showFinalState = () => {
        const colors = getColors();

        gsap.set(animated, {
          visibility: 'visible',
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1
        });

        trendLine.forEach((path) => {
          gsap.set(path, {
            opacity: 1,
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(barFills, {
          fill: colors.danger
        });

        gsap.set(alertRing, {
          opacity: 0.45
        });

        gsap.set(alertDot, {
          opacity: 1
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };


      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }


      setInitialState();

      /*
        Only remove CSS pre-animation hiding
        AFTER GSAP prepared every element.
      */
      root.classList.add(
        'is-gsap-ready'
      );


      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.55
      });


      timeline

        /*
          01
          Back panel.
        */
        .to(base, {
          opacity: 1,
          scale: 1,
          duration: 0.42,
          ease: 'power2.out'
        })


        /*
          02
          Cart comes in.
        */
        .to(
          cart,
          {
            opacity: 1,
            scale: 1,
            x: 0,
            duration: 0.32,
            ease: 'back.out(1.5)'
          },
          '+=.06'
        )


        /*
          03
          Tilted analytics dashboard.
        */
        .to(
          dashboard,
          {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.48,
            ease: 'power3.out'
          },
          '+=.08'
        )


        /*
          04–07
          Facebook, Instagram,
          LinkedIn and TikTok,
          one by one.
        */
        .to(
          socials,
          {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.3,
            stagger: 0.16,
            ease: 'back.out(1.7)'
          },
          '+=.08'
        )


        /*
          08
          Trend/relationship line draws.
        */
        .to(
          trendLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.62,
            ease: 'power2.inOut'
          },
          '+=.06'
        )


        /*
          09–12
          Analytics bars appear
          one after another.
        */
        .to(
          bars,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.34,
            stagger: 0.14,
            ease: 'back.out(1.35)'
          },
          '+=.05'
        )


        /*
          Once every bar exists,
          change all bar fills from
          black → red sequentially.
        */
        .to(
          barFills,
          {
            fill: () =>
              getColors().danger,

            duration: 0.38,
            stagger: 0.12,
            ease: 'power2.inOut'
          },
          '+=.2'
        )


        /*
          Final red warning point.
        */
        .to(
          alert,
          {
            opacity: 1,
            scale: 1,
            duration: 0.28,
            ease: 'back.out(1.8)'
          },
          '+=.08'
        )

        .to(
          alertRing,
          {
            opacity: 0.45,
            duration: 0.2
          },
          '<'
        )

        .to(
          alertDot,
          {
            opacity: 1,
            duration: 0.18
          },
          '<'
        )


        /*
          Small pulse on final marker.
        */
        .to(
          alert,
          {
            scale: 1.12,
            duration: 0.24,
            ease: 'power1.out'
          },
          '+=.08'
        )

        .to(alert, {
          scale: 1,
          duration: 0.24,
          ease: 'power1.inOut'
        })


        /*
          Hold completed illustration.
        */
        .to({}, {
          duration: 2
        })


        /*
          Fade actual timeline pieces,
          not the root wrapper.
        */
        .to(animated, {
          opacity: 0,
          duration: 0.28,
          ease: 'power1.in'
        })


        /*
          Prepare next loop.
        */
        .call(() => {
          setInitialState();
        });


      let observer = null;

      if ('IntersectionObserver' in window) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }


      instances.set(root, {
        timeline,
        observer
      });
    });
  };


  const destroyProblemSocialPerformance = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpSocialPerformanceReady;
    });
  };


  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(boot, 60);
      return;
    }

    initProblemSocialPerformance(
      document
    );
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initProblemSocialPerformance(
        event.target
      );
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyProblemSocialPerformance(
        event.target
      );
    }
  );


  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyProblemSocialPerformance(
            root
          );
        }
      );

      initProblemSocialPerformance(
        document
      );
    }
  );
})();








/* =========================================================
   SVG ANIMATION: Revenue AI graph
   Snippet: lp-problem-revenue-ai-graph.liquid
   CSS: lp-problem-revenue-ai-graph.css
   ========================================================= */

(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );


  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-revenue-ai-graph]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-revenue-ai-graph]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };


  const initRevenueAiGraph = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpRevenueAiGraphReady ===
        'true'
      ) {
        return;
      }

      root.dataset.lpRevenueAiGraphReady =
        'true';

      const q = gsap.utils.selector(root);

      const shell =
        q('.lp-rag__shell');

      const revenuePill =
        q('.lp-rag__revenue-pill');

      const miniBars =
        q('.lp-rag__mini-bar');

      const miniLine =
        q('.lp-rag__mini-line');

      const revenueLabel =
        q('.lp-rag__revenue-label');

      const avatar =
        q('.lp-rag__avatar');

      const metric =
        q('.lp-rag__metric');

      const leftFlow =
        q('.lp-rag__left-flow');

      const rightFlow =
        q('.lp-rag__right-flow');

      const flowLines =
        q('.lp-rag__flow-line');

      const leftTopTool =
        q('.lp-rag__tool--left-top');

      const chatgpt =
        q('.lp-rag__tool--chatgpt');

      const rightTopTool =
        q('.lp-rag__tool--right-top');

      const rightLowerTool =
        q('.lp-rag__tool--right-lower');

      const bars =
        q('.lp-rag__bar');

      const graphPath =
        q('.lp-rag__graph-path');

      const graphPoint =
        q('.lp-rag__graph-point');

      const animated =
        q('.lp-rag__animated');


      /*
        Calculate SVG line lengths once.
      */
      const pathLengths = new Map();

      [
        ...miniLine,
        ...flowLines,
        ...graphPath
      ].forEach((path) => {
        pathLengths.set(
          path,
          path.getTotalLength()
        );
      });


      const hideStroke = (paths) => {
        paths.forEach((path) => {
          const length =
            pathLengths.get(path);

          if (!length) return;

          gsap.set(path, {
            opacity: 0,
            strokeDasharray: length,
            strokeDashoffset: length
          });
        });
      };


      const showStrokeFinal = (paths) => {
        paths.forEach((path) => {
          gsap.set(path, {
            opacity: 1,
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });
      };


      const setInitialState = () => {
        gsap.set(animated, {
          visibility: 'visible'
        });

        gsap.set(bars, {
          visibility: 'visible'
        });


        /*
          Main panel
        */
        gsap.set(shell, {
          opacity: 0,
          scale: 0.96,
          transformOrigin: 'center center'
        });


        /*
          Revenue UI
        */
        gsap.set(revenuePill, {
          opacity: 0,
          y: -8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(miniBars, {
          opacity: 0,
          scaleY: 0,
          transformOrigin: 'center bottom'
        });

        hideStroke(miniLine);

        gsap.set(revenueLabel, {
          opacity: 0,
          x: -5
        });


        /*
          Avatar + metric
        */
        gsap.set(avatar, {
          opacity: 0,
          scale: 0.7,
          transformOrigin: 'center center'
        });

        gsap.set(metric, {
          opacity: 0,
          y: 7,
          scale: 0.94,
          transformOrigin: 'center center'
        });


        /*
          AI/tool integrations
        */
        gsap.set(
          [
            ...leftTopTool,
            ...chatgpt,
            ...rightTopTool,
            ...rightLowerTool
          ],
          {
            opacity: 0,
            scale: 0.65,
            transformOrigin: 'center center'
          }
        );

        gsap.set(leftFlow, {
          opacity: 1
        });

        gsap.set(rightFlow, {
          opacity: 1
        });

        hideStroke(flowLines);


        /*
          Main graph bars.
          Every bar grows from its own bottom.
        */
        gsap.set(bars, {
          opacity: 0,
          scaleY: 0,
          transformOrigin: '50% 100%'
        });


        /*
          Main graph connector is hidden
          until ALL bars have grown.
        */
        hideStroke(graphPath);

        gsap.set(graphPoint, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });
      };


      const showFinalState = () => {
        gsap.set(animated, {
          visibility: 'visible',
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1,
          scaleY: 1
        });

        gsap.set(bars, {
          visibility: 'visible',
          opacity: 1,
          scaleY: 1
        });

        showStrokeFinal(miniLine);
        showStrokeFinal(flowLines);
        showStrokeFinal(graphPath);

        gsap.set(graphPoint, {
          opacity: 1,
          scale: 1
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };


      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }


      /*
        IMPORTANT:
        prepare everything BEFORE allowing
        CSS to expose the SVG.
      */
      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );


      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.6
      });


      timeline

        /*
          01
          Main dashboard/card
        */
        .to(shell, {
          opacity: 1,
          scale: 1,
          duration: 0.45,
          ease: 'power3.out'
        })


        /*
          02
          Revenue pill
        */
        .to(
          revenuePill,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.36,
            ease: 'power2.out'
          },
          '+=.07'
        )


        /*
          03
          Tiny revenue graph bars
        */
        .to(
          miniBars,
          {
            opacity: 1,
            scaleY: 1,
            duration: 0.22,
            stagger: 0.07,
            ease: 'back.out(1.45)'
          },
          '-=.12'
        )


        /*
          04
          Tiny graph line
        */
        .to(
          miniLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.3,
            ease: 'power2.inOut'
          },
          '-=.07'
        )


        /*
          05
          Revenue vector text
        */
        .to(
          revenueLabel,
          {
            opacity: 1,
            x: 0,
            duration: 0.28,
            ease: 'power2.out'
          },
          '-=.12'
        )


        /*
          06
          Customer/avatar
        */
        .to(
          avatar,
          {
            opacity: 1,
            scale: 1,
            duration: 0.34,
            ease: 'back.out(1.65)'
          },
          '+=.06'
        )


        /*
          07
          -80% vector
        */
        .to(
          metric,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.34,
            ease: 'power3.out'
          },
          '+=.04'
        )


        /*
          08
          Left AI logo
        */
        .to(
          leftTopTool,
          {
            opacity: 1,
            scale: 1,
            duration: 0.28,
            ease: 'back.out(1.7)'
          },
          '+=.06'
        )


        /*
          09
          Left connector draws
        */
        .to(
          q(
            '.lp-rag__left-flow .lp-rag__flow-line'
          ),
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            stagger: 0.08,
            ease: 'power2.inOut'
          },
          '+=.03'
        )


        /*
          10
          ChatGPT icon
        */
        .to(
          chatgpt,
          {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.7)'
          },
          '-=.05'
        )


        /*
          11
          Right top tool
        */
        .to(
          rightTopTool,
          {
            opacity: 1,
            scale: 1,
            duration: 0.28,
            ease: 'back.out(1.7)'
          },
          '+=.04'
        )


        /*
          12
          Right connector draws
        */
        .to(
          q(
            '.lp-rag__right-flow .lp-rag__flow-line'
          ),
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            stagger: 0.08,
            ease: 'power2.inOut'
          },
          '+=.03'
        )


        /*
          13
          Right lower tool
        */
        .to(
          rightLowerTool,
          {
            opacity: 1,
            scale: 1,
            duration: 0.28,
            ease: 'back.out(1.7)'
          },
          '-=.04'
        )


        /*
          14
          MAIN GRAPH

          Every single bar grows one-by-one.
          This is deliberately slower than
          the surrounding UI so it reads clearly.
        */
        .to(
          bars,
          {
            opacity: 1,
            scaleY: 1,
            duration: 0.32,
            stagger: 0.11,
            ease: 'back.out(1.25)'
          },
          '+=.12'
        )


        /*
          15
          Only AFTER all bars finish,
          draw the graph connector.
        */
        .to(
          graphPath,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.7,
            ease: 'power2.inOut'
          },
          '+=.12'
        )


        /*
          16
          Connector endpoint
        */
        .to(
          graphPoint,
          {
            opacity: 1,
            scale: 1,
            duration: 0.28,
            ease: 'back.out(1.9)'
          },
          '-=.08'
        )


        /*
          Endpoint pulse
        */
        .to(
          graphPoint,
          {
            scale: 1.14,
            duration: 0.2,
            ease: 'power1.out'
          },
          '+=.05'
        )

        .to(graphPoint, {
          scale: 1,
          duration: 0.22,
          ease: 'power1.inOut'
        })


        /*
          Hold complete illustration
        */
        .to({}, {
          duration: 2
        })


        /*
          Clean fade before restart.
          Fade actual animation groups,
          not the entire parent wrapper.
        */
        .to(
          [
            ...animated,
            ...bars
          ],
          {
            opacity: 0,
            duration: 0.26,
            ease: 'power1.in'
          }
        )


        /*
          Reset
        */
        .call(() => {
          setInitialState();
        });


      let observer = null;

      if ('IntersectionObserver' in window) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }


      instances.set(root, {
        timeline,
        observer
      });
    });
  };


  const destroyRevenueAiGraph = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpRevenueAiGraphReady;
    });
  };


  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(boot, 60);
      return;
    }

    initRevenueAiGraph(document);
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initRevenueAiGraph(
        event.target
      );
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyRevenueAiGraph(
        event.target
      );
    }
  );


  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyRevenueAiGraph(root);
        }
      );

      initRevenueAiGraph(document);
    }
  );
})();











/* =========================================================
   SVG ANIMATION: AI workflow gap
   Snippet: lp-problem-ai-workflow-gap.liquid
   CSS: lp-problem-ai-workflow-gap.css
   ========================================================= */
(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-ai-workflow-gap]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-ai-workflow-gap]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initAiWorkflowGap = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpAiWorkflowGapReady ===
        'true'
      ) {
        return;
      }

      root.dataset.lpAiWorkflowGapReady =
        'true';

      const q = gsap.utils.selector(root);

      const shell =
        q('.lp-awg__shell');

      const headline =
        q('.lp-awg__headline');

      const headlineParts =
        q('.lp-awg__headline > path');

      const documentCard =
        q('.lp-awg__document');

      const documentParts =
        q('.lp-awg__document > *');

      const leftAvatar =
        q('.lp-awg__avatar--left');

      const rightAvatar =
        q('.lp-awg__avatar--right');

      const messagePanel =
        q('.lp-awg__message-panel');

      const messageParts =
        q('.lp-awg__message-panel > path');

      const animated =
        q('.lp-awg__animated');

      const setInitialState = () => {
        gsap.set(animated, {
          visibility: 'visible'
        });

        gsap.set(shell, {
          opacity: 0,
          scale: 0.965,
          transformOrigin: 'center center'
        });

        gsap.set(headline, {
          opacity: 1
        });

        gsap.set(headlineParts, {
          opacity: 0,
          y: -5
        });

        gsap.set(leftAvatar, {
          opacity: 0,
          scale: 0.72,
          x: -8,
          transformOrigin: 'center center'
        });

        gsap.set(documentCard, {
          opacity: 0,
          y: 10,
          scale: 0.95,
          transformOrigin: 'center center'
        });

        gsap.set(documentParts, {
          opacity: 0
        });

        gsap.set(messagePanel, {
          opacity: 0,
          y: 12,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        gsap.set(messageParts, {
          opacity: 0
        });

        gsap.set(rightAvatar, {
          opacity: 0,
          scale: 0.72,
          x: 8,
          transformOrigin: 'center center'
        });
      };

      const showFinalState = () => {
        gsap.set(animated, {
          visibility: 'visible',
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1
        });

        gsap.set(
          [
            ...headlineParts,
            ...documentParts,
            ...messageParts
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.7
      });

      timeline

        .to(shell, {
          opacity: 1,
          scale: 1,
          duration: 0.45,
          ease: 'power3.out'
        })

        .to(
          headlineParts,
          {
            opacity: 1,
            y: 0,
            duration: 0.3,
            stagger: 0.09,
            ease: 'power2.out'
          },
          '+=.05'
        )

        .to(
          leftAvatar,
          {
            opacity: 1,
            scale: 1,
            x: 0,
            duration: 0.36,
            ease: 'back.out(1.6)'
          },
          '+=.04'
        )

        .to(
          documentCard,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.38,
            ease: 'power3.out'
          },
          '+=.05'
        )

        .to(
          documentParts,
          {
            opacity: 1,
            duration: 0.18,
            stagger: 0.045,
            ease: 'power1.out'
          },
          '-=.18'
        )

        .to(
          messagePanel,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.42,
            ease: 'power3.out'
          },
          '+=.08'
        )

        .to(
          messageParts,
          {
            opacity: 1,
            duration: 0.22,
            stagger: 0.08,
            ease: 'power1.out'
          },
          '-=.18'
        )

        .to(
          rightAvatar,
          {
            opacity: 1,
            scale: 1,
            x: 0,
            duration: 0.38,
            ease: 'back.out(1.7)'
          },
          '+=.06'
        )

        .to(
          leftAvatar,
          {
            scale: 1.04,
            duration: 0.18,
            ease: 'power1.out'
          },
          '+=.12'
        )

        .to(
          leftAvatar,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )

        .to(
          rightAvatar,
          {
            scale: 1.05,
            duration: 0.18,
            ease: 'power1.out'
          },
          '-=.1'
        )

        .to(
          rightAvatar,
          {
            scale: 1,
            duration: 0.2,
            ease: 'power1.inOut'
          }
        )

        .to({}, {
          duration: 2
        })

        .to(
          animated,
          {
            opacity: 0,
            duration: 0.26,
            ease: 'power1.in'
          }
        )

        .call(() => {
          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyAiWorkflowGap = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpAiWorkflowGapReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(boot, 60);
      return;
    }

    initAiWorkflowGap(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAiWorkflowGap(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyAiWorkflowGap(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyAiWorkflowGap(root);
        }
      );

      initAiWorkflowGap(document);
    }
  );
})();






/* =========================================================
   SVG ANIMATION: Variant Overload
   Snippet: lp-problem-variant-overload.liquid
   CSS: lp-problem-variant-overload.css
   ========================================================= */

(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-variant-overload]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-variant-overload]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initVariantOverload = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpVariantOverloadReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-variant-overload__svg'
      );

      if (!svg) return;

      root.dataset.lpVariantOverloadReady =
        'true';

      const q = gsap.utils.selector(root);

      const browserShell =
        q('.lp-vo__browser-shell');

      const divider =
        q('.lp-vo__divider');

      const browserDots =
        q('.lp-vo__browser-dots circle');

      const row1Buttons =
        q('.lp-vo__row--1 .lp-vo__button');

      const row2Buttons =
        q('.lp-vo__row--2 .lp-vo__button');

      const row3Buttons =
        q('.lp-vo__row--3 .lp-vo__button');

      const row4Buttons =
        q('.lp-vo__row--4 .lp-vo__button');

      const row5Buttons =
        q('.lp-vo__row--5 .lp-vo__button');

      const conversionCard =
        q('.lp-vo__metric--conversion');

      const aovCard =
        q('.lp-vo__metric--aov');

      const revenueCard =
        q('.lp-vo__metric--revenue');

      const metrics =
        q('.lp-vo__metric');

      const allButtons = [
        ...row1Buttons,
        ...row2Buttons,
        ...row3Buttons,
        ...row4Buttons,
        ...row5Buttons
      ];

      const dividerLength =
        divider[0]?.getTotalLength?.() || 0;

      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });

        gsap.set(browserShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        gsap.set(divider, {
          opacity: 0,
          strokeDasharray: dividerLength,
          strokeDashoffset: dividerLength
        });

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(allButtons, {
          opacity: 0,
          y: 6,
          scale: 0.94,
          transformOrigin: 'center center'
        });

        gsap.set(metrics, {
          opacity: 0,
          y: 14,
          scale: 0.96,
          transformOrigin: 'center center'
        });
      };

      const showFinalState = () => {
        gsap.set(
          [
            ...browserShell,
            ...browserDots,
            ...allButtons,
            ...metrics
          ],
          {
            visibility: 'visible',
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        gsap.set(divider, {
          visibility: 'visible',
          opacity: 1,
          strokeDasharray: 'none',
          strokeDashoffset: 0
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.7
      });

      timeline

        .to(browserShell, {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power3.out'
        })

        .to(
          divider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.4,
            ease: 'power2.inOut'
          },
          '-=.18'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.07,
            ease: 'back.out(1.7)'
          },
          '-=.16'
        )

        .to(
          row1Buttons,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.28,
            stagger: 0.075,
            ease: 'power2.out'
          },
          '+=.1'
        )

        .to(
          row2Buttons,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.28,
            stagger: 0.075,
            ease: 'power2.out'
          },
          '+=.02'
        )

        .to(
          row3Buttons,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.28,
            stagger: 0.075,
            ease: 'power2.out'
          },
          '+=.02'
        )

        .to(
          row4Buttons,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.28,
            stagger: 0.075,
            ease: 'power2.out'
          },
          '+=.02'
        )

        .to(
          row5Buttons,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.28,
            stagger: 0.075,
            ease: 'power2.out'
          },
          '+=.02'
        )

        .to(
          conversionCard,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.36,
            ease: 'power3.out'
          },
          '+=.12'
        )

        .to(
          aovCard,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.36,
            ease: 'power3.out'
          },
          '-=.18'
        )

        .to(
          revenueCard,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.36,
            ease: 'power3.out'
          },
          '-=.18'
        )

        .to(
          revenueCard,
          {
            scale: 1.035,
            duration: 0.2,
            ease: 'power1.out'
          },
          '+=.12'
        )

        .to(
          revenueCard,
          {
            scale: 1,
            duration: 0.22,
            ease: 'power1.inOut'
          }
        )

        .to({}, {
          duration: 2
        })

        .to(
          [
            ...browserDots,
            ...allButtons,
            ...metrics,
            ...divider,
            ...browserShell
          ],
          {
            opacity: 0,
            duration: 0.25,
            ease: 'power1.in'
          }
        )

        .call(() => {
          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyVariantOverload = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpVariantOverloadReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );

      return;
    }

    initVariantOverload(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initVariantOverload(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyVariantOverload(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyVariantOverload(root);
        }
      );

      initVariantOverload(document);
    }
  );
})();







/* =========================================================
   SVG ANIMATION: Magento Migration Flow
   Snippet: lp-problem-migration-flow.liquid
   CSS: lp-problem-migration-flow.css
   ========================================================= */


(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-migration-flow]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-migration-flow]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initMigrationFlow = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpMigrationFlowReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-migration-flow__svg'
      );

      if (!svg) return;

      root.dataset.lpMigrationFlowReady =
        'true';

      const q = gsap.utils.selector(root);

      const sourceCard =
        q('.lp-mf__source-card');

      const sourceBrand =
        q('.lp-mf__source-brand');

      const connectors =
        q('.lp-mf__connector');

      const node1 =
        q('.lp-mf__node--1');

      const node2 =
        q('.lp-mf__node--2');

      const node3 =
        q('.lp-mf__node--3');

      const node4 =
        q('.lp-mf__node--4');

      const arrow =
        q('.lp-mf__arrow');

      const destinationCard =
        q('.lp-mf__destination-card');

      const destinationBrand =
        q('.lp-mf__destination-brand');

      const destinationWordmark =
        q('.lp-mf__destination-wordmark');

      const success =
        q('.lp-mf__success');

      const connectorLengths =
        connectors.map((connector) => {
          return connector.getTotalLength();
        });

      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });

        gsap.set(sourceCard, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        gsap.set(sourceBrand, {
          opacity: 0,
          y: 5
        });

        connectors.forEach(
          (connector, index) => {
            const length =
              connectorLengths[index];

            gsap.set(connector, {
              opacity: 0,
              strokeDasharray: length,
              strokeDashoffset: length
            });
          }
        );

        gsap.set(
          [
            ...node1,
            ...node2,
            ...node3,
            ...node4
          ],
          {
            opacity: 0,
            scale: 0.92,
            transformOrigin: 'center center'
          }
        );

        gsap.set(arrow, {
          opacity: 0,
          x: -8
        });

        gsap.set(destinationCard, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        gsap.set(
          [
            ...destinationBrand,
            ...destinationWordmark
          ],
          {
            opacity: 0,
            y: 5
          }
        );

        gsap.set(success, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });
      };

      const showFinalState = () => {
        gsap.set(
          [
            ...sourceCard,
            ...sourceBrand,
            ...connectors,
            ...node1,
            ...node2,
            ...node3,
            ...node4,
            ...arrow,
            ...destinationCard,
            ...destinationBrand,
            ...destinationWordmark,
            ...success
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        connectors.forEach(
          (connector) => {
            gsap.set(connector, {
              strokeDasharray: 'none',
              strokeDashoffset: 0
            });
          }
        );

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        .to(sourceCard, {
          opacity: 1,
          scale: 1,
          duration: 0.35,
          ease: 'power2.out'
        })

        .to(
          sourceBrand,
          {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: 'power2.out'
          },
          '-=.12'
        )

        .to(
          connectors[0],
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.36,
            ease: 'power2.inOut'
          },
          '+=.06'
        )

        .to(node1, {
          opacity: 1,
          scale: 1,
          duration: 0.26,
          ease: 'power2.out'
        })

        .to(connectors[1], {
          opacity: 1,
          strokeDashoffset: 0,
          duration: 0.22,
          ease: 'power2.inOut'
        })

        .to(node2, {
          opacity: 1,
          scale: 1,
          duration: 0.26,
          ease: 'power2.out'
        })

        .to(connectors[2], {
          opacity: 1,
          strokeDashoffset: 0,
          duration: 0.22,
          ease: 'power2.inOut'
        })

        .to(node3, {
          opacity: 1,
          scale: 1,
          duration: 0.26,
          ease: 'power2.out'
        })

        .to(connectors[3], {
          opacity: 1,
          strokeDashoffset: 0,
          duration: 0.22,
          ease: 'power2.inOut'
        })

        .to(node4, {
          opacity: 1,
          scale: 1,
          duration: 0.26,
          ease: 'power2.out'
        })

        .to(connectors[4], {
          opacity: 1,
          strokeDashoffset: 0,
          duration: 0.26,
          ease: 'power2.inOut'
        })

        .to(
          arrow,
          {
            opacity: 1,
            x: 0,
            duration: 0.28,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          destinationCard,
          {
            opacity: 1,
            scale: 1,
            duration: 0.34,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          destinationBrand,
          {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: 'power2.out'
          }
        )

        .to(
          destinationWordmark,
          {
            opacity: 1,
            y: 0,
            duration: 0.25,
            ease: 'power2.out'
          },
          '-=.14'
        )

        .to(
          success,
          {
            opacity: 1,
            scale: 1,
            duration: 0.2,
            ease: 'back.out(1.5)'
          },
          '+=.04'
        )

        .to({}, {
          duration: 2
        })

        .to(
          [
            ...sourceCard,
            ...sourceBrand,
            ...connectors,
            ...node1,
            ...node2,
            ...node3,
            ...node4,
            ...arrow,
            ...destinationCard,
            ...destinationBrand,
            ...destinationWordmark,
            ...success
          ],
          {
            opacity: 0,
            duration: 0.25,
            ease: 'power1.in'
          }
        )

        .call(() => {
          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyMigrationFlow = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpMigrationFlowReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );

      return;
    }

    initMigrationFlow(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initMigrationFlow(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyMigrationFlow(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyMigrationFlow(root);
        }
      );

      initMigrationFlow(document);
    }
  );
})();

















/* =========================================================
   SVG ANIMATION: App Confilt
   Snippet: lp-problem-app-conflict.liquid
   CSS: lp-problem-app-conflict.css
   ========================================================= */

(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-app-conflict]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-app-conflict]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initAppConflict = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpAppConflictReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-app-conflict__svg'
      );

      if (!svg) return;

      const paths = Array.from(
        svg.children
      ).filter(
        (element) =>
          element.tagName.toLowerCase() ===
          'path'
      );

      if (paths.length < 34) {
        root.classList.add(
          'is-gsap-ready'
        );
        return;
      }

      root.dataset.lpAppConflictReady =
        'true';

      const browserShell = paths[0];
      const browserDivider = paths[1];

      const browserDots =
        paths.slice(2, 5);

      const topSkeleton =
        paths[5];

      const topControls =
        paths.slice(6, 8);

      const productVisual =
        paths.slice(8, 11);

      const productContent =
        paths.slice(11, 14);

      const addToCart =
        paths[14];

      const codeShell =
        paths[15];

      const codeDots =
        paths.slice(16, 19);

      const codeLines =
        paths.slice(19, 22);

      const codeError =
        paths.slice(22, 24);

      const conflictCard =
        paths[24];

      const conflictNode =
        paths[25];

      const connector1 =
        paths[26];

      const connectorDot1 =
        paths[27];

      const connector2 =
        paths[28];

      const connectorDot2 =
        paths[29];

      const warningBadge =
        paths.slice(30, 34);

      const drawablePaths = [
        browserDivider,
        connector1,
        connector2
      ];

      const lengths = new Map();

      drawablePaths.forEach((path) => {
        if (
          path &&
          typeof path.getTotalLength ===
            'function'
        ) {
          lengths.set(
            path,
            path.getTotalLength()
          );
        }
      });

      const hideLine = (path) => {
        const length =
          lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };

      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });

        gsap.set(browserShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        hideLine(browserDivider);

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(
          [
            topSkeleton,
            ...topControls
          ],
          {
            opacity: 0,
            y: -5
          }
        );

        gsap.set(productVisual, {
          opacity: 0,
          y: 8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(productContent, {
          opacity: 0,
          x: 8
        });

        gsap.set(addToCart, {
          opacity: 0,
          scale: 0.92,
          transformOrigin: 'center center'
        });

        gsap.set(codeShell, {
          opacity: 0,
          y: 14,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(codeDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(codeLines, {
          opacity: 0,
          scaleX: 0,
          transformOrigin: 'left center'
        });

        gsap.set(codeError, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        hideLine(connector1);
        hideLine(connector2);

        gsap.set(
          [
            connectorDot1,
            connectorDot2
          ],
          {
            opacity: 0,
            scale: 0,
            transformOrigin: 'center center'
          }
        );

        gsap.set(conflictCard, {
          opacity: 0,
          x: 14,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(conflictNode, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(warningBadge, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });
      };

      const showFinalState = () => {
        gsap.set(paths, {
          opacity: 1,
          x: 0,
          y: 0,
          scale: 1,
          scaleX: 1
        });

        drawablePaths.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        .to(browserShell, {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power3.out'
        })

        .to(
          browserDivider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            ease: 'power2.inOut'
          },
          '-=.18'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.06,
            ease: 'back.out(1.8)'
          },
          '-=.16'
        )

        .to(
          [
            topSkeleton,
            ...topControls
          ],
          {
            opacity: 1,
            y: 0,
            duration: 0.22,
            stagger: 0.05,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          productVisual,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            stagger: 0.045,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          productContent,
          {
            opacity: 1,
            x: 0,
            duration: 0.24,
            stagger: 0.05,
            ease: 'power2.out'
          },
          '-=.12'
        )

        .to(
          addToCart,
          {
            opacity: 1,
            scale: 1,
            duration: 0.27,
            ease: 'back.out(1.4)'
          },
          '+=.03'
        )

        .to(
          codeShell,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.36,
            ease: 'power3.out'
          },
          '+=.12'
        )

        .to(
          codeDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            stagger: 0.06,
            ease: 'back.out(1.8)'
          },
          '-=.16'
        )

        .to(
          codeLines,
          {
            opacity: 1,
            scaleX: 1,
            duration: 0.22,
            stagger: 0.08,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          codeError,
          {
            opacity: 1,
            scale: 1,
            duration: 0.23,
            ease: 'back.out(1.7)'
          },
          '+=.06'
        )

        .to(
          connector1,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.38,
            ease: 'power2.inOut'
          },
          '+=.04'
        )

        .to(
          connectorDot1,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '-=.1'
        )

        .to(
          connector2,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            ease: 'power2.inOut'
          },
          '-=.04'
        )

        .to(
          connectorDot2,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '-=.1'
        )

        .to(
          conflictCard,
          {
            opacity: 1,
            x: 0,
            scale: 1,
            duration: 0.36,
            ease: 'power3.out'
          },
          '+=.04'
        )

        .to(
          conflictNode,
          {
            opacity: 1,
            scale: 1,
            duration: 0.2,
            ease: 'back.out(1.8)'
          },
          '-=.1'
        )

        .to(
          warningBadge,
          {
            opacity: 1,
            scale: 1,
            duration: 0.24,
            stagger: 0.04,
            ease: 'back.out(1.6)'
          },
          '+=.08'
        )

        .to(
          warningBadge,
          {
            scale: 1.06,
            duration: 0.18,
            ease: 'power1.out'
          },
          '+=.08'
        )

        .to(
          warningBadge,
          {
            scale: 1,
            duration: 0.2,
            ease: 'power1.inOut'
          }
        )

        .to(
          codeError,
          {
            scale: 1.15,
            duration: 0.16,
            ease: 'power1.out'
          },
          '-=.1'
        )

        .to(
          codeError,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )

        .to({}, {
          duration: 2
        })

        .to(
          paths,
          {
            opacity: 0,
            duration: 0.28,
            ease: 'power1.in'
          }
        )

        .call(() => {
          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyAppConflict = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpAppConflictReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );
      return;
    }

    initAppConflict(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAppConflict(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyAppConflict(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyAppConflict(root);
        }
      );

      initAppConflict(document);
    }
  );
})();









/* =========================================================
   SVG ANIMATION: App code residue
   Snippet: lp-problem-app-code-residue.liquid
   CSS: lp-problem-app-code-residue.css
   ========================================================= */

(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-app-code-residue]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-app-code-residue]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initAppCodeResidue = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpAppCodeResidueReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-app-code-residue__svg'
      );

      if (!svg) return;

      root.dataset.lpAppCodeResidueReady =
        'true';

      const q = gsap.utils.selector(root);

      const browserShell =
        q('.lp-acr__browser-shell');

      const browserDivider =
        q('.lp-acr__browser-divider');

      const browserDots =
        q('.lp-acr__browser-dots circle');

      const headerPlaceholder =
        q('.lp-acr__header-placeholder');

      const product =
        q('.lp-acr__product');

      const productCopy =
        q('.lp-acr__product-copy');

      const addToCart =
        q('.lp-acr__add-to-cart');

      const deletedCard =
        q('.lp-acr__deleted-card');

      const deletedIcon =
        q('.lp-acr__deleted-icon-bg, .lp-acr__deleted-icon');

      const deletedSlash =
        q('.lp-acr__deleted-slash');

      const deletedLabel =
        q('.lp-acr__deleted-label');

      const redLine =
        q('.lp-acr__dependency-line--red');

      const yellowLine =
        q('.lp-acr__dependency-line--yellow');

      const redDot =
        q('.lp-acr__dependency-dot--red');

      const yellowDot =
        q('.lp-acr__dependency-dot--yellow');

      const themePanelShell =
        q('.lp-acr__theme-panel-shell');

      const themeTitle =
        q('.lp-acr__theme-title');

      const themeFile1 =
        q('.lp-acr__theme-file--1');

      const themeFile2 =
        q('.lp-acr__theme-file--2');

      const warning =
        q('.lp-acr__warning');

      const warningIcon =
        q('.lp-acr__warning-icon-bg, .lp-acr__warning-cross');

      const lines = [
        browserDivider[0],
        deletedSlash[0],
        redLine[0],
        yellowLine[0]
      ].filter(Boolean);

      const lengths = new Map();

      lines.forEach((path) => {
        if (
          typeof path.getTotalLength ===
          'function'
        ) {
          lengths.set(
            path,
            path.getTotalLength()
          );
        }
      });

      const hideLine = (path) => {
        const length =
          lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };

      const resetLine = (path) => {
        const length =
          lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };

      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });

        gsap.set(browserShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        hideLine(browserDivider[0]);

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(headerPlaceholder, {
          opacity: 0,
          x: -6
        });

        gsap.set(product, {
          opacity: 0,
          y: 8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(productCopy, {
          opacity: 0,
          x: 8
        });

        gsap.set(addToCart, {
          opacity: 0,
          scale: 0.92,
          transformOrigin: 'center center'
        });

        gsap.set(deletedCard, {
          opacity: 0,
          x: -14,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(deletedIcon, {
          opacity: 0,
          scale: 0.8,
          transformOrigin: 'center center'
        });

        hideLine(deletedSlash[0]);

        gsap.set(deletedLabel, {
          opacity: 0,
          y: 4
        });

        hideLine(redLine[0]);
        hideLine(yellowLine[0]);

        gsap.set(
          [
            ...redDot,
            ...yellowDot
          ],
          {
            opacity: 0,
            scale: 0,
            transformOrigin: 'center center'
          }
        );

        gsap.set(themePanelShell, {
          opacity: 0,
          y: 14,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        gsap.set(themeTitle, {
          opacity: 0,
          y: 5
        });

        gsap.set(
          [
            ...themeFile1,
            ...themeFile2
          ],
          {
            opacity: 0,
            x: -8
          }
        );

        gsap.set(warning, {
          opacity: 0,
          x: 18,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(warningIcon, {
          scale: 0,
          transformOrigin: 'center center'
        });
      };

      const showFinalState = () => {
        gsap.set(
          [
            ...browserShell,
            ...browserDots,
            ...headerPlaceholder,
            ...product,
            ...productCopy,
            ...addToCart,
            ...deletedCard,
            ...deletedIcon,
            ...deletedSlash,
            ...deletedLabel,
            ...redLine,
            ...yellowLine,
            ...redDot,
            ...yellowDot,
            ...themePanelShell,
            ...themeTitle,
            ...themeFile1,
            ...themeFile2,
            ...warning
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        lines.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        .to(browserShell, {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power3.out'
        })

        .to(
          browserDivider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.35,
            ease: 'power2.inOut'
          },
          '-=.18'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.06,
            ease: 'back.out(1.8)'
          },
          '-=.18'
        )

        .to(
          headerPlaceholder,
          {
            opacity: 1,
            x: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          product,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          productCopy,
          {
            opacity: 1,
            x: 0,
            duration: 0.28,
            ease: 'power2.out'
          },
          '-=.16'
        )

        .to(
          addToCart,
          {
            opacity: 1,
            scale: 1,
            duration: 0.28,
            ease: 'back.out(1.45)'
          },
          '-=.05'
        )

        .to(
          deletedCard,
          {
            opacity: 1,
            x: 0,
            scale: 1,
            duration: 0.35,
            ease: 'power3.out'
          },
          '+=.12'
        )

        .to(
          deletedIcon,
          {
            opacity: 1,
            scale: 1,
            duration: 0.22,
            ease: 'back.out(1.6)'
          },
          '-=.16'
        )

        .to(
          deletedSlash,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.28,
            ease: 'power2.inOut'
          },
          '-=.04'
        )

        .to(
          deletedLabel,
          {
            opacity: 1,
            y: 0,
            duration: 0.22,
            ease: 'power2.out'
          }
        )

        .to(
          redLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            ease: 'power2.inOut'
          },
          '+=.08'
        )

        .to(
          redDot,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '-=.12'
        )

        .to(
          yellowLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.42,
            ease: 'power2.inOut'
          },
          '-=.12'
        )

        .to(
          yellowDot,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '-=.12'
        )

        .to(
          themePanelShell,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.38,
            ease: 'power3.out'
          },
          '+=.08'
        )

        .to(
          themeTitle,
          {
            opacity: 1,
            y: 0,
            duration: 0.22,
            ease: 'power2.out'
          }
        )

        .to(
          themeFile1,
          {
            opacity: 1,
            x: 0,
            duration: 0.28,
            ease: 'power2.out'
          },
          '+=.02'
        )

        .to(
          themeFile2,
          {
            opacity: 1,
            x: 0,
            duration: 0.28,
            ease: 'power2.out'
          },
          '-=.1'
        )

        .to(
          warning,
          {
            opacity: 1,
            x: 0,
            scale: 1,
            duration: 0.35,
            ease: 'back.out(1.35)'
          },
          '+=.08'
        )

        .to(
          warningIcon,
          {
            scale: 1,
            duration: 0.22,
            ease: 'back.out(1.8)'
          },
          '-=.18'
        )

        .to(
          redDot,
          {
            scale: 1.3,
            duration: 0.16,
            ease: 'power1.out'
          },
          '+=.12'
        )

        .to(
          redDot,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )

        .to(
          yellowDot,
          {
            scale: 1.3,
            duration: 0.16,
            ease: 'power1.out'
          },
          '-=.12'
        )

        .to(
          yellowDot,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )

        .to({}, {
          duration: 2
        })

        .to(
          [
            ...warning,
            ...themeFile1,
            ...themeFile2,
            ...themeTitle,
            ...themePanelShell,
            ...redDot,
            ...yellowDot,
            ...redLine,
            ...yellowLine,
            ...deletedLabel,
            ...deletedSlash,
            ...deletedIcon,
            ...deletedCard,
            ...addToCart,
            ...productCopy,
            ...product,
            ...headerPlaceholder,
            ...browserDots,
            ...browserDivider,
            ...browserShell
          ],
          {
            opacity: 0,
            duration: 0.28,
            ease: 'power1.in'
          }
        )

        .call(() => {
          resetLine(browserDivider[0]);
          resetLine(deletedSlash[0]);
          resetLine(redLine[0]);
          resetLine(yellowLine[0]);

          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyAppCodeResidue = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpAppCodeResidueReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );
      return;
    }

    initAppCodeResidue(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAppCodeResidue(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyAppCodeResidue(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyAppCodeResidue(root);
        }
      );

      initAppCodeResidue(document);
    }
  );
})();






/* =========================================================
   SVG ANIMATION: Store complexity
   Snippet: lp-problem-store-complexity.liquid
   CSS: lp-problem-store-complexity.css
   ========================================================= */


   (() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-store-complexity]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-store-complexity]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initStoreComplexity = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpStoreComplexityReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-store-complexity__svg'
      );

      if (!svg) return;

      root.dataset.lpStoreComplexityReady =
        'true';

      const q = gsap.utils.selector(root);

      const browserShell =
        q('.lp-sc__browser-shell');

      const browserDivider =
        q('.lp-sc__browser-divider');

      const browserDots =
        q('.lp-sc__browser-dots circle');

      const headerPlaceholder =
        q('.lp-sc__header-placeholder');

      const headerActions =
        q('.lp-sc__header-actions rect');

      const product =
        q('.lp-sc__product');

      const productCopy =
        q('.lp-sc__product-copy');

      const updateButton =
        q('.lp-sc__update-button');

      const appsCard =
        q('.lp-sc__apps-card');

      const appsIcons =
        q('.lp-sc__apps-icons rect');

      const appsProblemLine =
        q('.lp-sc__apps-problem-line');

      const codeCard =
        q('.lp-sc__code-card');

      const codeLines =
        q('.lp-sc__code-line');

      const fixesCard =
        q('.lp-sc__fixes-card');

      const fixesStatus =
        q('.lp-sc__fixes-status');

      const connectorApps =
        q('.lp-sc__connector--apps');

      const connectorCode =
        q('.lp-sc__connector--code');

      const connectorFixes =
        q('.lp-sc__connector--fixes');

      const dotApps =
        q('.lp-sc__connector-dot--apps');

      const dotCode =
        q('.lp-sc__connector-dot--code');

      const dotFixes =
        q('.lp-sc__connector-dot--fixes');

      const crossLinks =
        q('.lp-sc__cross-link');

      const warning =
        q('.lp-sc__warning');

      const warningTriangle =
        q('.lp-sc__warning-triangle');

      const warningLine =
        q('.lp-sc__warning-line');

      const warningDot =
        q('.lp-sc__warning-dot');

      const drawablePaths = [
        browserDivider[0],
        appsProblemLine[0],
        connectorApps[0],
        connectorCode[0],
        connectorFixes[0],
        ...crossLinks
      ].filter(Boolean);

      const pathLengths = new Map();

      drawablePaths.forEach((path) => {
        if (
          typeof path.getTotalLength ===
          'function'
        ) {
          pathLengths.set(
            path,
            path.getTotalLength()
          );
        }
      });

      const hidePath = (path) => {
        const length =
          pathLengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };

      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });

        gsap.set(browserShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        hidePath(browserDivider[0]);

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(headerPlaceholder, {
          opacity: 0,
          x: -6
        });

        gsap.set(headerActions, {
          opacity: 0,
          scale: 0.8,
          transformOrigin: 'center center'
        });

        gsap.set(product, {
          opacity: 0,
          y: 8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(productCopy, {
          opacity: 0,
          x: 8
        });

        gsap.set(updateButton, {
          opacity: 0,
          scale: 0.92,
          transformOrigin: 'center center'
        });

        gsap.set(
          [
            ...appsCard,
            ...codeCard,
            ...fixesCard
          ],
          {
            opacity: 0,
            y: 14,
            scale: 0.96,
            transformOrigin: 'center center'
          }
        );

        gsap.set(appsIcons, {
          opacity: 0,
          scale: 0.8,
          transformOrigin: 'center center'
        });

        hidePath(appsProblemLine[0]);

        gsap.set(codeLines, {
          opacity: 0,
          scaleX: 0,
          transformOrigin: 'left center'
        });

        gsap.set(fixesStatus, {
          opacity: 0,
          scale: 0.9,
          transformOrigin: 'center center'
        });

        [
          connectorApps[0],
          connectorCode[0],
          connectorFixes[0],
          ...crossLinks
        ].forEach(hidePath);

        gsap.set(
          [
            ...dotApps,
            ...dotCode,
            ...dotFixes
          ],
          {
            opacity: 0,
            scale: 0,
            transformOrigin: 'center center'
          }
        );

        gsap.set(warning, {
          opacity: 0,
          scale: 0.82,
          transformOrigin: 'center center'
        });

        gsap.set(warningTriangle, {
          scale: 0.8,
          transformOrigin: 'center center'
        });

        gsap.set(
          [
            ...warningLine,
            ...warningDot
          ],
          {
            opacity: 0
          }
        );
      };

      const showFinalState = () => {
        gsap.set(
          [
            ...browserShell,
            ...browserDots,
            ...headerPlaceholder,
            ...headerActions,
            ...product,
            ...productCopy,
            ...updateButton,
            ...appsCard,
            ...codeCard,
            ...fixesCard,
            ...appsIcons,
            ...appsProblemLine,
            ...codeLines,
            ...fixesStatus,
            ...connectorApps,
            ...connectorCode,
            ...connectorFixes,
            ...crossLinks,
            ...dotApps,
            ...dotCode,
            ...dotFixes,
            ...warning,
            ...warningTriangle,
            ...warningLine,
            ...warningDot
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            scaleX: 1
          }
        );

        drawablePaths.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        .to(browserShell, {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power3.out'
        })

        .to(
          browserDivider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            ease: 'power2.inOut'
          },
          '-=.18'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.06,
            ease: 'back.out(1.8)'
          },
          '-=.16'
        )

        .to(
          headerPlaceholder,
          {
            opacity: 1,
            x: 0,
            duration: 0.2,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          headerActions,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.05,
            ease: 'back.out(1.5)'
          },
          '-=.12'
        )

        .to(
          product,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          productCopy,
          {
            opacity: 1,
            x: 0,
            duration: 0.26,
            ease: 'power2.out'
          },
          '-=.15'
        )

        .to(
          updateButton,
          {
            opacity: 1,
            scale: 1,
            duration: 0.26,
            ease: 'back.out(1.4)'
          },
          '-=.04'
        )

        .to(
          connectorApps,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.38,
            ease: 'power2.inOut'
          },
          '+=.12'
        )

        .to(
          dotApps,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.1'
        )

        .to(
          appsCard,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            ease: 'power3.out'
          },
          '-=.05'
        )

        .to(
          appsIcons,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.05,
            ease: 'back.out(1.5)'
          }
        )

        .to(
          appsProblemLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.25,
            ease: 'power2.inOut'
          },
          '-=.08'
        )

        .to(
          connectorCode,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            ease: 'power2.inOut'
          },
          '+=.04'
        )

        .to(
          dotCode,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.09'
        )

        .to(
          codeCard,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            ease: 'power3.out'
          },
          '-=.04'
        )

        .to(
          codeLines,
          {
            opacity: 1,
            scaleX: 1,
            duration: 0.22,
            stagger: 0.07,
            ease: 'power2.out'
          }
        )

        .to(
          connectorFixes,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.38,
            ease: 'power2.inOut'
          },
          '+=.04'
        )

        .to(
          dotFixes,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.09'
        )

        .to(
          fixesCard,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            ease: 'power3.out'
          },
          '-=.04'
        )

        .to(
          fixesStatus,
          {
            opacity: 1,
            scale: 1,
            duration: 0.22,
            ease: 'back.out(1.5)'
          }
        )

        .to(
          crossLinks,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            stagger: 0.1,
            ease: 'power2.inOut'
          },
          '+=.06'
        )

        .to(
          warning,
          {
            opacity: 1,
            scale: 1,
            duration: 0.34,
            ease: 'back.out(1.45)'
          },
          '+=.06'
        )

        .to(
          warningTriangle,
          {
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.7)'
          },
          '-=.18'
        )

        .to(
          [
            ...warningLine,
            ...warningDot
          ],
          {
            opacity: 1,
            duration: 0.15,
            stagger: 0.06
          }
        )

        .to(
          warning,
          {
            scale: 1.06,
            duration: 0.18,
            ease: 'power1.out'
          },
          '+=.08'
        )

        .to(warning, {
          scale: 1,
          duration: 0.2,
          ease: 'power1.inOut'
        })

        .to({}, {
          duration: 2
        })

        .to(
          [
            ...warning,
            ...crossLinks,
            ...fixesStatus,
            ...fixesCard,
            ...dotFixes,
            ...connectorFixes,
            ...codeLines,
            ...codeCard,
            ...dotCode,
            ...connectorCode,
            ...appsProblemLine,
            ...appsIcons,
            ...appsCard,
            ...dotApps,
            ...connectorApps,
            ...updateButton,
            ...productCopy,
            ...product,
            ...headerActions,
            ...headerPlaceholder,
            ...browserDots,
            ...browserDivider,
            ...browserShell
          ],
          {
            opacity: 0,
            duration: 0.28,
            ease: 'power1.in'
          }
        )

        .call(() => {
          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyStoreComplexity = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpStoreComplexityReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );

      return;
    }

    initStoreComplexity(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initStoreComplexity(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyStoreComplexity(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyStoreComplexity(root);
        }
      );

      initStoreComplexity(document);
    }
  );
})();









/* =========================================================
   SVG ANIMATION: Patch Stack
   Snippet: lp-problem-patch-stack.liquid
   CSS: lp-problem-patch-stack.css
   ========================================================= */


   (() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-patch-stack]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-patch-stack]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initPatchStack = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpPatchStackReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-patch-stack__svg'
      );

      if (!svg) return;

      root.dataset.lpPatchStackReady =
        'true';

      const q = gsap.utils.selector(root);

      const browserShell =
        q('.lp-ps__browser-shell');

      const browserDivider =
        q('.lp-ps__browser-divider');

      const browserDots =
        q('.lp-ps__browser-dots circle');

      const header =
        q('.lp-ps__header-placeholder');

      const product =
        q('.lp-ps__product');

      const productCopy =
        q('.lp-ps__product-copy');

      const cart =
        q('.lp-ps__cart');

      const productWarning =
        q('.lp-ps__product-warning');

      const patch1 =
        q('.lp-ps__patch--1');

      const patch2 =
        q('.lp-ps__patch--2');

      const patch3 =
        q('.lp-ps__patch--3');

      const patchBars =
        q('.lp-ps__patch-bar');

      const connector1 =
        q('.lp-ps__connector--1');

      const connector2 =
        q('.lp-ps__connector--2');

      const connector3 =
        q('.lp-ps__connector--3');

      const dot1 =
        q('.lp-ps__connector-dot--1');

      const dot2 =
        q('.lp-ps__connector-dot--2');

      const dot3 =
        q('.lp-ps__connector-dot--3');

      const rootCause =
        q('.lp-ps__root-cause');

      const rootCauseIcon =
        q(
          '.lp-ps__root-cause-icon-bg, .lp-ps__root-cause-cross'
        );

      const lines = [
        browserDivider[0],
        connector1[0],
        connector2[0],
        connector3[0],
        ...patchBars
      ].filter(Boolean);

      const lengths = new Map();

      lines.forEach((path) => {
        if (
          typeof path.getTotalLength ===
          'function'
        ) {
          lengths.set(
            path,
            path.getTotalLength()
          );
        }
      });

      const hideLine = (path) => {
        const length =
          lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };

      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });

        gsap.set(browserShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        hideLine(browserDivider[0]);

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(header, {
          opacity: 0,
          x: -6
        });

        gsap.set(product, {
          opacity: 0,
          y: 8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(productCopy, {
          opacity: 0,
          x: 8
        });

        gsap.set(cart, {
          opacity: 0,
          scale: 0.92,
          transformOrigin: 'center center'
        });

        gsap.set(productWarning, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        [
          connector1[0],
          connector2[0],
          connector3[0]
        ].forEach(hideLine);

        gsap.set(
          [
            ...dot1,
            ...dot2,
            ...dot3
          ],
          {
            opacity: 0,
            scale: 0,
            transformOrigin: 'center center'
          }
        );

        gsap.set(
          [
            ...patch1,
            ...patch2,
            ...patch3
          ],
          {
            opacity: 0,
            y: 14,
            scale: 0.95,
            transformOrigin: 'center center'
          }
        );

        patchBars.forEach(hideLine);

        gsap.set(rootCause, {
          opacity: 0,
          y: -12,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(rootCauseIcon, {
          scale: 0,
          transformOrigin: 'center center'
        });
      };

      const showFinalState = () => {
        gsap.set(
          [
            ...browserShell,
            ...browserDots,
            ...header,
            ...product,
            ...productCopy,
            ...cart,
            ...productWarning,
            ...connector1,
            ...connector2,
            ...connector3,
            ...dot1,
            ...dot2,
            ...dot3,
            ...patch1,
            ...patch2,
            ...patch3,
            ...patchBars,
            ...rootCause
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        lines.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        .to(browserShell, {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power3.out'
        })

        .to(
          browserDivider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            ease: 'power2.inOut'
          },
          '-=.18'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            stagger: 0.06,
            ease: 'back.out(1.8)'
          },
          '-=.16'
        )

        .to(
          header,
          {
            opacity: 1,
            x: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          product,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'power2.out'
          }
        )

        .to(
          productCopy,
          {
            opacity: 1,
            x: 0,
            duration: 0.26,
            ease: 'power2.out'
          },
          '-=.15'
        )

        .to(
          cart,
          {
            opacity: 1,
            scale: 1,
            duration: 0.27,
            ease: 'back.out(1.45)'
          },
          '-=.05'
        )

        .to(
          productWarning,
          {
            opacity: 1,
            scale: 1,
            duration: 0.23,
            ease: 'back.out(1.7)'
          },
          '+=.08'
        )

        .to(
          connector1,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.38,
            ease: 'power2.inOut'
          },
          '+=.1'
        )

        .to(
          dot1,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.1'
        )

        .to(
          patch1,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            ease: 'power3.out'
          },
          '-=.04'
        )

        .to(
          patchBars[0],
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.22,
            ease: 'power2.inOut'
          }
        )

        .to(
          connector2,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            ease: 'power2.inOut'
          },
          '+=.05'
        )

        .to(
          dot2,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.09'
        )

        .to(
          patch2,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            ease: 'power3.out'
          },
          '-=.04'
        )

        .to(
          patchBars[1],
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.22,
            ease: 'power2.inOut'
          }
        )

        .to(
          connector3,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.38,
            ease: 'power2.inOut'
          },
          '+=.05'
        )

        .to(
          dot3,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.09'
        )

        .to(
          patch3,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.32,
            ease: 'power3.out'
          },
          '-=.04'
        )

        .to(
          patchBars[2],
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.22,
            ease: 'power2.inOut'
          }
        )

        .to(
          rootCause,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.36,
            ease: 'back.out(1.4)'
          },
          '+=.12'
        )

        .to(
          rootCauseIcon,
          {
            scale: 1,
            duration: 0.2,
            ease: 'back.out(1.8)'
          },
          '-=.2'
        )

        .to(
          productWarning,
          {
            scale: 1.08,
            duration: 0.16,
            ease: 'power1.out'
          },
          '+=.08'
        )

        .to(
          productWarning,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )

        .to(
          rootCause,
          {
            scale: 1.025,
            duration: 0.18,
            ease: 'power1.out'
          },
          '-=.05'
        )

        .to(
          rootCause,
          {
            scale: 1,
            duration: 0.2,
            ease: 'power1.inOut'
          }
        )

        .to({}, {
          duration: 2
        })

        .to(
          [
            ...rootCause,
            ...patch3,
            ...dot3,
            ...connector3,
            ...patch2,
            ...dot2,
            ...connector2,
            ...patch1,
            ...dot1,
            ...connector1,
            ...productWarning,
            ...cart,
            ...productCopy,
            ...product,
            ...header,
            ...browserDots,
            ...browserDivider,
            ...browserShell
          ],
          {
            opacity: 0,
            duration: 0.28,
            ease: 'power1.in'
          }
        )

        .call(() => {
          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyPatchStack = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpPatchStackReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );
      return;
    }

    initPatchStack(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initPatchStack(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyPatchStack(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyPatchStack(root);
        }
      );

      initPatchStack(document);
    }
  );
})();












/* =========================================================
   SVG ANIMATION: Desktop Mobile Gap
   Snippet: lp-problem-desktop-mobile-gap.liquid
   CSS: lp-problem-desktop-mobile-gap.css
   ========================================================= */


   (() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-desktop-mobile-gap]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-desktop-mobile-gap]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };

  const initDesktopMobileGap = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpDesktopMobileGapReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-desktop-mobile-gap__svg'
      );

      if (!svg) return;

      root.dataset.lpDesktopMobileGapReady =
        'true';

      const q = gsap.utils.selector(root);

      const desktop =
        q('.lp-dmg__desktop');

      const desktopShell =
        q('.lp-dmg__desktop-shell');

      const desktopDivider =
        q('.lp-dmg__desktop-divider');

      const desktopDots =
        q('.lp-dmg__desktop-dots path');

      const desktopProduct =
        q('.lp-dmg__desktop-product');

      const desktopCopy =
        q('.lp-dmg__desktop-copy');

      const desktopStand =
        q('.lp-dmg__desktop-stand');

      const desktopSuccess =
        q('.lp-dmg__desktop-success');

      const desktopStatus =
        q('.lp-dmg__desktop-status');

      const bridgeLine =
        q('.lp-dmg__bridge-line');

      const bridgeWarning =
        q('.lp-dmg__bridge-warning');

      const mobile =
        q('.lp-dmg__mobile');

      const mobileShell =
        q('.lp-dmg__mobile-shell');

      const mobileScreen =
        q('.lp-dmg__mobile-screen');

      const mobileSpeaker =
        q('.lp-dmg__mobile-speaker');

      const mobileProduct =
        q('.lp-dmg__mobile-product');

      const mobileLoader =
        q('.lp-dmg__mobile-loader');

      const mobileLoaderActive =
        q('.lp-dmg__mobile-loader-active');

      const mobileWarning =
        q('.lp-dmg__mobile-warning');

      const drawable = [
        desktopDivider[0],
        bridgeLine[0]
      ].filter(Boolean);

      const lengths = new Map();

      drawable.forEach((path) => {
        if (
          typeof path.getTotalLength ===
          'function'
        ) {
          lengths.set(
            path,
            path.getTotalLength()
          );
        }
      });

      const hideLine = (path) => {
        const length = lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };

      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });

        gsap.set(desktopShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        hideLine(desktopDivider[0]);

        gsap.set(desktopDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(
          [
            ...desktopProduct,
            ...desktopCopy,
            ...desktopStand
          ],
          {
            opacity: 0,
            y: 7
          }
        );

        gsap.set(desktopSuccess, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(desktopStatus, {
          opacity: 0,
          y: -7
        });

        hideLine(bridgeLine[0]);

        gsap.set(bridgeWarning, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(mobileShell, {
          opacity: 0,
          scale: 0.94,
          transformOrigin: 'center center'
        });

        gsap.set(
          [
            ...mobileScreen,
            ...mobileSpeaker,
            ...mobileProduct
          ],
          {
            opacity: 0,
            y: 6
          }
        );

        gsap.set(mobileLoader, {
          opacity: 0,
          scale: 0.8,
          transformOrigin: 'center center'
        });

        gsap.set(mobileWarning, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });
      };

      const showFinalState = () => {
        gsap.set(
          [
            ...desktop,
            ...desktopSuccess,
            ...desktopStatus,
            ...bridgeLine,
            ...bridgeWarning,
            ...mobile,
            ...mobileWarning
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1
          }
        );

        drawable.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };

      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }

      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );

      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });

      timeline

        .to(desktopShell, {
          opacity: 1,
          scale: 1,
          duration: 0.38,
          ease: 'power3.out'
        })

        .to(
          desktopDivider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.32,
            ease: 'power2.inOut'
          },
          '-=.15'
        )

        .to(
          desktopDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.16,
            stagger: 0.055,
            ease: 'back.out(1.8)'
          },
          '-=.14'
        )

        .to(
          desktopProduct,
          {
            opacity: 1,
            y: 0,
            duration: 0.26,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          desktopCopy,
          {
            opacity: 1,
            y: 0,
            duration: 0.24,
            ease: 'power2.out'
          },
          '-=.12'
        )

        .to(
          desktopStand,
          {
            opacity: 1,
            y: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '-=.08'
        )

        .to(
          desktopSuccess,
          {
            opacity: 1,
            scale: 1,
            duration: 0.24,
            ease: 'back.out(1.7)'
          },
          '+=.05'
        )

        .to(
          desktopStatus,
          {
            opacity: 1,
            y: 0,
            duration: 0.26,
            ease: 'power2.out'
          },
          '-=.08'
        )

        .to(
          bridgeLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.4,
            ease: 'power2.inOut'
          },
          '+=.1'
        )

        .to(
          bridgeWarning,
          {
            opacity: 1,
            scale: 1,
            duration: 0.2,
            ease: 'back.out(1.8)'
          },
          '-=.12'
        )

        .to(
          mobileShell,
          {
            opacity: 1,
            scale: 1,
            duration: 0.38,
            ease: 'power3.out'
          },
          '+=.05'
        )

        .to(
          [
            ...mobileScreen,
            ...mobileSpeaker
          ],
          {
            opacity: 1,
            y: 0,
            duration: 0.22,
            stagger: 0.04,
            ease: 'power2.out'
          },
          '-=.14'
        )

        .to(
          mobileProduct,
          {
            opacity: 1,
            y: 0,
            duration: 0.26,
            ease: 'power2.out'
          }
        )

        .to(
          mobileLoader,
          {
            opacity: 1,
            scale: 1,
            duration: 0.22,
            ease: 'back.out(1.5)'
          },
          '+=.05'
        )

       

        .to(
          mobileWarning,
          {
            opacity: 1,
            scale: 1,
            duration: 0.24,
            ease: 'back.out(1.7)'
          },
          '-=.15'
        )

        .to(
          mobileWarning,
          {
            scale: 1.08,
            duration: 0.16,
            ease: 'power1.out'
          },
          '+=.06'
        )

        .to(
          mobileWarning,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )

        .to({}, {
          duration: 2
        })

        .to(
          [
            ...mobileWarning,
            ...mobile,
            ...bridgeWarning,
            ...bridgeLine,
            ...desktopStatus,
            ...desktopSuccess,
            ...desktop
          ],
          {
            opacity: 0,
            duration: 0.27,
            ease: 'power1.in'
          }
        )

        .call(() => {
          gsap.set(mobileLoaderActive, {
            rotation: 0
          });

          setInitialState();
        });

      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }

      instances.set(root, {
        timeline,
        observer
      });
    });
  };

  const destroyDesktopMobileGap = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpDesktopMobileGapReady;
    });
  };

  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );

      return;
    }

    initDesktopMobileGap(document);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initDesktopMobileGap(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyDesktopMobileGap(
        event.target
      );
    }
  );

  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyDesktopMobileGap(root);
        }
      );

      initDesktopMobileGap(document);
    }
  );
})();











/* =========================================================
   SVG ANIMATION: Speed App Layer
   Snippet: lp-problem-speed-app-layer.liquid
   CSS: lp-problem-speed-app-layer.css
   ========================================================= */

(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-speed-app-layer]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-speed-app-layer]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };


  const initSpeedAppLayer = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset.lpSpeedAppLayerReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-speed-app-layer__svg'
      );

      if (!svg) return;

      root.dataset.lpSpeedAppLayerReady =
        'true';

      const q = gsap.utils.selector(root);


      /* Browser */

      const browserShell =
        q('.lp-sal__browser-shell');

      const browserDivider =
        q('.lp-sal__browser-divider');

      const browserDots =
        q('.lp-sal__browser-dots path');

      const product =
        q('.lp-sal__product');

      const productCopy =
        q('.lp-sal__product-copy');


      /* Score */

      const score =
        q('.lp-sal__score');

      const scoreNumber =
        q('.lp-sal__score-number');

      const scoreProgress =
        q('.lp-sal__score-progress');


      /* Speed app */

      const speedApp =
        q('.lp-sal__speed-app');

      const speedIcon =
        q('.lp-sal__speed-icon');

      const speedTitle =
        q('.lp-sal__speed-title');

      const speedCopy =
        q('.lp-sal__speed-copy');


      /* Root cause */

      const rootCause =
        q('.lp-sal__root-cause');

      const rootTitle =
        q('.lp-sal__root-title');

      const rootLines =
        q('.lp-sal__root-line');

      const rootLightning =
        q('.lp-sal__root-lightning');

      const rootDot =
        q('.lp-sal__root-dot');


      /* Drawable paths */

      const drawable = [
        browserDivider[0],
        scoreProgress[0],
        ...rootLines
      ].filter(Boolean);

      const lengths = new Map();

      drawable.forEach((path) => {
        if (
          typeof path.getTotalLength ===
          'function'
        ) {
          lengths.set(
            path,
            path.getTotalLength()
          );
        }
      });


      const hideLine = (path) => {
        const length =
          lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };


      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });


        /* Browser */

        gsap.set(browserShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        hideLine(browserDivider[0]);

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(product, {
          opacity: 0,
          y: 8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(productCopy, {
          opacity: 0,
          x: 8
        });


        /* Score */

        gsap.set(score, {
          opacity: 0,
          scale: 0.82,
          transformOrigin: 'center center'
        });

        gsap.set(scoreNumber, {
          opacity: 0,
          y: 5
        });

        hideLine(scoreProgress[0]);


        /* Speed app */

        gsap.set(speedApp, {
          opacity: 0,
          x: -18,
          y: 8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(speedIcon, {
          opacity: 0,
          scale: 0,
          rotation: -20,
          transformOrigin: 'center center'
        });

        gsap.set(speedTitle, {
          opacity: 0,
          x: -7
        });

        gsap.set(speedCopy, {
          opacity: 0,
          x: -7
        });


        /* Root cause */

        gsap.set(rootCause, {
          opacity: 0,
          x: 18,
          y: 8,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(rootTitle, {
          opacity: 0,
          x: 7
        });

        rootLines.forEach(hideLine);

        gsap.set(rootLightning, {
          opacity: 0,
          scale: 0,
          rotation: -8,
          transformOrigin: 'center center'
        });

        gsap.set(rootDot, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });
      };


      const showFinalState = () => {
        gsap.set(
          [
            ...browserShell,
            ...browserDivider,
            ...browserDots,
            ...product,
            ...productCopy,

            ...score,
            ...scoreNumber,
            ...scoreProgress,

            ...speedApp,
            ...speedIcon,
            ...speedTitle,
            ...speedCopy,

            ...rootCause,
            ...rootTitle,
            ...rootLines,
            ...rootLightning,
            ...rootDot
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            rotation: 0
          }
        );

        drawable.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };


      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }


      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );


      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });


      timeline

        /* ------------------
           Store
        ------------------- */

        .to(browserShell, {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power3.out'
        })

        .to(
          browserDivider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.32,
            ease: 'power2.inOut'
          },
          '-=.17'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            stagger: 0.055,
            ease: 'back.out(1.8)'
          },
          '-=.14'
        )

        .to(
          product,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          productCopy,
          {
            opacity: 1,
            x: 0,
            duration: 0.26,
            ease: 'power2.out'
          },
          '-=.14'
        )


        /* ------------------
           Score = 54
        ------------------- */

        .to(
          score,
          {
            opacity: 1,
            scale: 1,
            duration: 0.34,
            ease: 'back.out(1.4)'
          },
          '+=.08'
        )

        .to(
          scoreNumber,
          {
            opacity: 1,
            y: 0,
            duration: 0.2,
            ease: 'power2.out'
          },
          '-=.12'
        )

        .to(
          scoreProgress,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.4,
            ease: 'power2.inOut'
          },
          '-=.06'
        )


        /* ------------------
           Speed app installed
        ------------------- */

        .to(
          speedApp,
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            duration: 0.38,
            ease: 'power3.out'
          },
          '+=.12'
        )

        .to(
          speedIcon,
          {
            opacity: 1,
            scale: 1,
            rotation: 0,
            duration: 0.25,
            ease: 'back.out(1.8)'
          },
          '-=.18'
        )

        .to(
          speedTitle,
          {
            opacity: 1,
            x: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '-=.08'
        )

        .to(
          speedCopy,
          {
            opacity: 1,
            x: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '-=.1'
        )


        /* Small app pulse */

        .to(
          speedIcon,
          {
            scale: 1.12,
            duration: 0.16,
            ease: 'power1.out'
          },
          '+=.08'
        )

        .to(
          speedIcon,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )


        /* ------------------
           Root cause
        ------------------- */

        .to(
          rootCause,
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            duration: 0.38,
            ease: 'power3.out'
          },
          '+=.1'
        )

        .to(
          rootTitle,
          {
            opacity: 1,
            x: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '-=.14'
        )

        .to(
          rootLines,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.25,
            stagger: 0.08,
            ease: 'power2.inOut'
          }
        )

        .to(
          rootLightning,
          {
            opacity: 1,
            scale: 1,
            rotation: 0,
            duration: 0.24,
            ease: 'back.out(1.7)'
          },
          '-=.12'
        )

        .to(
          rootDot,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '-=.08'
        )


        /* ------------------
           Warning pulse
        ------------------- */

        .to(
          rootCause,
          {
            scale: 1.025,
            duration: 0.18,
            ease: 'power1.out'
          },
          '+=.12'
        )

        .to(
          rootCause,
          {
            scale: 1,
            duration: 0.2,
            ease: 'power1.inOut'
          }
        )

        .to(
          rootLightning,
          {
            scale: 1.15,
            duration: 0.16,
            ease: 'power1.out'
          },
          '-=.12'
        )

        .to(
          rootLightning,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )


        /* Hold */

        .to({}, {
          duration: 2
        })


        /* ------------------
           Fade
        ------------------- */

        .to(
          [
            ...rootCause,
            ...speedApp,
            ...score,
            ...productCopy,
            ...product,
            ...browserDots,
            ...browserDivider,
            ...browserShell
          ],
          {
            opacity: 0,
            duration: 0.28,
            ease: 'power1.in'
          }
        )


        /* Reset */

        .call(() => {
          setInitialState();
        });


      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }


      instances.set(root, {
        timeline,
        observer
      });
    });
  };


  const destroySpeedAppLayer = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpSpeedAppLayerReady;
    });
  };


  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );

      return;
    }

    initSpeedAppLayer(document);
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initSpeedAppLayer(
        event.target
      );
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroySpeedAppLayer(
        event.target
      );
    }
  );


  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroySpeedAppLayer(root);
        }
      );

      initSpeedAppLayer(document);
    }
  );
})();



/* =========================================================
   SVG ANIMATION: Perfect Score Mobile Wait
   Snippet: lp-problem-perfect-score-mobile-wait.liquid
   CSS: lp-problem-perfect-score-mobile-wait.css
   ========================================================= */

(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-perfect-score-mobile-wait]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-perfect-score-mobile-wait]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };


  const initPerfectScoreMobileWait = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset
          .lpPerfectScoreMobileWaitReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-perfect-score-mobile-wait__svg'
      );

      if (!svg) return;

      root.dataset
        .lpPerfectScoreMobileWaitReady =
        'true';

      const q = gsap.utils.selector(root);


      /* SCORE */

      const score =
        q('.lp-psmw__score');

      const scoreShell =
        q('.lp-psmw__score-shell');

      const scoreRing =
        q('.lp-psmw__score-ring');

      const scoreNumber =
        q('.lp-psmw__score-number');

      const scoreBadge =
        q('.lp-psmw__score-badge');

      const scoreBadgeDot =
        q('.lp-psmw__score-badge-dot');


      /* CONNECTOR */

      const connectorLine =
        q('.lp-psmw__connector-line');

      const connectorArrow =
        q('.lp-psmw__connector-arrow');

      const connectorDot =
        q('.lp-psmw__connector-dot');


      /* MOBILE */

      const mobileShell =
        q('.lp-psmw__mobile-shell');

      const mobileScreen =
        q('.lp-psmw__mobile-screen');

      const mobileSpeaker =
        q('.lp-psmw__mobile-speaker');

      const mobileProduct =
        q('.lp-psmw__mobile-product');

      const loader =
        q('.lp-psmw__loader');

      const loaderActive =
        q('.lp-psmw__loader-active');

      const waiting =
        q('.lp-psmw__waiting');

      const waitingDot =
        q('.lp-psmw__waiting-dot');


      /* DRAW PATHS */

      const drawable = [
        scoreRing[0],
        connectorLine[0],
        connectorArrow[0]
      ].filter(Boolean);

      const lengths = new Map();

      drawable.forEach((path) => {
        if (
          typeof path.getTotalLength ===
          'function'
        ) {
          lengths.set(
            path,
            path.getTotalLength()
          );
        }
      });


      const hideLine = (path) => {
        const length =
          lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };


      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });


        /* SCORE */

        gsap.set(scoreShell, {
          opacity: 0,
          scale: 0.88,
          transformOrigin: 'center center'
        });

        hideLine(scoreRing[0]);

        gsap.set(scoreNumber, {
          opacity: 0,
          scale: 0.82,
          transformOrigin: 'center center'
        });

        gsap.set(scoreBadge, {
          opacity: 0,
          y: 8,
          scale: 0.94,
          transformOrigin: 'center center'
        });

        gsap.set(scoreBadgeDot, {
          scale: 0,
          transformOrigin: 'center center'
        });


        /* CONNECTOR */

        hideLine(connectorLine[0]);
        hideLine(connectorArrow[0]);

        gsap.set(connectorDot, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });


        /* MOBILE */

        gsap.set(mobileShell, {
          opacity: 0,
          x: 15,
          scale: 0.94,
          transformOrigin: 'center center'
        });

        gsap.set(
          [
            ...mobileScreen,
            ...mobileSpeaker
          ],
          {
            opacity: 0,
            y: 5
          }
        );

        gsap.set(mobileProduct, {
          opacity: 0,
          y: 7
        });

        gsap.set(loader, {
          opacity: 0,
          scale: 0.82,
          transformOrigin: 'center center'
        });

        gsap.set(waiting, {
          opacity: 0,
          y: 7,
          scale: 0.94,
          transformOrigin: 'center center'
        });

        gsap.set(waitingDot, {
          scale: 0,
          transformOrigin: 'center center'
        });

        
      };


      const showFinalState = () => {
        gsap.set(
          [
            ...score,
            ...scoreBadge,
            ...connectorLine,
            ...connectorArrow,
            ...connectorDot,
            ...mobileShell,
            ...mobileScreen,
            ...mobileSpeaker,
            ...mobileProduct,
            ...loader,
            ...waiting
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            rotation: 0
          }
        );

        drawable.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };


      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }


      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );


      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });


      timeline

        /* 01 SCORE SHELL */

        .to(scoreShell, {
          opacity: 1,
          scale: 1,
          duration: 0.36,
          ease: 'back.out(1.35)'
        })


        /* 02 GREEN RING */

        .to(
          scoreRing,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.55,
            ease: 'power2.inOut'
          },
          '-=.08'
        )


        /* 03 SCORE 100 */

        .to(
          scoreNumber,
          {
            opacity: 1,
            scale: 1,
            duration: 0.28,
            ease: 'back.out(1.6)'
          },
          '-=.14'
        )


        /* 04 SCORE BADGE */

        .to(
          scoreBadge,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.28,
            ease: 'power2.out'
          },
          '+=.04'
        )

        .to(
          scoreBadgeDot,
          {
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '-=.12'
        )


        /* 05 SCORE PULSE */

        .to(
          score,
          {
            scale: 1.035,
            transformOrigin: 'center center',
            duration: 0.16,
            ease: 'power1.out'
          },
          '+=.06'
        )

        .to(
          score,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )


        /* 06 CONNECTOR DOT */

        .to(
          connectorDot,
          {
            opacity: 1,
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '+=.08'
        )


        /* 07 CONNECTOR */

        .to(
          connectorLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.34,
            ease: 'power2.inOut'
          },
          '-=.06'
        )

        .to(
          connectorArrow,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '-=.08'
        )


        /* 08 MOBILE */

        .to(
          mobileShell,
          {
            opacity: 1,
            x: 0,
            scale: 1,
            duration: 0.38,
            ease: 'power3.out'
          },
          '+=.06'
        )

        .to(
          [
            ...mobileScreen,
            ...mobileSpeaker
          ],
          {
            opacity: 1,
            y: 0,
            duration: 0.22,
            stagger: 0.05,
            ease: 'power2.out'
          },
          '-=.15'
        )


        /* 09 MOBILE CONTENT */

        .to(
          mobileProduct,
          {
            opacity: 1,
            y: 0,
            duration: 0.27,
            ease: 'power2.out'
          }
        )


        /* 10 LOADER */

        .to(
          loader,
          {
            opacity: 1,
            scale: 1,
            duration: 0.23,
            ease: 'back.out(1.5)'
          },
          '+=.04'
        )


       


        /* 12 STILL WAITING */

        .to(
          waiting,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.35)'
          },
          '-=.18'
        )

        .to(
          waitingDot,
          {
            scale: 1,
            duration: 0.18,
            ease: 'back.out(1.8)'
          },
          '-=.12'
        )


        /* 13 WARNING PULSE */

        .to(
          waiting,
          {
            scale: 1.05,
            duration: 0.16,
            ease: 'power1.out'
          },
          '+=.08'
        )

        .to(
          waiting,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )


        /* 14 ANOTHER LOADER TURN */

       


        /* HOLD */

        .to({}, {
          duration: 2
        })


        /* FADE */

        .to(
          [
            ...waiting,
            ...loader,
            ...mobileProduct,
            ...mobileScreen,
            ...mobileSpeaker,
            ...mobileShell,
            ...connectorArrow,
            ...connectorLine,
            ...connectorDot,
            ...scoreBadge,
            ...score
          ],
          {
            opacity: 0,
            duration: 0.28,
            ease: 'power1.in'
          }
        )


        /* RESET */

        .call(() => {
          setInitialState();
        });


      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }


      instances.set(root, {
        timeline,
        observer
      });
    });
  };


  const destroyPerfectScoreMobileWait = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpPerfectScoreMobileWaitReady;
    });
  };


  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );

      return;
    }

    initPerfectScoreMobileWait(document);
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initPerfectScoreMobileWait(
        event.target
      );
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyPerfectScoreMobileWait(
        event.target
      );
    }
  );


  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyPerfectScoreMobileWait(
            root
          );
        }
      );

      initPerfectScoreMobileWait(
        document
      );
    }
  );
})();


   /* =========================================================
   SVG ANIMATION: Images Fixed Still Slow
   Snippet: lp-problem-images-fixed-still-slow.liquid
   CSS: lp-problem-images-fixed-still-slow.css
   ========================================================= */

(() => {
  const instances = new WeakMap();

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const getRoots = (scope = document) => {
    const roots = [];

    if (
      scope.matches?.(
        '[data-lp-problem-images-fixed-still-slow]'
      )
    ) {
      roots.push(scope);
    }

    scope
      .querySelectorAll?.(
        '[data-lp-problem-images-fixed-still-slow]'
      )
      .forEach((root) => {
        if (!roots.includes(root)) {
          roots.push(root);
        }
      });

    return roots;
  };


  const initImagesFixedStillSlow = (
    scope = document
  ) => {
    if (!window.gsap) return;

    const gsap = window.gsap;

    getRoots(scope).forEach((root) => {
      if (
        root.dataset
          .lpImagesFixedStillSlowReady ===
        'true'
      ) {
        return;
      }

      const svg = root.querySelector(
        '.lp-problem-images-fixed-still-slow__svg'
      );

      if (!svg) return;

      root.dataset
        .lpImagesFixedStillSlowReady =
        'true';

      const q = gsap.utils.selector(root);


      /* BROWSER */

      const browserShell =
        q('.lp-ifss__browser-shell');

      const browserDivider =
        q('.lp-ifss__browser-divider');

      const browserDots =
        q('.lp-ifss__browser-dots path');

      const product =
        q('.lp-ifss__product');

      const productCopy =
        q('.lp-ifss__product-copy');


      /* IMAGES FIXED */

      const imagesFixed =
        q('.lp-ifss__images-fixed');

      const imagesFixedDot =
        q('.lp-ifss__images-fixed-dot');

      const imagesFixedCheck =
        q('.lp-ifss__images-fixed-check');


      /* CONNECTOR */

      const connectorLine =
        q('.lp-ifss__connector-line');

      const connectorArrow =
        q('.lp-ifss__connector-arrow');

      const connectorDot =
        q('.lp-ifss__connector-dot');


      /* SPEED */

      const speedCard =
        q('.lp-ifss__speed-card');

      const speedShell =
        q('.lp-ifss__speed-shell');

      const speedTitle =
        q('.lp-ifss__speed-title');

      const gauge =
        q('.lp-ifss__gauge');

      const gaugeTrack =
        q('.lp-ifss__gauge-track');

      const gaugeNeedle =
        q('.lp-ifss__gauge-needle');

      const gaugeCenter =
        q('.lp-ifss__gauge-center');

      const stillSlow =
        q('.lp-ifss__still-slow');

      const stillSlowDot =
        q('.lp-ifss__still-slow-dot');


      /* DRAWABLE */

      const drawable = [
        browserDivider[0],
        imagesFixedCheck[0],
        connectorLine[0],
        connectorArrow[0],
        gaugeTrack[0]
      ].filter(Boolean);

      const lengths = new Map();

      drawable.forEach((path) => {
        if (
          typeof path.getTotalLength ===
          'function'
        ) {
          lengths.set(
            path,
            path.getTotalLength()
          );
        }
      });


      const hideLine = (path) => {
        const length =
          lengths.get(path);

        if (!length) return;

        gsap.set(path, {
          opacity: 0,
          strokeDasharray: length,
          strokeDashoffset: length
        });
      };


      const setInitialState = () => {
        gsap.set(svg, {
          visibility: 'visible'
        });


        /* Browser */

        gsap.set(browserShell, {
          opacity: 0,
          scale: 0.97,
          transformOrigin: 'center center'
        });

        hideLine(browserDivider[0]);

        gsap.set(browserDots, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(product, {
          opacity: 0,
          y: 7,
          scale: 0.96,
          transformOrigin: 'center center'
        });

        gsap.set(productCopy, {
          opacity: 0,
          x: 8
        });


        /* Images fixed */

        gsap.set(imagesFixed, {
          opacity: 0,
          y: -8,
          scale: 0.94,
          transformOrigin: 'center center'
        });

        gsap.set(imagesFixedDot, {
          scale: 0,
          transformOrigin: 'center center'
        });

        hideLine(imagesFixedCheck[0]);


        /* Connector */

        hideLine(connectorLine[0]);
        hideLine(connectorArrow[0]);

        gsap.set(connectorDot, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });


        /* Speed */

        gsap.set(speedShell, {
          opacity: 0,
          x: 15,
          scale: 0.95,
          transformOrigin: 'center center'
        });

        gsap.set(speedTitle, {
          opacity: 0,
          y: -5
        });

        gsap.set(gauge, {
          opacity: 0,
          scale: 0.82,
          transformOrigin: 'center center'
        });

        hideLine(gaugeTrack[0]);

        gsap.set(gaugeNeedle, {
          opacity: 0,
          rotation: -45,
          transformOrigin: '0% 100%'
        });

        gsap.set(gaugeCenter, {
          opacity: 0,
          scale: 0,
          transformOrigin: 'center center'
        });

        gsap.set(stillSlow, {
          opacity: 0,
          y: 7,
          scale: 0.94,
          transformOrigin: 'center center'
        });

        gsap.set(stillSlowDot, {
          scale: 0,
          transformOrigin: 'center center'
        });
      };


      const showFinalState = () => {
        gsap.set(
          [
            ...browserShell,
            ...browserDivider,
            ...browserDots,
            ...product,
            ...productCopy,
            ...imagesFixed,
            ...connectorLine,
            ...connectorArrow,
            ...connectorDot,
            ...speedCard,
            ...gauge,
            ...stillSlow
          ],
          {
            opacity: 1,
            x: 0,
            y: 0,
            scale: 1,
            rotation: 0
          }
        );

        drawable.forEach((path) => {
          gsap.set(path, {
            strokeDasharray: 'none',
            strokeDashoffset: 0
          });
        });

        gsap.set(svg, {
          visibility: 'visible'
        });

        root.classList.add(
          'is-gsap-ready'
        );
      };


      if (reducedMotion.matches) {
        showFinalState();

        instances.set(root, {
          timeline: null,
          observer: null
        });

        return;
      }


      setInitialState();

      root.classList.add(
        'is-gsap-ready'
      );


      const timeline = gsap.timeline({
        paused: true,
        repeat: -1,
        repeatDelay: 0.8
      });


      timeline

        /* Browser */

        .to(browserShell, {
          opacity: 1,
          scale: 1,
          duration: 0.38,
          ease: 'power3.out'
        })

        .to(
          browserDivider,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.32,
            ease: 'power2.inOut'
          },
          '-=.16'
        )

        .to(
          browserDots,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            stagger: 0.055,
            ease: 'back.out(1.8)'
          },
          '-=.15'
        )

        .to(
          product,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.28,
            ease: 'power2.out'
          },
          '+=.03'
        )

        .to(
          productCopy,
          {
            opacity: 1,
            x: 0,
            duration: 0.25,
            ease: 'power2.out'
          },
          '-=.13'
        )


        /* Images fixed */

        .to(
          imagesFixed,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.35)'
          },
          '+=.07'
        )

        .to(
          imagesFixedDot,
          {
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.12'
        )

        .to(
          imagesFixedCheck,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.22,
            ease: 'power2.inOut'
          },
          '-=.05'
        )


        /* Connector */

        .to(
          connectorDot,
          {
            opacity: 1,
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '+=.09'
        )

        .to(
          connectorLine,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.32,
            ease: 'power2.inOut'
          },
          '-=.05'
        )

        .to(
          connectorArrow,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.2,
            ease: 'power2.out'
          },
          '-=.08'
        )


        /* Speed panel */

        .to(
          speedShell,
          {
            opacity: 1,
            x: 0,
            scale: 1,
            duration: 0.35,
            ease: 'power3.out'
          },
          '+=.05'
        )

        .to(
          speedTitle,
          {
            opacity: 1,
            y: 0,
            duration: 0.22,
            ease: 'power2.out'
          },
          '-=.14'
        )


        /* Gauge */

        .to(
          gauge,
          {
            opacity: 1,
            scale: 1,
            duration: 0.24,
            ease: 'back.out(1.45)'
          },
          '+=.03'
        )

        .to(
          gaugeTrack,
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.35,
            ease: 'power2.inOut'
          },
          '-=.1'
        )

        .to(
          gaugeCenter,
          {
            opacity: 1,
            scale: 1,
            duration: 0.16,
            ease: 'back.out(1.8)'
          },
          '-=.08'
        )

        .to(
          gaugeNeedle,
          {
            opacity: 1,
            rotation: 0,
            duration: 0.42,
            ease: 'power2.out'
          },
          '-=.08'
        )


        /* Needle moves but still poor */

        .to(
          gaugeNeedle,
          {
            rotation: -14,
            duration: 0.3,
            ease: 'power1.inOut'
          },
          '+=.08'
        )

        .to(
          gaugeNeedle,
          {
            rotation: 0,
            duration: 0.3,
            ease: 'power1.inOut'
          }
        )


        /* Still slow */

        .to(
          stillSlow,
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.3,
            ease: 'back.out(1.35)'
          },
          '+=.06'
        )

        .to(
          stillSlowDot,
          {
            scale: 1,
            duration: 0.17,
            ease: 'back.out(1.8)'
          },
          '-=.12'
        )


        /* Warning pulse */

        .to(
          stillSlow,
          {
            scale: 1.055,
            duration: 0.16,
            ease: 'power1.out'
          },
          '+=.08'
        )

        .to(
          stillSlow,
          {
            scale: 1,
            duration: 0.18,
            ease: 'power1.inOut'
          }
        )

        .to(
          connectorDot,
          {
            scale: 1.25,
            duration: 0.15,
            ease: 'power1.out'
          },
          '-=.05'
        )

        .to(
          connectorDot,
          {
            scale: 1,
            duration: 0.17,
            ease: 'power1.inOut'
          }
        )


        /* Hold */

        .to({}, {
          duration: 2
        })


        /* Fade */

        .to(
          [
            ...stillSlow,
            ...gauge,
            ...speedCard,
            ...connectorArrow,
            ...connectorLine,
            ...connectorDot,
            ...imagesFixed,
            ...productCopy,
            ...product,
            ...browserDots,
            ...browserDivider,
            ...browserShell
          ],
          {
            opacity: 0,
            duration: 0.28,
            ease: 'power1.in'
          }
        )


        .call(() => {
          setInitialState();
        });


      let observer = null;

      if (
        'IntersectionObserver' in window
      ) {
        observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  timeline.play();
                } else {
                  timeline.pause();
                }
              });
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(root);
      } else {
        timeline.play();
      }


      instances.set(root, {
        timeline,
        observer
      });
    });
  };


  const destroyImagesFixedStillSlow = (
    scope
  ) => {
    getRoots(scope).forEach((root) => {
      const instance =
        instances.get(root);

      if (!instance) return;

      instance.timeline?.kill();
      instance.observer?.disconnect();

      instances.delete(root);

      delete root.dataset
        .lpImagesFixedStillSlowReady;
    });
  };


  const boot = () => {
    if (!window.gsap) {
      window.setTimeout(
        boot,
        60
      );

      return;
    }

    initImagesFixedStillSlow(document);
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initImagesFixedStillSlow(
        event.target
      );
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyImagesFixedStillSlow(
        event.target
      );
    }
  );


  reducedMotion.addEventListener(
    'change',
    () => {
      getRoots(document).forEach(
        (root) => {
          destroyImagesFixedStillSlow(
            root
          );
        }
      );

      initImagesFixedStillSlow(
        document
      );
    }
  );
})();


   
   /* =========================================================
   SVG ANIMATION: Desktop Mobile Gap
   Snippet: lp-problem-desktop-mobile-gap.liquid
   CSS: lp-problem-desktop-mobile-gap.css
   ========================================================= */
